(function(){
"use strict";

/* ============================================================
   1. CONFIGURATION
   ============================================================ */
var CFG = (window.TEMPO_CFG_OVERRIDE) || {
  base:    "https://www.abristempo.com",
  quoteFR: "https://www.abristempo.com/pages/soumission",
  quoteEN: "https://www.abristempo.com/en/pages/soumission",
  phone:   "1 800 463-8674",
  currency:"$",
  /* Banque de configurations : collez ici l'adresse de votre application
     web Google Apps Script (ou tout autre point de collecte qui accepte
     un POST JSON). Laissée vide, l'application fonctionne normalement,
     elle ne journalise simplement rien. */
  logUrl:  ""
};

var F = function(ft,inch){ return ft + (inch||0)/12; };
function pad2(n){ n = Math.round(n); return (n<10?"0":"")+n; }
var HCODE = {}; HCODE[F(6,6)]="66"; HCODE[F(7,6)]="76"; HCODE[F(8,6)]="86"; HCODE[F(9,6)]="96";

/* ============================================================
   2. CATALOGUE
   sku(w,len,h)  -> code article, identique au SKU Shopify
   door(w,h)     -> handle de la porte Tempo-Clip de bout
   ============================================================ */
var MODELS = {
  simple_reg: {
    id:"simple_reg", geo:{ground:11, bar:8.9167, rise:1.8333, shape:"taper"}, fam:"simple", roof:"gable", arc:4, rise:1.667, paver:"PPS",
    w:[11], L:[4,8,12,16,20,24,28,32,36,40,44], H:[F(6,6),F(7,6),F(8,6)],
    handle:"abri-simple", handleEN:"abri-simple",
    sku:function(w,l,h){ return "A11"+pad2(l)+HCODE[h]; },
    door:function(w,h){ return "porte-tempo-clip-de-bout-simple-x-"+HCODE[h]; },
    nameFR:"Abri simple Pointu 11'", nameEN:"Single Peaked Shelter 11'",
    specFR:"Poteau rond 1¼ po, calibre 17 · arches aux 4 pi",
    specEN:'1¼" round post, 17 gauge · arches every 4 ft'
  },
  simple_hd: {
    id:"simple_hd", geo:{ground:11, bar:8.9167, rise:1.8333, shape:"taper"}, fam:"simple", roof:"gable", arc:4, rise:1.667, paver:"PPPLUS",
    w:[11], L:[4,8,12,16,20,24,28,32,36,40,44], H:[F(6,6),F(7,6),F(8,6)],
    handle:"abri-simple",
    sku:function(w,l,h){ return "AHD11"+pad2(l)+HCODE[h]; },
    door:function(w,h){ return "porte-tempo-clip-de-bout-simple-x-"+HCODE[h]; },
    nameFR:"Abri simple Pointu 11' HD", nameEN:"Single Peaked Shelter 11' HD",
    specFR:"Poteau mini-ovale 1¼ x 1¾ po, calibre 16 · arches aux 4 pi",
    specEN:'1¼ x 1¾" mini-oval post, 16 gauge · arches every 4 ft'
  },
  ta12: {
    id:"ta12", geo:{ground:12, bar:8.9167, rise:1.0833, shape:"ta"}, fam:"simple", roof:"gable", arc:4, rise:1.5, paver:"PPTAR", hero:true,
    w:[12], L:[4,8,12,16,20,24,28,32,36,40,44], H:[7,8,9],
    handle:"abri-simple",
    sku:function(w,l,h){ return "A12"+pad2(l)+String(Math.round(h)); },
    door:function(w,h){ return "porte-tempo-clip-de-bout-12-x-"+Math.round(h); },
    nameFR:"Abri simple 12' TA", nameEN:"Single Shelter 12' TA",
    specFR:"Poteau 1 5/8 x 2¾ po, calibre 16 — le même que nos abris doubles · murs droits, 12 pi de large",
    specEN:'1 5/8 x 2¾" post, 16 gauge — the same as our double shelters · straight walls, 12 ft wide'
  },
  monopente: {
    id:"monopente", geo:{ground:10.5, bar:8.9167, rise:2.8333, shape:"shed"}, fam:"simple", roof:"shed", arc:4, rise:3.0, paver:"PPPLUS",
    w:[10.5], L:[4,8,12,16,20,24,28,32,36,40,44,48,52,56,60], H:[7,8,9],
    handle:"abri-monopente",
    sku:function(w,l,h){ return "MONO106"+pad2(l)+String(Math.round(h)); },
    door:function(w,h){ return "porte-tempo-clip-de-bout-monopente-x-"+Math.round(h)+"-gauche"; },
    nameFR:"Abri monopente", nameEN:"Mono-slope Shelter",
    specFR:"Toit à pente unique · s'installe contre un mur, la neige tombe d'un seul côté",
    specEN:"Single-slope roof · installs against a wall, snow falls on one side only"
  },
  double_pointu: {
    id:"double_pointu", geo:{ground:null, bar:null, rise:2.2708, shape:"straight"}, fam:"double", roof:"gable", arc:4, rise:null, paver:"PPTAR",
    w:[16,18,20], L:[4,8,12,16,20,24,28,32,36,40,44], H:[F(6,6),F(7,6),F(8,6)],
    handle:"abri-double-pointu",
    sku:function(w,l,h){ return "A"+pad2(w)+pad2(l)+HCODE[h]; },
    door:function(w,h){ return "porte-tempo-clip-de-bout-double-"+Math.round(w)+"-x-"+HCODE[h]; },
    nameFR:"Abri double Pointu", nameEN:"Double Peaked Shelter",
    specFR:"Poteau 1 5/8 x 2¾ po, calibre 16 · arches aux 4 pi · le plus populaire",
    specEN:'1 5/8 x 2¾" post, 16 gauge · arches every 4 ft · the most popular'
  },
  double_rond: {
    id:"double_rond", geo:{ground:null, bar:null, rise:2.4, shape:"round"}, fam:"double", roof:"round", arc:5, rise:2.4, paver:"PPTAR", welded:true,
    w:[18,20], L:[15,20,25,30,35], H:[7,F(7,10)],
    handle:"abri-double-rond",
    sku:function(w,l,h){ return "AR"+pad2(w)+pad2(l)+(h>7.5?"710":"7"); },
    door:function(){ return null; },
    nameFR:"Abri double Rond", nameEN:"Double Round Shelter",
    specFR:"Arches aux 5 pi · toile soudée 200 g/m², étanche · belle ouverture et grande hauteur au centre",
    specEN:"Arches every 5 ft · welded 200 g/m² cover, watertight · great opening and centre height"
  },
  rangement_8: {
    id:"rangement_8", geo:{ground:5, bar:4.2, rise:1.4167, shape:"taper"}, fam:"rangement", roof:"gable", arc:4, rise:1.417, paver:"PPS",
    w:[5], L:[8], H:[F(6,1)], handle:"abri-rangement-5x8",
    sku:function(){ return "A050861"; }, door:function(){ return null; },
    nameFR:"Abri de rangement 5' x 8'", nameEN:"Storage Shelter 5' x 8'",
    specFR:"Toit pointu · autonome, en espace dégagé · aucune fenêtre",
    specEN:"Peaked roof · free-standing, open space · no windows"
  },
  rangement_12: {
    id:"rangement_12", geo:{ground:5, bar:4.2, rise:1.4167, shape:"taper"}, fam:"rangement", roof:"gable", arc:4, rise:1.417, paver:"PPS",
    w:[5], L:[12], H:[F(6,1)], handle:"abri-rangement-5x12",
    sku:function(){ return "A051261"; }, door:function(){ return null; },
    nameFR:"Abri de rangement 5' x 12'", nameEN:"Storage Shelter 5' x 12'",
    specFR:"Toit pointu · autonome, en espace dégagé · aucune fenêtre",
    specEN:"Peaked roof · free-standing, open space · no windows"
  },
  mini_mono_8: {
    id:"mini_mono_8", geo:{ground:5, bar:4.4, rise:1.2, shape:"shed"}, fam:"rangement", roof:"shed", arc:4, rise:1.2, paver:"PPS",
    w:[5], L:[8], H:[F(6,3)], handle:"abri-mini-monopente-5x8",
    sku:function(){ return "MONO050863"; }, door:function(){ return null; },
    nameFR:"Abri mini-monopente 5' x 8'", nameEN:"Mini Mono-slope Shelter 5' x 8'",
    specFR:"Pente unique · s'appuie contre un mur ou un cabanon · aucune fenêtre",
    specEN:"Single slope · leans against a wall or shed · no windows"
  },
  mini_mono_12: {
    id:"mini_mono_12", geo:{ground:5, bar:4.4, rise:1.2, shape:"shed"}, fam:"rangement", roof:"shed", arc:4, rise:1.2, paver:"PPS",
    w:[5], L:[12], H:[F(6,3)], handle:"abri-mini-monopente-5x12",
    sku:function(){ return "MONO051263"; }, door:function(){ return null; },
    nameFR:"Abri mini-monopente 5' x 12'", nameEN:"Mini Mono-slope Shelter 5' x 12'",
    specFR:"Pente unique · s'appuie contre un mur ou un cabanon · aucune fenêtre",
    specEN:"Single slope · leans against a wall or shed · no windows"
  },
  utilitaire: {
    id:"utilitaire", geo:{ground:8, bar:6.9, rise:1.4167, shape:"taper", fillet:0.55}, fam:"rangement", roof:"gable", arc:5, rise:1.417, paver:"PPS",
    w:[8], L:[10], H:[F(6,4)], handle:"abri-utilitaire-08x10",
    sku:function(){ return "A0810B"; }, door:function(){ return null; },
    nameFR:"Abri utilitaire 8' x 10'", nameEN:"Utility Shelter 8' x 10'",
    specFR:"Le plus grand des abris de rangement · motoneige, VTT, gros équipement · aucune fenêtre",
    specEN:"The largest storage shelter · snowmobile, ATV, large equipment · no windows"
  }
};

function riseOf(m,w){ return (m.geo && m.geo.rise) || 2; }
/* Largeur au sol et à la barre de porte, en pieds.
   Relevé sur les fiches « MESURES ABRIS POUR TOILES » de Tempo :
   un simple 11' fait 11 pi au sol mais 8'11" à la barre de porte —
   le 12' TA monte droit, c'est là son avantage d'espace utile. */
function widths(m,w){
  var g = m.geo || {};
  return { ground: g.ground || w, bar: g.bar || w };
}

/* ============================================================
   3. ACCESSOIRES — id de variante Shopify réel, pour le panier
   ============================================================ */
var ACC = {
  PER2:     { id:44509906829356, sku:"PER2", price:49.95, handle:"ensemble-de-2-ancrages-permanents", pack:2,
              fr:"Ensemble de 2 ancrages permanents", en:"Set of 2 permanent anchors",
              frD:"On perce une fois, l'ancrage reste et se réutilise chaque année.",
              enD:"Drilled once, the anchor stays and is reused every year." },
  PER6:     { id:44509906894892, sku:"PER6", price:149.95, handle:"ensemble-de-6-ancrages-permanents", pack:6,
              fr:"Ensemble de 6 ancrages permanents", en:"Set of 6 permanent anchors",
              frD:"On perce une fois, l'ancrage reste et se réutilise chaque année. L'été, la vis est à fleur de surface — on ne la voit plus.",
              enD:"Drilled once, the anchor stays and is reused every year. In summer the screw sits flush — you don't see it." },
  ANCBAS2:  { id:44509903126572, sku:"ANCBAS2", price:35.00, handle:"ensemble-de-2-ancrages-a-bascule", pack:2,
              fr:"Ensemble de 2 ancrages à bascule", en:"Set of 2 toggle anchors",
              frD:"Ils se déploient sous la surface et tiennent 1000 lb chacun. Tige de plantage incluse (une par 8 ancrages).",
              enD:"They deploy below the surface and hold 1000 lb each. Driving rod included (one per 8 anchors)." },
  CAB2:     { id:44509904502828, sku:"CAB2", price:24.99, handle:"ensemble-de-2-cables-guide-avec-45-de-cordes", pack:2,
              fr:"Ensemble de 2 câbles-guides (45' de corde)", en:"Set of 2 guy cables (45 ft of rope)",
              frD:"Obligatoires avec les ancrages à bascule.",
              enD:"Mandatory with toggle anchors." },
  LUM:      { id:44509905158188, sku:"LUM", price:49.99, handle:"lumieres-led-pour-abri-tempo",
              fr:"Lumières DEL pour abri Tempo", en:"Tempo LED shelter lights",
              frD:"Une entrée éclairée tout l'hiver, sans fil à tirer chaque soir. Éclairage seulement — ne jamais suspendre de charge à la structure.",
              enD:"A lit driveway all winter, with no cord to run every evening. Lighting only — never hang loads from the structure." },
  ANCBAS4:  { id:44509903159340, sku:"ANCBAS4", price:70.00, handle:"ensemble-de-4-ancrages-a-bascule", pack:4,
              fr:"Ensemble de 4 ancrages à bascule", en:"Set of 4 toggle anchors",
              frD:"Ils se déploient sous la surface et tiennent 1000 lb chacun. C'est ce qui garde l'abri en place quand le vent pousse tout l'hiver. Tige de plantage incluse (une par 8 ancrages).",
              enD:"They deploy below the surface and hold 1000 lb each. This is what keeps the shelter in place when the wind pushes all winter. Driving rod included (one per 8 anchors)." },
  PER4:     { id:44509906862124, sku:"PER4", price:99.95, handle:"ensemble-de-4-ancrages-permanents", pack:4,
              fr:"Ensemble de 4 ancrages permanents", en:"Set of 4 permanent anchors",
              frD:"On perce une fois, l'ancrage reste et se réutilise chaque année. L'été, la vis est à fleur de surface — on ne la voit plus.",
              enD:"Drilled once, the anchor stays and is reused every year. In summer the screw sits flush — you don't see it." },
  CAB4:     { id:44509904535596, sku:"CAB4", price:44.99, handle:"ensemble-de-4-cables-guide-avec-90-de-cordes", pack:4,
              fr:"Ensemble de 4 câbles-guides (90' de corde)", en:"Set of 4 guy cables (90 ft of rope)",
              frD:"Obligatoires avec les ancrages à bascule. C'est la pièce la plus souvent oubliée à l'achat.",
              enD:"Mandatory with toggle anchors. This is the most frequently forgotten part at purchase." },
  PPS:      { id:44509907091500, sku:"PPS", price:1.75, handle:"protecteurs-de-pave-simple-1", unit:true,
              fr:"Protecteurs de pavé — rond 1¼ po", en:'Paver protectors — 1¼" round',
              frD:"Un par patte d'arche. Ils répartissent la charge et empêchent le poteau de fendre votre pavé.",
              enD:"One per arch leg. They spread the load and stop the post from cracking your pavers." },
  PPPLUS:   { id:44522853433388, sku:"PPPLUS", price:2.00, handle:"protecteurs-de-pave-mini-ovales", unit:true,
              fr:"Protecteurs de pavé — mini-ovale", en:"Paver protectors — mini-oval",
              frD:"Un par patte d'arche. Ils répartissent la charge et empêchent le poteau de fendre votre pavé.",
              enD:"One per arch leg. They spread the load and stop the post from cracking your pavers." },
  PPTAR:    { id:44509907124268, sku:"PPTAR", price:2.25, handle:"protecteurs-de-pave-pour-tar", unit:true,
              fr:"Protecteurs de pavé — TAR", en:"Paver protectors — TAR",
              frD:"Un par patte d'arche. Ils répartissent la charge et empêchent le poteau de fendre votre pavé.",
              enD:"One per arch leg. They spread the load and stop the post from cracking your pavers." },
  SANGL:    { id:44509908729900, sku:"SANGL", price:1.50, handle:"sangles-dattaches", unit:true,
              fr:"Sangles d'attache", en:"Fastening straps",
              frD:"Elles relient la structure à l'ancrage permanent posé au sol. Sans elles, l'ancrage ne sert à rien.",
              enD:"They connect the structure to the permanent anchor in the ground. Without them, the anchor is useless." },
  MECHEPLUS:{ id:44509905256492, sku:"MECHEPLUS", price:34.99, handle:"meche-de-perceuse-sds-plus-22-mm-x-400-mm-7-8-pouces-x-15-3-4-pouces",
              fr:"Mèche SDS-PLUS 22 mm x 400 mm", en:"SDS-PLUS bit 22 mm x 400 mm",
              frD:"Pour percer vos ancrages permanents, avec une perceuse à percussion. Achat de la première année seulement.",
              enD:"To drill your permanent anchors, with a hammer drill. First-year purchase only." },
  GRAISSE:  { id:44509905059884, sku:"GRAISSE", price:2.99, handle:"lubrifiant-a-base-de-graisse-de-silicone-30g",
              fr:"Lubrifiant à la graisse de silicone 30 g", en:"Silicone grease lubricant 30 g",
              frD:"Sur le filet des ancrages permanents. Ça évite que la vis d'été se grippe et devienne impossible à sortir au printemps.",
              enD:"On the permanent anchor threads. Stops the summer screw from seizing and becoming impossible to remove in spring." },
  RATP:     { id:44509908664364, sku:"RATP", price:64.99, handle:"rateau-a-neige-4-6-m-15",
              fr:"Râteau à neige 15 pi", en:"Snow rake 15 ft",
              frD:"Le déneigement du toit est votre responsabilité, et il se fait de l'extérieur. Un râteau, c'est ce qui évite l'affaissement.",
              enD:"Clearing the roof is your responsibility, and it's done from outside. A rake is what prevents collapse." },
  BANDU:    { id:44509903290412, sku:"BANDU", price:34.50, handle:"bande-anti-vent-universelle",
              fr:"Bande anti-vent universelle", en:"Universal wind band",
              frD:"Elle plaque la toile contre la structure et réduit le battement. Recommandée sur un terrain exposé.",
              enD:"It presses the cover against the structure and reduces flapping. Recommended on an exposed lot." },
  CORD150:  { id:44509904601132, sku:"CORD150", price:11.45, handle:"paquets-de-corde-150-x-3-16",
              fr:"Paquet de corde 150 pi x 3/16 po", en:"150 ft x 3/16\" rope pack",
              frD:"Pour attacher l'abri à ses ancrages, quel que soit le type. La corde s'use et se coupe : mieux vaut en avoir d'avance.",
              enD:"To tie the shelter to its anchors, whatever the type. Rope wears and gets cut: better to have some on hand." },
  SANGLETEMPO:{ id:44509908762668, sku:"SANGLETEMPO", price:10.99, handle:"sangle-de-fixation-rouge-de-16-avec-boucle-a-came-pour-abri-tempo",
              fr:"Sangle de fixation 16 pi à boucle à came", en:"16 ft cam-buckle fastening strap",
              frD:"Pour serrer la toile et sécuriser l'ensemble. Toujours utile d'en avoir une de plus.",
              enD:"To tighten the cover and secure everything. Always useful to have a spare." }
};

/* Prix connus des portes Tempo-Clip de bout (repli si la boutique
   n'est pas jointe; le prix réel est relu en direct sur le site). */
var DOOR_PRICE = {
  "porte-tempo-clip-de-bout-simple-x-66":109.00,
  "porte-tempo-clip-de-bout-simple-x-76":130.00,
  "porte-tempo-clip-de-bout-simple-x-86":163.00,
  "porte-tempo-clip-de-bout-12-x-7":132.00,
  "porte-tempo-clip-de-bout-12-x-8":155.00,
  "porte-tempo-clip-de-bout-double-16-x-66":142.00,
  "porte-tempo-clip-de-bout-double-18-x-66":142.00,
  "porte-tempo-clip-de-bout-double-18-x-76":164.00,
  "porte-tempo-clip-de-bout-double-20-x-66":142.00,
  "porte-tempo-clip-de-bout-double-16-x-86":219.00,
  "porte-tempo-clip-de-bout-double-18-x-86":219.00
};

/* ============================================================
   3b. GABARITS DE VÉHICULES (hauteur x largeur x longueur, pieds)
   Voiture et VUS = données Tempo. Les autres = gabarits
   représentatifs des modèles les plus vendus au Québec.
   ============================================================ */
var VEH = {
  voiture:      { h:F(4,8),  w:F(5,11), l:F(15,2) },
  vus:          { h:F(5,10), w:F(6,6),  l:16      },
  camionnette:  { h:F(6,4),  w:F(6,8),  l:F(19,8) },
  fourgonnette: { h:F(5,9),  w:F(6,6),  l:17      },
  fourgon_haut: { h:F(8,6),  w:F(6,9),  l:20      }
};
var ROOF_ADD = { rien:0, barres:0.25, coffre:F(1,2), boite:F(1,6) };

/* ============================================================
   4. RÈGLES D'ANCRAGE
   ============================================================ */
var SOILS = {
  asphalte: { anchor:"cavalier", paver:false },
  beton:    { anchor:"permanent", paver:false },
  pave:     { anchor:"permanent", paver:true  },
  gazon:    { anchor:"bascule",   paver:false },
  gravier:  { anchor:"bascule",   paver:false }
};
function anchorCount(model,len){
  if(model.roof==="round") return 2*(len/model.arc + 1);
  return 2*(Math.ceil((len-2)/10) + 1);
}
function paverCount(model,len){ return 2*(Math.round(len/model.arc) + 1); }
function toPack(n,size){ return Math.ceil(n/size)*size; }

/* ============================================================
   5. FORMATAGE
   ============================================================ */
function ftIn(v){
  var f = Math.floor(v + 1e-6), i = Math.round((v - f)*12);
  if(i===12){ f++; i=0; }
  return i ? f+"'"+i+'"' : f+"'";
}
function metric(v){ return (v*0.3048).toFixed(2).replace(/\.?0+$/,"")+" m"; }
function money(v,lang){
  if(v===null||v===undefined) return "—";
  var s = v.toFixed(2).replace(".", lang==="en"?".":",");
  s = s.replace(/\B(?=(\d{3})+(?!\d))/g, lang==="en"?",":" ");
  return lang==="en" ? "$"+s : s+" $";
}

window.TEMPO_DATA = {
  CFG:CFG, MODELS:MODELS, ACC:ACC, DOOR_PRICE:DOOR_PRICE, SOILS:SOILS,
  VEH:VEH, ROOF_ADD:ROOF_ADD,
  riseOf:riseOf, widths:widths, anchorCount:anchorCount, paverCount:paverCount, toPack:toPack,
  ftIn:ftIn, metric:metric, money:money, F:F, HCODE:HCODE
};
})();
/* Table de prix de référence (262 SKU, relevés sur abristempo.com).
   Sert de repli : sur la boutique, les prix et la disponibilité sont
   relus en direct dans /products/<handle>.js. */
window.TEMPO_PRICES = {"A050861":210.0,"A051261":260.0,"A0810B":250.0,"A110466":349.0,"A110476":474.0,"A110486":749.0,"A110866":424.0,"A110876":599.0,"A110886":874.0,"A111266":474.0,"A111276":724.0,"A111286":999.0,"A111666":549.0,"A111676":849.0,"A111686":1099.0,"A112066":599.0,"A112076":949.0,"A112086":1224.0,"A112466":749.0,"A112476":1074.0,"A112486":1349.0,"A112866":899.0,"A112876":1199.0,"A112886":1474.0,"A113266":1049.0,"A113276":1324.0,"A113286":1599.0,"A113666":1199.0,"A113676":1449.0,"A113686":1699.0,"A114066":1349.0,"A114076":1549.0,"A114086":1824.0,"A114466":1524.0,"A114476":1749.0,"A114486":1999.0,"A12047":599.0,"A12048":874.0,"A12049":949.0,"A12087":774.0,"A12088":1049.0,"A12089":1149.0,"A12127":949.0,"A12128":1224.0,"A12129":1324.0,"A12167":1149.0,"A12168":1399.0,"A12169":1499.0,"A12207":1199.0,"A12208":1599.0,"A12209":1674.0,"A12247":1499.0,"A12248":1774.0,"A12249":1849.0,"A12287":1674.0,"A12288":1949.0,"A12289":2049.0,"A12327":1849.0,"A12328":2149.0,"A12329":2199.0,"A12367":2049.0,"A12368":2299.0,"A12369":2399.0,"A12407":2199.0,"A12408":2499.0,"A12409":2599.0,"A12447":2449.0,"A12448":2749.0,"A12449":2799.0,"A160466":724.0,"A160476":849.0,"A160486":1074.0,"A160866":949.0,"A160876":1099.0,"A160886":1374.0,"A161266":1149.0,"A161276":1374.0,"A161286":1674.0,"A161666":1249.0,"A161676":1649.0,"A161686":1974.0,"A162066":1324.0,"A162076":1699.0,"A162086":2299.0,"A162466":1674.0,"A162476":2049.0,"A162486":2599.0,"A162866":2149.0,"A162876":2549.0,"A162886":2899.0,"A163266":2399.0,"A163276":2799.0,"A163286":3199.0,"A163666":2649.0,"A163676":3049.0,"A163686":3499.0,"A164066":2899.0,"A164076":3249.0,"A164086":3799.0,"A164466":3299.0,"A164476":3699.0,"A164486":4199.0,"A180466":849.0,"A180476":949.0,"A180486":1199.0,"A180866":1074.0,"A180876":1224.0,"A180886":1499.0,"A181266":1249.0,"A181276":1499.0,"A181286":1799.0,"A181666":1374.0,"A181676":1774.0,"A181686":2099.0,"A182066":1449.0,"A182076":1824.0,"A182086":2399.0,"A182466":1799.0,"A182476":2199.0,"A182486":2699.0,"A182866":2299.0,"A182876":2649.0,"A182886":2999.0,"A183266":2499.0,"A183276":2899.0,"A183286":3299.0,"A183666":2749.0,"A183676":3149.0,"A183686":3599.0,"A184066":2999.0,"A184076":3399.0,"A184086":3899.0,"A184466":3399.0,"A184476":3799.0,"A184486":4299.0,"A200466":949.0,"A200476":1074.0,"A200486":1324.0,"A200866":1199.0,"A200876":1349.0,"A200886":1624.0,"A201266":1374.0,"A201276":1624.0,"A201286":1924.0,"A201666":1499.0,"A201676":1899.0,"A201686":2199.0,"A202066":1549.0,"A202076":1949.0,"A202086":2499.0,"A202466":1924.0,"A202476":2299.0,"A202486":2799.0,"A202866":2399.0,"A202876":2799.0,"A202886":3099.0,"A203266":2649.0,"A203276":3049.0,"A203286":3399.0,"A203666":2899.0,"A203676":3249.0,"A203686":3699.0,"A204066":3099.0,"A204076":3499.0,"A204086":3999.0,"A204466":3549.0,"A204476":3949.0,"A204486":4449.0,"AHD110466":474.0,"AHD110476":599.0,"AHD110486":874.0,"AHD110866":549.0,"AHD110876":724.0,"AHD110886":999.0,"AHD111266":599.0,"AHD111276":849.0,"AHD111286":1099.0,"AHD111666":649.0,"AHD111676":949.0,"AHD111686":1224.0,"AHD112066":699.0,"AHD112076":1074.0,"AHD112086":1349.0,"AHD112466":899.0,"AHD112476":1249.0,"AHD112486":1524.0,"AHD112866":1074.0,"AHD112876":1449.0,"AHD112886":1699.0,"AHD113266":1249.0,"AHD113276":1624.0,"AHD113286":1899.0,"AHD113666":1449.0,"AHD113676":1799.0,"AHD113686":2049.0,"AHD114066":1624.0,"AHD114076":1974.0,"AHD114086":2249.0,"AHD114466":1849.0,"AHD114476":2199.0,"AHD114486":2499.0,"AR1815710":1149.0,"AR18207":1099.0,"AR1820710":1199.0,"AR18257":1499.0,"AR1825710":1599.0,"AR1830710":1899.0,"AR1835710":2199.0,"AR2015710":1249.0,"AR20207":1199.0,"AR2020710":1299.0,"AR20257":1599.0,"AR2025710":1699.0,"AR2030710":1999.0,"AR2035710":2299.0,"BROCHE":5.25,"FLJ120":135.0,"FLJ48":99.0,"FLJTAR120":175.0,"FLJTAR48":125.0,"FLTAR120":145.0,"FLTAR72":90.0,"KITSD4":4.5,"MONO050863":210.0,"MONO051263":260.0,"MONO106047":874.0,"MONO106048":1099.0,"MONO106049":1249.0,"MONO106087":924.0,"MONO106088":1149.0,"MONO106089":1299.0,"MONO106127":974.0,"MONO106128":1199.0,"MONO106129":1349.0,"MONO106167":1024.0,"MONO106168":1274.0,"MONO106169":1424.0,"MONO106207":1074.0,"MONO106208":1324.0,"MONO106209":1474.0,"MONO106247":1249.0,"MONO106248":1499.0,"MONO106249":1649.0,"MONO106287":1449.0,"MONO106288":1674.0,"MONO106289":1824.0,"MONO106327":1624.0,"MONO106328":1849.0,"MONO106329":1999.0,"MONO106367":1799.0,"MONO106368":2049.0,"MONO106369":2199.0,"MONO106407":1974.0,"MONO106408":2199.0,"MONO106409":2349.0,"MONO106447":2349.0,"MONO106448":2599.0,"MONO106449":2749.0,"MONO106487":2699.0,"MONO106488":2949.0,"MONO106489":3099.0,"MONO106527":3049.0,"MONO106528":3299.0,"MONO106529":3449.0,"MONO106567":3399.0,"MONO106568":3649.0,"MONO106569":3799.0,"MONO106607":3799.0,"MONO106608":3999.0,"MONO106609":4149.0,"PC5":126.0,"PEZ":96.0,"PEZ76":109.0,"PEZTARA":16.0,"PVC1166":109.0,"PVC127":132.0,"PVC128":155.0,"PVC1676":164.0,"PVC1686":197.0,"PVC2076":164.0,"PVC2086":197.0,"PVCMONO7G":131.0,"PVCMONO8G":150.0,"PVCMONO9G":185.0,"RAIL":15.5};

(function(){
"use strict";
var D = window.TEMPO_DATA, F = D.F;

/* ============================================================
   COORDONNÉES — affichées sur le bon de commande imprimable
   ============================================================ */
D.CFG.company  = "Abris Tempo — Les Industries Iverco inc.";
D.CFG.address  = "3265, rue Jules-Brillant, Laval (Québec)";
D.CFG.tel      = "450 625-1931";
D.CFG.web      = "abristempo.com";
D.CFG.email    = "tempo@abristempo.com";

/* ============================================================
   GAMME « BON · MEILLEUR · LE TOP » — abris simples
   L'ordre du tableau est l'ordre d'affichage.
   ============================================================ */
D.TIERS = [
  { id:"simple_reg", key:"bon",
    labFR:"Bon", labEN:"Good",
    tagFR:"L'essentiel, au meilleur prix", tagEN:"The essentials, best price",
    proFR:["Poteau rond 1¼ po, calibre 17 galvanisé à 280 g/m² de zinc — le double de la norme de l'industrie.",
           "Même toile, mêmes dimensions et même garantie que le HD : c'est l'épaisseur du poteau qui change.",
           "Le choix logique pour une entrée abritée, entourée de maisons ou d'arbres."],
    proEN:["1¼\" round post, 17 gauge, galvanized at 280 g/m² of zinc — double the industry standard.",
           "Same cover, same sizes and same warranty as the HD: only the post thickness changes.",
           "The logical choice for a sheltered driveway, surrounded by houses or trees."] },
  { id:"simple_hd", key:"meilleur", recommended:true,
    labFR:"Meilleur", labEN:"Better",
    tagFR:"Le meilleur rapport qualité-prix", tagEN:"Best value for money",
    proFR:["Poteau mini-ovale 1¼ x 1¾ po, calibre 16 : la paroi est plus épaisse et le profil ovale résiste mieux au fléchissement.",
           "C'est la différence qui compte quand le vent pousse tout l'hiver et que la neige s'accumule sur le toit.",
           "Un abri qui reste droit et se remonte sans peine, saison après saison : c'est là que l'écart de prix se rembourse."],
    proEN:["1¼ x 1¾\" mini-oval post, 16 gauge: thicker wall and an oval profile that resists bending far better.",
           "That's the difference that counts when wind pushes all winter and snow builds up on the roof.",
           "A shelter that stays true and goes back up without a fight, season after season: that's where the price difference pays for itself."] },
  { id:"ta12", key:"top",
    labFR:"Le top", labEN:"Top",
    tagFR:"Le plus d'espace, notre meilleure structure", tagEN:"The most space, our strongest structure",
    proFR:["Poteau 1 5/8 x 2¾ po, calibre 16 — exactement celui de nos abris doubles. Aucun autre abri simple sur le marché n'a ça.",
           "Murs droits et 12 pi de large : on circule autour du véhicule et les portières s'ouvrent au complet, même avec un VUS.",
           "Hauteur libre de 7 pi de base, jusqu'à 9 pi — pour une camionnette, un support à vélos ou un coffre de toit."],
    proEN:["1 5/8 x 2¾\" post, 16 gauge — exactly the one from our double shelters. No other single shelter on the market has this.",
           "Straight walls and 12 ft wide: you walk around the vehicle and doors open fully, even with an SUV.",
           "7 ft clearance as standard, up to 9 ft — for a pickup, a bike rack or a roof box."] }
];

/* ============================================================
   PORTE DE CÔTÉ
   Le bon article dépend du profil de poteau et de la hauteur.
   ============================================================ */
D.SIDEDOOR = {
  /* Deux critères, et deux seulement : la famille de poteau et la hauteur
     libre, seuil à 7'6". Le kit d'attachement est COMPRIS dans les versions
     « 76 » — il n'y a plus de pièce complémentaire à ajouter au panier. */
  PEZ:      { sku:"PEZ",      id:44509906960428, price:96.00,  handle:"porte-de-cote-tempo-clip-simple",
              fr:"Porte de côté Tempo-Clip — abri simple, jusqu'à 7'6\"",
              en:"Tempo-Clip side door — single shelter, up to 7'6\"" },
  PEZ76:    { sku:"PEZ76",    id:46000355934252, price:109.00, handle:"porte-de-cote-tempo-clip-simple-7-6-et-plus",
              fr:"Porte de côté Tempo-Clip — abri simple 7'6\" et plus (kit d'attachement inclus)",
              en:"Tempo-Clip side door — single shelter 7'6\" and up (attachment kit included)" },
  PEZTAR:   { sku:"PEZTAR",   id:46010491535404, price:108.00, handle:"porte-de-cote-tempo-clip-tar",
              fr:"Porte de côté Tempo-Clip — abri double et 12' TA, jusqu'à 7'6\"",
              en:"Tempo-Clip side door — double and 12' TA shelters, up to 7'6\"" },
  PEZTAR76: { sku:"PEZTAR76", id:46010491502636, price:124.00, handle:"porte-de-cote-tempo-clip-tar-7-6-et-plus",
              fr:"Porte de côté Tempo-Clip — abri double et 12' TA 7'6\" et plus (kit d'attachement inclus)",
              en:"Tempo-Clip side door — double and 12' TA 7'6\" and up (attachment kit included)" },
  PC5:      { sku:"PC5",      id:44509906763820, price:126.00, handle:"kit-porte-de-cote-tempo-clip-double-rond-toile-fermoirs-moulures-kitsd4",
              fr:"Kit porte de côté Tempo-Clip — double Rond (toile, fermoirs, moulures)",
              en:"Tempo-Clip side door kit — double Round (cover, latches, mouldings)" },
  KITSD4:   { sku:"KITSD4",   id:44509905125420, price:4.50, handle:"kit-quincaillerie-porte-de-cote-universel",
              fr:"Kit de quincaillerie de porte de côté (universel)",
              en:"Side-door hardware kit (universal)" }
};
/* PEZTARA (attachement TAR vendu seul) n'est plus proposé par le configurateur :
   il est compris dans PEZTAR76. Le code reste en vente comme pièce de rechange. */
/* Peut-on poser une porte de côté auto-installable sur ce modèle,
   à cette longueur ? Il faut une section qui ne soit pas une section de bout.
   - double Rond : toile soudée, arche jusqu'au sol -> non
   - utilitaire 8'x10' : arches aux 5 pi -> 2 sections, toutes deux de bout -> non
   - 5'x8' (rangement et mini-monopente) : 2 sections de bout -> non
   - 5'x12' : 3 sections, celle du milieu est libre -> oui */
D.canSideDoor = function(model, len){
  if(!model) return false;
  if(model.id==="double_rond") return false;
  if(model.id==="utilitaire")  return false;
  var L = len || (model.L && model.L[0]) || 0;
  var arc = model.arc || 4;
  return (Math.round(L/arc) >= 3);           /* au moins une section du milieu */
};
/* -> [code]. UN SEUL article : la quincaillerie et, au-dessus de 7'6",
   le kit d'attachement sont compris dans la porte. */
D.sideDoorFor = function(model, h){
  if(model.id==="double_rond") return ["PC5"];
  var tar  = (model.paver==="PPTAR");        // poteau 1 5/8 x 2¾ (12' TA, doubles)
  var haut = (h >= 7.5-0.02);                // seuil de hauteur libre : 7'6"
  if(tar) return [haut ? "PEZTAR76" : "PEZTAR"];
  return  [haut ? "PEZ76"    : "PEZ"];
};

/* ============================================================
   RACCORD MAISON / GARAGE — flap de jonction + wirelock
   Le flap se choisit par famille d'abri et par longueur à couvrir.
   ============================================================ */
D.FLAPS = {
  FL48:     { sku:"FL48",     id:44509904764972, price:62.00,  inches:48,  fam:"simple",
              handle:"flap-simple-de-48",
              fr:"Flap simple — 48 po (4 pi)", en:"Single flap — 48 in (4 ft)" },
  FL86:     { sku:"FL86",     id:44509904797740, price:85.00,  inches:86,  fam:"simple",
              handle:"flap-simple-de-86",
              fr:"Flap simple — 86 po (7 pi 2 po)", en:"Single flap — 86 in (7 ft 2 in)" },
  FL120:    { sku:"FL120",    id:44509904732204, price:110.00, inches:120, fam:"simple",
              handle:"flap-simple-de-120",
              fr:"Flap simple — 120 po (10 pi)", en:"Single flap — 120 in (10 ft)" },
  FLTAR72:  { sku:"FLTAR72",  id:44509905027116, price:90.00,  inches:72,  fam:"large",
              handle:"flap-double-de-72-12-a-20-seulement",
              fr:"Flap double — 72 po (6 pi)", en:"Double flap — 72 in (6 ft)" },
  FLTAR120: { sku:"FLTAR120", id:44509904994348, price:145.00, inches:120, fam:"large",
              handle:"flap-double-de-120-12-a-20-seulement",
              fr:"Flap double — 120 po (10 pi)", en:"Double flap — 120 in (10 ft)" }
};
/* Wirelock : le rail et sa broche se vendent maintenant ENSEMBLE, code WIRE.
   RAIL et BROCHE restent au catalogue comme pièces de rechange, mais le
   configurateur ne les propose plus séparément. */
D.WIRELOCK = {
  WIRE:   { sku:"WIRE",   id:46010494451756, price:19.99, handle:"ensemble-wirelock-rail-et-broche",
            fr:"Ensemble Wirelock — rail d'aluminium de 6 pi et broche",
            en:"Wirelock set — 6 ft aluminum rail and locking wire" }
};
/* Choisit le flap : bonne famille, puis la première taille qui couvre. */
/* Abris de 12 pi à 20 pi de large -> gamme FLTAR. Abris simples -> gamme FL. */
D.flapFor = function(model, feet){
  var wmax = Math.max.apply(null, model.w);
  var fam = wmax >= 12 ? "large" : "simple";
  var list = [];
  for(var k in D.FLAPS) if(D.FLAPS[k].fam===fam) list.push(D.FLAPS[k]);
  list.sort(function(a,b){ return a.inches-b.inches; });
  var need = (feet||8)*12;
  for(var i=0;i<list.length;i++) if(list[i].inches >= need) return list[i];
  return list[list.length-1] || null;
};
/* Ensembles Wirelock de 6 pi : on couvre les deux montants et le linteau. */
D.wirelockCount = function(openingFeet){ return Math.max(2, Math.ceil((openingFeet||9)/6) + 2); };

/* ============================================================
   FENÊTRES — nombre par modèle. Elles sont livrées BOUCHÉES :
   le client découpe seulement celles qu'il veut ouvrir.
   ============================================================ */
D.windowsFor = function(model){
  if(model.fam==="rangement") return 0;      // aucune fenêtre sur les abris de rangement
  if(model.roof==="shed")     return 4;      // monopente : 4, aux quatre coins
  return 2;                                   // simple et double : 2
};
})();

/* Logo Tempo officiel (PNG, fond transparent) — utilisé dans l'en-tête,
   sur la toile en 3D et sur le bon de commande imprimable. */
window.TEMPO_LOGO = "data:image/png;base64,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";

(function(){
"use strict";

/* ============================================================
   TEXTES — FR / EN
   ============================================================ */
var T = {
fr:{
  brand:"Configurateur d'abri", restart:"Recommencer", back:"Retour", next:"Continuer",
  heroEyebrow:"Deux minutes",
  heroTitle:"Configurez votre abri Tempo",
  heroSub:"Quelques questions simples, et vous repartez avec le bon modèle, les bonnes dimensions, les bons ancrages et votre commande prête — le tout visualisé en 3D avec votre véhicule à l'intérieur.",
  heroCta:"Commencer",
  heroS1:"Votre véhicule", heroS2:"Vos dimensions", heroS3:"Votre sol", heroS4:"Votre commande",
  qOf:"Question %1 sur %2",

  resTag:"Votre configuration", resModel:"Modèle recommandé", resWhy:"Pourquoi ce modèle",
  resTips:"Bons conseils avant de commander", resWarn:"À vérifier avant d'acheter",
  viz3d:"Vue 3D", vizDrag:"Glissez pour tourner · molette ou pincez pour zoomer", vizDragM:"Glissez pour tourner · pincez pour zoomer",
  slLength:"Longueur", slHeight:"Hauteur libre", slWidth:"Largeur",

  ordTitle:"Votre commande", 
  ordSub:"Décochez ce dont vous n'avez pas besoin. Les articles requis pour ancrer votre abri correctement ne peuvent pas être retirés.",
  ordTotal:"Total", ordTax:"Avant taxes et livraison", ordCart:"Ajouter au panier",
  ctaQuote:"Demander une soumission", ctaQuoteShort:"Soumission", ordCartShort:"Ajouter au panier",
  sumTitle2:"Résumé de commande",
  sumSub:"Copiez-le et envoyez-le-nous, ou joignez-le à votre demande de soumission. Tout y est : codes d'articles, quantités et prix.",
  copy:"Copier le résumé", copied:"Copié ✓", mail:"Nous l'envoyer par courriel",
  note:"Cet outil donne une recommandation à titre indicatif, basée sur les mesures que vous avez fournies. Mesurez toujours votre espace et votre véhicule avant de commander, et vérifiez le règlement de votre municipalité. Les prix sont en dollars canadiens, avant taxes et livraison. En cas de doute, un conseiller Tempo valide votre configuration gratuitement.",

  dimW:"Largeur", dimL:"Longueur", dimH:"Hauteur libre",
  hAtDoor:"à la barre de porte",
  priceNote:"avant taxes", priceOnline:"prix en ligne",
  cartReady:"Le panier s'ouvrira sur abristempo.com avec tous vos articles.",
  cartOffline:"Le panier fonctionne depuis notre site web. D'ici là, copiez le résumé plus bas ou demandez une soumission.",
  fitOk:"Dégagement confortable pour %1.",
  fitTight:"Ça entre, mais c'est juste. Une taille de plus serait plus confortable.",
  fitNo:"Trop petit pour %1 — augmentez la %2.",
  fitNoH:"hauteur", fitNoL:"longueur", fitNoW:"largeur",
  altSwap:"Voir ce modèle",
  included:"Inclus", required:"Requis", suggested:"Suggéré", each:"ch.", yourShelter:"Votre abri", asked:"Demandé",
  tierTitle:"Trois options d'abri simple selon vos besoins",
  print:"Imprimer ou enregistrer en PDF",
  docTitle:"Bon de commande", docCode:"Code", docDesc:"Description", docQty:"Qté",
  docUnit:"Prix unitaire", docTot:"Montant", docTotal:"Total avant taxes et livraison",
  slogan:"L'abri d'auto. Le vrai.", slDoor:"Porte de côté",
  oriFront:"AVANT", oriBack:"ARRIÈRE", oriLeft:"GAUCHE", oriRight:"DROITE",
  advNeedTitle:"Cette configuration passe par un conseiller",
  advNeedTx:"Une porte de côté dans la première ou la dernière section doit être cousue sur mesure à notre atelier de Laval, et des frais de couture additionnels peuvent s'appliquer. Imprimez votre bon de commande ou envoyez-le-nous : un conseiller vérifie avec vous le délai, les frais et la position exacte.",
  mailTitle:"Envoyez-nous votre commande", mailSend:"Ouvrir mon courriel",
  mailSub:"On vous rappelle pour confirmer les dimensions, la disponibilité et le délai. Aucun engagement.",
  mailName:"Votre nom", mailTel:"Votre téléphone", mailCity:"Votre ville (facultatif)",
  discTitle:"Avant d'ajouter au panier", discBack:"Revenir", discOk:"J'accepte",
  discIntro:"Trois choses à confirmer. On préfère être clairs maintenant plutôt que le jour de l'installation.",
  disc1:"Je comprends que les dimensions de véhicules utilisées ici sont approximatives et que c'est à moi de mesurer mon véhicule et mon espace avant de commander.",
  disc2:"Je comprends que cette configuration est une suggestion, basée uniquement sur les informations que j'ai fournies.",
  disc3:"Je sais qu'il est de ma responsabilité de vérifier le règlement de ma municipalité : dates permises, dimensions, hauteur et distances.",

  resTitleAuto:"Voici votre abri",
  resSubAuto:"Basé sur %1 et sur votre sol en %2. Ajustez les dimensions et votre commande se met à jour.",
  resTitleRang:"Voici votre abri de rangement",
  resSubRang:"Tournez-le en 3D pour vous faire une idée du volume, puis ajustez votre commande.",

  advTitleBig:"On préfère vous parler",
  advTextBig:"Un bateau, un VR ou une roulotte, ça ne se configure pas en ligne : la hauteur et la largeur varient énormément d'un modèle à l'autre. Un conseiller Tempo prend vos mesures et vous propose la bonne structure — souvent un abri industriel ou, pour un bateau, un abri Navigloo.",
  advTitleCom:"Votre projet mérite une soumission",
  advTextCom:"Les abris commerciaux et industriels vont jusqu'à 30 pi de largeur, sans limite de longueur. Chaque projet est calculé selon la portée, la charge de neige et l'usage. Écrivez-nous et un conseiller vous rappelle.",
  advTitleWide3:"Trois de front, ça se calcule",
  advTextWide3:"Nos abris doubles vont jusqu'à 20 pi de large : deux véhicules côte à côte, pas trois. Pour trois de front il faut un abri industriel, calculé selon la portée et la charge de neige de votre région. Écrivez-nous vos mesures et un conseiller vous revient avec une proposition. Si par contre vos trois véhicules peuvent se placer deux côte à côte et un devant, revenez en arrière et choisissez cette option : ça se configure ici.",
  advTitleEntree:"Un abri d'entrée, c'est par ici",
  advTextEntree:"Pour protéger une porte, un perron ou un escalier, Tempo offre l'abri portique et l'abri vestibule. Ce ne sont pas des abris d'auto — les dimensions et le montage sont différents.",
  advSeeEntree:"Voir les abris d'entrée",

  tr1n:"1971", tr1t:"Pionniers de l'abri d'auto démontable au Québec. 55 ans à le refaire mieux, et plus de 2 millions de clients.",
  tr2n:"280 g/m²", tr2t:"De zinc sur l'acier de nos structures (norme Z275/Z280) — le double du Z140 courant dans l'industrie.",
  tr3n:"Testé au Québec", tr3t:"Testées au Groupe CTT de Saint-Hyacinthe : traction, déchirure, UV et cycles de gel-dégel.",
  tr4n:"4 magasins", tr4t:"Laval ouvert à l'année, Anjou, Saint-Jérôme et Brossard en saison, plus des détaillants partout au Québec.",
  recapTitle:"Vos réponses", recapRedo:"Tout refaire depuis le début",
  recapChange:"Modifier", editing:"Modification d'une réponse", editDone:"Revenir à ma configuration",
  saveTitle:"Gardez votre configuration",
  saveSub:"Le lien contient tous vos choix. Envoyez-le à votre conjoint, gardez-le pour y revenir, ou donnez-le à un conseiller : il rouvre exactement l'écran que vous avez devant vous.",
  saveCopy:"Copier le lien de ma configuration", saveCopied:"Lien copié ✓", saveShare:"Partager",
  mailMail:"Votre courriel (facultatif)",
  leadSend:"Envoyer ma configuration", leadSending:"Envoi…",
  leadOK:"C'est reçu. Un conseiller Tempo vous rappelle avec votre configuration sous les yeux.",
  leadErr:"Il nous faut votre nom et un numéro de téléphone à 10 chiffres pour vous rappeler.",
  resumed:"On a rouvert la configuration de votre lien. Tout est modifiable.",

  accDim:"Dimensions de l'abri", accDoors:"Portes", accGround:"Vos dimensions de terrain et type de sol",
  accVeh:"Véhicules", accView:"Options d'affichage", accSoil:"Revêtement", accSkin:"Vue", accDims:"Mesures",
  doorFront:"Porte avant", doorBack:"Porte arrière", sideAdd:"Porte de côté", sidePos:"Position sur la longueur",
  driveW:"Largeur de l'entrée", driveL:"Profondeur de l'entrée",

  disc2Title:"Gardez une trace de votre configuration",
  disc2Intro:"On vous suggère d'imprimer votre bon de commande ou de l'enregistrer, pour garder une trace des informations que vous avez fournies. N'oubliez pas qu'il est de votre responsabilité de vérifier vos mesures : cet outil est là pour vous aider, mais il ne peut pas être tenu responsable d'une erreur de mesure ou de réglementation.",
  disc2Close:"Fermer", disc2Cart:"Ajouter au panier",

  tab_accDim:"Dimensions", tab_accGround:"Terrain et sol", tab_accVeh:"Véhicules",
  tab_accDoors:"Portes", tab_accView:"Affichage",

  oosTitle:"Ce modèle est temporairement en rupture",
  oosTx:"On ne peut pas l'ajouter au panier pour l'instant. Envoyez-nous votre commande : on vous revient avec une date de disponibilité le plus rapidement possible, et votre configuration est déjà prête de notre côté.",
  oosLine:"En rupture de stock. Cette pièce est nécessaire à votre installation, mais elle ne peut pas être ajoutée au panier pour le moment — ajoutez-la à votre demande par courriel et un conseiller vous donnera la date de retour en stock.",
  oosPill:"Rupture de stock",

  sumTitle:"MA CONFIGURATION TEMPO",
  sumVeh:"Véhicule(s)", sumSoil:"Sol", sumSite:"Emplacement", sumWind:"Terrain exposé au vent",
  sumItems:"ARTICLES", sumQty:"Qté", sumTotalTx:"TOTAL AVANT TAXES",
  mailSubject:"Ma configuration Abris Tempo"
},
en:{
  brand:"Shelter Configurator", restart:"Start over", back:"Back", next:"Continue",
  heroEyebrow:"Two minutes",
  heroTitle:"Configure your Tempo shelter",
  heroSub:"A few simple questions and you'll have the right model, the right size, the right anchors and your order ready — all shown in 3D with your vehicle inside.",
  heroCta:"Get started",
  heroS1:"Your vehicle", heroS2:"Your space", heroS3:"Your ground", heroS4:"Your order",
  qOf:"Question %1 of %2",

  resTag:"Your configuration", resModel:"Recommended model", resWhy:"Why this model",
  resTips:"Good to know before you order", resWarn:"Check these before you buy",
  viz3d:"3D view", vizDrag:"Drag to rotate · scroll or pinch to zoom", vizDragM:"Drag to rotate · pinch to zoom",
  slLength:"Length", slHeight:"Clearance height", slWidth:"Width",

  ordTitle:"Your order",
  ordSub:"Uncheck anything you don't need. Items required to anchor your shelter properly can't be removed.",
  ordTotal:"Total", ordTax:"Before taxes and delivery", ordCart:"Add to cart",
  ctaQuote:"Request a quote", ctaQuoteShort:"Get a quote", ordCartShort:"Add to cart",
  sumTitle2:"Order summary",
  sumSub:"Copy it and send it to us, or attach it to your quote request. Everything's there: item codes, quantities and prices.",
  copy:"Copy summary", copied:"Copied ✓", mail:"Email it to us",
  note:"This tool gives an indicative recommendation based on the measurements you entered. Always measure your space and your vehicle before ordering, and check your municipality's by-laws. Prices are in Canadian dollars, before taxes and delivery. When in doubt, a Tempo advisor will confirm your configuration free of charge.",

  dimW:"Width", dimL:"Length", dimH:"Clearance",
  hAtDoor:"at the door bar",
  priceNote:"before taxes", priceOnline:"price online",
  cartReady:"The cart will open on abristempo.com with all your items.",
  cartOffline:"The cart only works from our website. In the meantime, copy the summary below or request a quote.",
  fitOk:"Comfortable clearance for %1.",
  fitTight:"It fits, but it's tight. One size up would be more comfortable.",
  fitNo:"Too small for %1 — increase the %2.",
  fitNoH:"height", fitNoL:"length", fitNoW:"width",
  altSwap:"View this model",
  included:"Included", required:"Required", suggested:"Suggested", each:"ea.", yourShelter:"Your shelter", asked:"Requested",
  tierTitle:"Three single-shelter options to suit your needs",
  print:"Print or save as PDF",
  docTitle:"Order form", docCode:"Code", docDesc:"Description", docQty:"Qty",
  docUnit:"Unit price", docTot:"Amount", docTotal:"Total before taxes and delivery",
  slogan:"The car shelter. The real thing.", slDoor:"Side door",
  oriFront:"FRONT", oriBack:"BACK", oriLeft:"LEFT", oriRight:"RIGHT",
  advNeedTitle:"This configuration goes through an advisor",
  advNeedTx:"A side door in the first or last section must be custom-sewn at our Laval workshop, and additional sewing charges may apply. Print your order form or send it to us: an advisor will check lead time, charges and exact position with you.",
  mailTitle:"Send us your order", mailSend:"Open my email",
  mailSub:"We'll call you back to confirm sizes, availability and lead time. No commitment.",
  mailName:"Your name", mailTel:"Your phone", mailCity:"Your city (optional)",
  discTitle:"Before adding to cart", discBack:"Go back", discOk:"I agree",
  discIntro:"Three things to confirm. We'd rather be clear now than on installation day.",
  disc1:"I understand the vehicle dimensions used here are approximate and that it's up to me to measure my vehicle and my space before ordering.",
  disc2:"I understand this configuration is a suggestion, based only on the information I provided.",
  disc3:"I know it's my responsibility to check my municipality's by-laws: permitted dates, sizes, height and setbacks.",

  resTitleAuto:"Here's your shelter",
  resSubAuto:"Based on %1 and your ground: %2. Adjust the dimensions and your order updates.",
  resTitleRang:"Here's your storage shelter",
  resSubRang:"Rotate it in 3D to get a feel for the volume, then adjust your order.",

  advTitleBig:"We'd rather talk to you",
  advTextBig:"A boat, an RV or a trailer can't be configured online: height and width vary enormously from one model to the next. A Tempo advisor will take your measurements and propose the right structure — often an industrial shelter or, for a boat, a Navigloo shelter.",
  advTitleCom:"Your project deserves a quote",
  advTextCom:"Commercial and industrial shelters go up to 30 ft wide, with no length limit. Every project is engineered for span, snow load and use. Write to us and an advisor will call you back.",
  advTitleWide3:"Three side by side has to be engineered",
  advTextWide3:"Our double shelters go up to 20 ft wide: two vehicles side by side, not three. Three side by side needs an industrial shelter, engineered for span and for your area's snow load. Send us your measurements and an advisor will come back with a proposal. If your three vehicles can instead sit two side by side with one in front, go back and pick that option — you can configure that one right here.",
  advTitleEntree:"Entrance shelters are this way",
  advTextEntree:"To protect a door, a porch or stairs, Tempo offers portico and vestibule shelters. These are not car shelters — sizes and assembly are different.",
  advSeeEntree:"View entrance shelters",

  tr1n:"1971", tr1t:"Pioneers of the portable car shelter in Quebec. 55 years spent making it better, and over 2 million customers.",
  tr2n:"280 g/m²", tr2t:"Of zinc on our structural steel (Z275/Z280 standard) — double the Z140 common in the industry.",
  tr3n:"Tested in Quebec", tr3t:"Tested at Groupe CTT in Saint-Hyacinthe: tensile strength, tear resistance, UV and freeze-thaw cycles.",
  tr4n:"4 stores", tr4t:"Laval year-round, Anjou, Saint-Jérôme and Brossard in season, plus dealers across Quebec.",
  recapTitle:"Your answers", recapRedo:"Start over from scratch",
  recapChange:"Change", editing:"Changing one answer", editDone:"Back to my configuration",
  saveTitle:"Keep your configuration",
  saveSub:"The link contains all your choices. Send it to your partner, keep it to come back to, or give it to an advisor: it reopens the exact screen you are looking at.",
  saveCopy:"Copy my configuration link", saveCopied:"Link copied \u2713", saveShare:"Share",
  mailMail:"Your email (optional)",
  leadSend:"Send my configuration", leadSending:"Sending…",
  leadOK:"Got it. A Tempo advisor will call you back with your configuration in front of them.",
  leadErr:"We need your name and a 10-digit phone number to call you back.",
  resumed:"We reopened the configuration from your link. Everything is still editable.",

  accDim:"Shelter size", accDoors:"Doors", accGround:"Your driveway size and surface",
  accVeh:"Vehicles", accView:"Display options", accSoil:"Surface", accSkin:"View", accDims:"Measurements",
  doorFront:"Front door", doorBack:"Rear door", sideAdd:"Side door", sidePos:"Position along the length",
  driveW:"Driveway width", driveL:"Driveway depth",

  disc2Title:"Keep a record of your configuration",
  disc2Intro:"We suggest printing or saving your order form, so you keep a record of the information you provided. Remember that verifying your measurements is your responsibility: this tool is here to help, but we cannot be held responsible for a measurement or by-law error.",
  disc2Close:"Close", disc2Cart:"Add to cart",

  tab_accDim:"Size", tab_accGround:"Driveway", tab_accVeh:"Vehicles",
  tab_accDoors:"Doors", tab_accView:"Display",

  oosTitle:"This model is temporarily out of stock",
  oosTx:"We can't add it to the cart right now. Send us your order: we'll come back with an availability date as quickly as we can, and your configuration is already on file with us.",
  oosLine:"Out of stock. This part is required for your setup, but it can't be added to the cart right now — include it in your email request and an advisor will give you the restock date.",
  oosPill:"Out of stock",

  sumTitle:"MY TEMPO CONFIGURATION",
  sumVeh:"Vehicle(s)", sumSoil:"Ground", sumSite:"Location", sumWind:"Wind-exposed lot",
  sumItems:"ITEMS", sumQty:"Qty", sumTotalTx:"TOTAL BEFORE TAXES",
  mailSubject:"My Tempo shelter configuration"
}};

/* ============================================================
   QUESTIONS
   ============================================================ */
var IC = {
  arrowL:'<path d="M19 12H5M11 18l-6-6 6-6"/>',
  arrowR:'<path d="M5 12h14M13 6l6 6-6 6"/>',
  calendar:'<rect x="3" y="4.5" width="18" height="16" rx="2"/><path d="M3 9.5h18M8 2.5v4M16 2.5v4"/>',
  truck:'<path d="M2 16V6h11v10M13 9h4l3 3.5V16"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/><path d="M2 16h1.5M9 16h6.5M19.5 16H22"/>',
  users:'<path d="M15.5 20v-1.6a3.5 3.5 0 0 0-3.5-3.4H6a3.5 3.5 0 0 0-3.5 3.4V20"/><circle cx="9" cy="7.5" r="3.4"/><path d="M21.5 20v-1.6a3.5 3.5 0 0 0-2.6-3.3M16 4.2a3.5 3.5 0 0 1 0 6.6"/>',
  snow:'<path d="M12 2v20M4.5 6.5l15 11M19.5 6.5l-15 11"/><path d="M12 5.5 9.8 3.6M12 5.5l2.2-1.9M12 18.5l-2.2 1.9M12 18.5l2.2 1.9"/>',
  ruler:'<path d="M3 8.5h18a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1z"/><path d="M6.5 8.5v3M10 8.5v4.5M13.5 8.5v3M17 8.5v4.5"/>',
  rake:'<path d="M4 20 14 10"/><path d="M12.5 4.5 20 12M11 6l7.5 7.5M14 3l7 7"/>',
  cover:'<path d="M3 9.5 12 4l9 5.5"/><path d="M3 9.5V19a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9.5"/><path d="M3 13.5h18M3 16.5h18"/>',
  shield:'<path d="M12 2.5 4 6v6c0 5 3.4 8.6 8 9.5 4.6-.9 8-4.5 8-9.5V6z"/><path d="m9 12 2 2 4-4"/>',
  car:'<path d="M5 17h14M6.5 17v2M17.5 17v2"/><path d="M3.5 17v-4l2-5h13l2 5v4"/><circle cx="7.5" cy="14" r="1.2"/><circle cx="16.5" cy="14" r="1.2"/>',
  suv:'<path d="M4 17h16M6 17v2M18 17v2"/><path d="M2.5 17v-5l2.5-5.5h14L21.5 12v5"/><circle cx="7" cy="14" r="1.3"/><circle cx="17" cy="14" r="1.3"/><path d="M5 12h14"/>',
  truck:'<path d="M2 16h20M4 16v2M9 16v2M18 16v2"/><path d="M2 16V9h8l1.5-3h5L18 9h4v7"/><circle cx="6.5" cy="13.5" r="1.2"/><circle cx="17.5" cy="13.5" r="1.2"/>',
  van:'<path d="M3 17h18M5 17v2M17 17v2"/><path d="M2.5 17V7h13l5 5v5"/><circle cx="7" cy="14" r="1.2"/><circle cx="16" cy="14" r="1.2"/><path d="M6 8v4M11 8v4"/>',
  two:'<rect x="2" y="4" width="9" height="16" rx="1.5"/><rect x="13" y="4" width="9" height="16" rx="1.5"/>',
  tandem:'<rect x="4" y="2" width="16" height="9" rx="1.5"/><rect x="4" y="13" width="16" height="9" rx="1.5"/>',
  more:'<circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/>',
  trio:'<rect x="2" y="3" width="9" height="8" rx="1.5"/><rect x="13" y="3" width="9" height="8" rx="1.5"/><rect x="7.5" y="13" width="9" height="8" rx="1.5"/>',
  wide3:'<rect x="1.5" y="4" width="6" height="16" rx="1.5"/><rect x="9" y="4" width="6" height="16" rx="1.5"/><rect x="16.5" y="4" width="6" height="16" rx="1.5"/>',
  box:'<path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/>',
  door:'<path d="M4 21V4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v17"/><path d="M3 21h18M13.5 12.5h.01"/>',
  boat:'<path d="M3 16h18l-2.5 5H5.5z"/><path d="M6 16V7l10 4-10 5"/>',
  factory:'<path d="M3 21V10l6 4V10l6 4V6l6 4v11z"/><path d="M3 21h18"/>',
  wall:'<path d="M3 4v16M3 4h18v16H3"/><path d="M3 9h18M3 14h18M9 4v5M15 9v5M9 14v6"/>',
  open:'<circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1"/>',
  narrow:'<path d="M8 3v18M16 3v18"/><path d="M11 9l-2 3 2 3M13 9l2 3-2 3"/>',
  asphalt:'<rect x="2.5" y="6" width="19" height="12" rx="1.5"/><path d="M7 12h3M14 12h3"/>',
  concrete:'<rect x="2.5" y="6" width="19" height="12" rx="1.5"/><path d="M2.5 12h19M9 6v6M15 12v6"/>',
  paver:'<rect x="2.5" y="4" width="19" height="16" rx="1.5"/><path d="M2.5 9.3h19M2.5 14.6h19M8.8 4v5.3M15.2 9.3v5.3M8.8 14.6V20"/>',
  grass:'<path d="M3 20h18"/><path d="M6 20c0-4 1-6 2-8M10 20c0-5 .5-8 1.5-10M14 20c0-4 1-7 2-9M18 20c0-3 .5-5 1-6"/>',
  gravel:'<path d="M3 19h18"/><circle cx="7" cy="15" r="2"/><circle cx="13" cy="16" r="2.4"/><circle cx="18" cy="15" r="1.7"/><circle cx="10" cy="11" r="1.6"/>',
  nothing:'<path d="M4 6h16M4 12h16M4 18h16"/>',
  bars:'<path d="M3 8h18M3 8v2M21 8v2"/><path d="M4 16h16l-1.5-4h-13z"/><circle cx="7" cy="18" r="1"/><circle cx="17" cy="18" r="1"/>',
  cargo:'<rect x="5" y="4" width="14" height="4" rx="2"/><path d="M4 16h16l-1.5-4h-13z"/><circle cx="7" cy="18" r="1"/><circle cx="17" cy="18" r="1"/>',
  wind:'<path d="M9.6 4.6A2 2 0 1 1 11 8H2M12.6 19.4A2 2 0 1 0 14 16H2M17.7 7.7A2.5 2.5 0 1 1 19.5 12H2"/>',
  calm:'<path d="M3 12h8M3 7h6M3 17h5"/><path d="M17 5a4 4 0 0 1 0 14"/>',
  sled:'<path d="M3 18h13l4-4"/><path d="M3 18c2 2 5 2 7 0s5-2 7 0"/><path d="M6 14h8l3-5H9z"/>',
  tools:'<path d="M14.7 6.3a4 4 0 0 0 5.3 5.3l-8 8a2.8 2.8 0 0 1-4-4z"/><path d="M6 6l3 3"/>',
  wood:'<rect x="2.5" y="7" width="19" height="4" rx="1"/><rect x="2.5" y="13" width="19" height="4" rx="1"/><path d="M7 7v4M16 13v4"/>',
  bike:'<circle cx="6" cy="17" r="3.4"/><circle cx="18" cy="17" r="3.4"/><path d="M6 17l4-8h5l3 8M10 9h6"/>',
  question:'<circle cx="12" cy="12" r="9"/><path d="M9.2 9.2a2.9 2.9 0 0 1 5.6 1c0 1.9-2.8 2.9-2.8 2.9"/><path d="M12 17h.01"/>'
};

var QUESTIONS = [
{
  id:"usage", type:"choice",
  fr:{q:"Qu'est-ce que vous voulez abriter ?", hint:"C'est la question qui détermine toute la suite."},
  en:{q:"What do you want to shelter?", hint:"This question drives everything that follows."},
  opts:[
    {v:"auto", ic:IC.car,     fr:["Un ou des véhicules","Voiture, VUS, camionnette, fourgonnette"], en:["One or more vehicles","Car, SUV, pickup, minivan"]},
    {v:"rangement", ic:IC.box,fr:["De l'équipement","Motoneige, VTT, vélos, outils, bois de chauffage"], en:["Equipment","Snowmobile, ATV, bikes, tools, firewood"]},
    {v:"entree", ic:IC.door,  fr:["Une entrée de maison","Porte, perron, escalier"], en:["A house entrance","Door, porch, stairs"]},
    {v:"gros", ic:IC.boat,    fr:["Un bateau, un VR ou une roulotte","Grandes dimensions, mesures très variables"], en:["A boat, RV or trailer","Large, and dimensions vary a lot"]},
    {v:"commercial", ic:IC.factory, fr:["Un usage commercial ou industriel","Entreposage, chantier, machinerie"], en:["Commercial or industrial use","Storage, job site, machinery"]}
  ]
},
{
  id:"nb", type:"choice", when:function(a){return a.usage==="auto";},
  fr:{q:"Combien de véhicules doivent entrer ?", hint:"Comptez seulement ceux qui seront sous l'abri en même temps."},
  en:{q:"How many vehicles need to fit?", hint:"Count only those that will be under the shelter at the same time."},
  opts:[
    {v:"1", ic:IC.car,     fr:["Un seul véhicule",""], en:["A single vehicle",""]},
    {v:"2cote", ic:IC.two, fr:["Deux, côte à côte","Il vous faut un abri double"], en:["Two, side by side","You need a double shelter"]},
    {v:"2file", ic:IC.tandem, fr:["Deux, l'un derrière l'autre","Un abri simple, mais très long"], en:["Two, one behind the other","A single shelter, but very long"]},
    {v:"3grid", ic:IC.trio, fr:["Trois — deux côte à côte et un devant","Un abri double, simplement plus long"], en:["Three — two side by side, one in front","A double shelter, just longer"]},
    {v:"3large", ic:IC.wide3, fr:["Trois de front ou plus","Sur mesure : un conseiller vous prépare ça"], en:["Three or more side by side","Custom order: an advisor will take care of it"]}
  ]
},
{
  id:"veh", type:"choice", when:function(a){return a.usage==="auto" && a.nb==="1";},
  fr:{q:"Quel type de véhicule ?", hint:"On part de mesures moyennes. Vous pourrez ajuster ensuite."},
  en:{q:"What type of vehicle?", hint:"We start from average dimensions. You can adjust afterwards."},
  opts:[
    {v:"voiture", ic:IC.car,      fr:["Une voiture","Berline, compacte, hatchback"], en:["A car","Sedan, compact, hatchback"]},
    {v:"vus", ic:IC.suv,          fr:["Un VUS","Multisegment ou VUS standard"], en:["An SUV","Crossover or standard SUV"]},
    {v:"camionnette", ic:IC.truck,fr:["Une camionnette","Pick-up, cabine multiplace"], en:["A pickup truck","Crew cab"]},
    {v:"fourgonnette", ic:IC.van, fr:["Une fourgonnette","Minifourgonnette familiale"], en:["A minivan","Family minivan"]},
    {v:"fourgon_haut", ic:IC.van, fr:["Un fourgon à toit haut","Transit, Sprinter, ProMaster"], en:["A high-roof van","Transit, Sprinter, ProMaster"]}
  ]
},
{
  id:"veh2", type:"choice", when:function(a){return a.usage==="auto" && (a.nb==="2cote"||a.nb==="2file"||a.nb==="3grid");},
  fr:{q:"Vos véhicules, c'est plutôt…", hint:"C'est l'erreur numéro un : deux VUS n'entrent pas dans un 16 pieds."},
  en:{q:"Which best describes your vehicles?", hint:"This is mistake number one: two SUVs won't fit in a 16 ft shelter."},
  opts:[
    {v:"2voitures", ic:IC.car,   fr:["Deux voitures","Berlines ou compactes"], en:["Two cars","Sedans or compacts"]},
    {v:"mixte", ic:IC.suv,       fr:["Une voiture et un VUS",""], en:["One car and one SUV",""]},
    {v:"2vus", ic:IC.suv,        fr:["Deux VUS",""], en:["Two SUVs",""]},
    {v:"2gros", ic:IC.truck,     fr:["Deux camionnettes, ou un VUS et une camionnette",""], en:["Two pickups, or an SUV and a pickup",""]}
  ]
},
{
  id:"toit", type:"choice", when:function(a){return a.usage==="auto" && a.nb!=="3large";},
  fr:{q:"Y a-t-il quelque chose sur le toit ?", hint:"La hauteur libre se mesure à la barre de porte. C'est là que ça bloque, presque toujours."},
  en:{q:"Is there anything on the roof?", hint:"Clearance height is measured at the door bar. That's almost always the limiting point."},
  opts:[
    {v:"rien", ic:IC.nothing,  fr:["Rien du tout",""], en:["Nothing at all",""]},
    {v:"barres", ic:IC.bars,   fr:["Des barres de toit","Rails ou barres transversales"], en:["Roof rails","Rails or crossbars"]},
    {v:"coffre", ic:IC.cargo,  fr:["Un coffre de toit ou un porte-vélos","Ajoute facilement un pied de hauteur"], en:["A roof box or bike rack","Easily adds a foot of height"]},
    {v:"boite", ic:IC.cargo,   fr:["Un panier ou un porte-bagages chargé",""], en:["A loaded roof basket or rack",""]}
  ]
},
{
  id:"lieu", type:"choice", when:function(a){return a.usage==="auto" && (a.nb==="1" || a.nb==="2file");}, /* abri simple seulement : les doubles n'ont pas d'option monopente/contre un mur */
  fr:{q:"Où sera installé l'abri ?", hint:"L'espace autour compte autant que l'espace dessous : il faut pouvoir déneiger le toit."},
  en:{q:"Where will the shelter go?", hint:"The space around it matters as much as the space under it: you need to be able to clear snow off the roof."},
  opts:[
    {v:"degage", ic:IC.open,  fr:["Dans une entrée dégagée","De la place des deux côtés"], en:["In an open driveway","Room on both sides"]},
    {v:"mur", ic:IC.wall,     fr:["Collé sur la maison ou un mur","La neige doit tomber d'un seul côté"], en:["Against the house or a wall","Snow must fall on one side only"]},
    {v:"etroit", ic:IC.narrow,fr:["Dans un espace étroit","Maison en rangée, jumelée, voisin proche"], en:["In a narrow space","Townhouse, semi-detached, close neighbour"]}
  ]
},
{
  id:"quoi", type:"choice", when:function(a){return a.usage==="rangement";},
  fr:{q:"Qu'est-ce que vous voulez ranger ?", hint:"Les abris de rangement sont plus bas et plus étroits qu'un abri d'auto."},
  en:{q:"What do you want to store?", hint:"Storage shelters are lower and narrower than a car shelter."},
  opts:[
    {v:"gros", ic:IC.sled,  fr:["Motoneige, VTT ou grosse machinerie","Il vous faut le modèle utilitaire"], en:["Snowmobile, ATV or large machinery","You need the utility model"]},
    {v:"velos", ic:IC.bike, fr:["Vélos, tondeuse, souffleuse",""], en:["Bikes, mower, snowblower",""]},
    {v:"bois", ic:IC.wood,  fr:["Bois de chauffage",""], en:["Firewood",""]},
    {v:"outils", ic:IC.tools, fr:["Outils, meubles de jardin, boîtes",""], en:["Tools, patio furniture, boxes",""]}
  ]
},
{
  id:"rlieu", type:"choice", when:function(a){return a.usage==="rangement";},
  fr:{q:"Où l'installer ?", hint:""},
  en:{q:"Where will it go?", hint:""},
  opts:[
    {v:"degage", ic:IC.open, fr:["En espace dégagé","Modèle à toit pointu, autonome"], en:["In an open space","Peaked roof, free-standing"]},
    {v:"mur", ic:IC.wall,    fr:["Appuyé contre un mur ou un cabanon","Modèle mini-monopente"], en:["Leaning against a wall or shed","Mini mono-slope model"]}
  ]
},
{
  id:"entree", type:"entree", when:function(a){return a.usage==="auto" && a.nb!=="3large";},
  fr:{q:"Connaissez-vous les dimensions de votre entrée ?", hint:"Si oui, on ajuste l'abri pour tirer le maximum de l'espace — et on vous prévient tout de suite s'il n'entre pas."},
  en:{q:"Do you know your driveway dimensions?", hint:"If so, we'll size the shelter to make the most of the space — and warn you right away if it won't fit."},
  opts:[]
},
{
  id:"sol", type:"choice", when:function(a){return a.usage!=="entree" && a.usage!=="gros" && a.usage!=="commercial" && a.nb!=="3large";},
  fr:{q:"Sur quel type de sol ?", hint:"C'est ce qui détermine vos ancrages — et l'ancrage, c'est ce qui tient l'abri l'hiver."},
  en:{q:"On what kind of ground?", hint:"This determines your anchors — and anchoring is what holds the shelter through winter."},
  opts:[
    {v:"asphalte", ic:IC.asphalt, fr:["Asphalte","Entrée pavée noire"], en:["Asphalt","Blacktop driveway"]},
    {v:"beton", ic:IC.concrete,   fr:["Béton ou ciment","Dalle coulée"], en:["Concrete","Poured slab"]},
    {v:"pave", ic:IC.paver,       fr:["Pavé uni","Blocs de béton décoratifs"], en:["Interlocking pavers","Decorative concrete blocks"]},
    {v:"gazon", ic:IC.grass,      fr:["Gazon, terre ou sable",""], en:["Grass, soil or sand",""]},
    {v:"gravier", ic:IC.gravel,   fr:["Gravier ou pierre concassée",""], en:["Gravel or crushed stone",""]}
  ]
},
{
  id:"pcote", type:"choice",
  when:function(a){return a.usage==="auto" && a.nb!=="3large";},
  fr:{q:"Voulez-vous une porte de côté ?", hint:"Une porte sur le côté long de l'abri, pour entrer sans passer devant le véhicule. C'est l'accessoire qu'on regrette le plus de ne pas avoir pris."},
  en:{q:"Do you want a side door?", hint:"A door on the long side, so you can walk in without going around the vehicle. It's the accessory people most regret skipping."},
  opts:[
    {v:"non", ic:IC.nothing, fr:["Non, les portes de bout suffisent",""], en:["No, the end doors are enough",""]},
    {v:"oui", ic:IC.door,    fr:["Oui, j'en veux une","Elle peut aussi s'ajouter plus tard"], en:["Yes, I want one","It can also be added later"]}
  ]
},
{
  id:"pcoteSide", type:"choice", when:function(a){return a.pcote==="oui";},
  fr:{q:"De quel côté ?", hint:"En vous plaçant devant l'abri, face à l'ouverture. Habituellement du côté de la porte de la maison."},
  en:{q:"On which side?", hint:"Standing in front of the shelter, facing the opening. Usually on the house-door side."},
  opts:[
    {v:"gauche", ic:IC.arrowL, fr:["À gauche",""], en:["On the left",""]},
    {v:"droite", ic:IC.arrowR, fr:["À droite",""], en:["On the right",""]},
    {v:"nsp",    ic:IC.question, fr:["Je déciderai plus tard","On vous le demandera à la commande"], en:["I'll decide later","We'll ask when you order"]}
  ]
},
{
  id:"pcoteSect", type:"choice", when:function(a){return a.pcote==="oui";},
  fr:{q:"À quel endroit sur la longueur ?", hint:"L'abri est fait de sections de 4 pi. La position change la façon dont la porte est fabriquée."},
  en:{q:"Where along the length?", hint:"The shelter is built from 4 ft sections. The position changes how the door is made."},
  opts:[
    {v:"milieu", ic:IC.door, fr:["Dans une section du milieu","Kit auto-installable, sans couture — livré avec l'abri"], en:["In a middle section","Self-install kit, no sewing — ships with the shelter"]},
    {v:"bout",   ic:IC.wall, fr:["Dans la première ou la dernière section","La porte doit être cousue sur mesure à l'atelier : délai et frais en plus"], en:["In the first or last section","The door must be custom-sewn at the shop: extra lead time and cost"]}
  ]
},
{
  id:"raccord", type:"choice",
  when:function(a){return a.usage==="auto" && a.nb!=="3large";},
  fr:{q:"Voulez-vous raccorder l'abri à la maison ou au garage ?", hint:"Un flap de jonction ferme l'espace entre l'abri et le mur : plus de neige ni de vent qui s'engouffre, et on passe au sec de l'abri à la porte."},
  en:{q:"Do you want to connect the shelter to the house or garage?", hint:"A junction flap closes the gap between the shelter and the wall: no more snow or wind blowing through, and you stay dry from shelter to door."},
  opts:[
    {v:"non", ic:IC.open, fr:["Non, pas besoin",""], en:["No, not needed",""]},
    {v:"oui", ic:IC.wall, fr:["Oui, je veux fermer l'espace","On ajoutera le flap et les rails Wirelock"], en:["Yes, close the gap","We'll add the flap and Wirelock rails"]}
  ]
},
{
  id:"raccordLen", type:"raccord", when:function(a){return a.raccord==="oui";},
  fr:{q:"Quelle largeur d'ouverture faut-il couvrir ?", hint:"La largeur de votre porte de garage, ou de l'ouverture entre l'abri et le mur."},
  en:{q:"How wide is the opening to cover?", hint:"The width of your garage door, or of the opening between the shelter and the wall."},
  opts:[]
},
];

window.TEMPO_I18N = { T:T, QUESTIONS:QUESTIONS, IC:IC };
})();

(function(){
"use strict";
/* ============================================================
   MOTEUR 3D — Canvas 2D, perspective + tri du peintre.
   Aucune bibliothèque, aucun CDN, aucun souci de CSP.
   Toile blanche opaque, portes de bout roulées et ouvertes :
   on voit l'intérieur par l'ouverture, comme sur une vraie photo.
   Repère : X = largeur, Y = hauteur, Z = longueur. Unité = pied.
   ============================================================ */

function V(x,y,z){ return {x:x,y:y,z:z}; }
function sub(a,b){ return V(a.x-b.x,a.y-b.y,a.z-b.z); }
function add(a,b){ return V(a.x+b.x,a.y+b.y,a.z+b.z); }
function mul(a,k){ return V(a.x*k,a.y*k,a.z*k); }
function cross(a,b){ return V(a.y*b.z-a.z*b.y, a.z*b.x-a.x*b.z, a.x*b.y-a.y*b.x); }
function dot(a,b){ return a.x*b.x+a.y*b.y+a.z*b.z; }
function len3(a){ return Math.sqrt(dot(a,a)); }
function norm(a){ var l=len3(a)||1; return V(a.x/l,a.y/l,a.z/l); }
function lerp3(a,b,t){ return V(a.x+(b.x-a.x)*t, a.y+(b.y-a.y)*t, a.z+(b.z-a.z)*t); }

/* Logo Tempo, chargé une fois et appliqué sur les deux pignons */
var LOGO = null;
if(typeof Image === "function" && window.TEMPO_LOGO){
  LOGO = new Image();
  LOGO.onload = function(){ if(window.TEMPO_REDRAW) window.TEMPO_REDRAW(); };
  LOGO.src = window.TEMPO_LOGO;
}

var SUN  = norm(V(-0.42,0.80,0.43));   // soleil principal
var FILL = norm(V(0.55,0.28,-0.55));   // lumière d'appoint, côté opposé
var NEAR = 0.35;

function Viz(canvas, stage){
  this.cv = canvas; this.stage = stage;
  this.ctx = canvas.getContext("2d");
  this.yaw = -0.46; this.pitch = 0.20; this.dist = 46;
  this.target = V(0,3.2,0);
  this.showVeh = true; this.top = false;
  this.scene = null; this.dpr = 1;
  this._bind();
}

Viz.prototype._bind = function(){
  var s = this, drag=null;
  function pt(e){ var t = e.touches ? e.touches[0] : e; return {x:t.clientX, y:t.clientY}; }
  function down(e){
    if(e.touches && e.touches.length>1){ drag=null; s._pinch = s._d2(e); return; }
    drag = pt(e); s.onInteract && s.onInteract();
  }
  function move(e){
    if(e.touches && e.touches.length>1 && s._pinch){
      var d = s._d2(e);
      s.dist = Math.max(12, Math.min(180, s.dist * s._pinch/d));
      s._pinch = d; e.preventDefault(); s.draw(); return;
    }
    if(!drag) return;
    var p = pt(e);
    s.yaw   -= (p.x-drag.x)*0.008;
    s.pitch += (p.y-drag.y)*0.006;
    s.pitch = Math.max(-0.05, Math.min(1.45, s.pitch));
    drag = p; if(e.cancelable) e.preventDefault();
    s.top=false; s.onView&&s.onView(); s.draw();
  }
  function up(){ drag=null; s._pinch=null; }
  var st = this.stage;
  st.addEventListener("mousedown",down);
  window.addEventListener("mousemove",move);
  window.addEventListener("mouseup",up);
  st.addEventListener("touchstart",down,{passive:true});
  st.addEventListener("touchmove",move,{passive:false});
  st.addEventListener("touchend",up);
  st.addEventListener("wheel",function(e){
    e.preventDefault();
    s.dist = Math.max(12, Math.min(180, s.dist * (1 + (e.deltaY>0?0.11:-0.11))));
    s.onInteract && s.onInteract(); s.draw();
  },{passive:false});
};
Viz.prototype._d2 = function(e){
  var a=e.touches[0], b=e.touches[1];
  return Math.hypot(a.clientX-b.clientX, a.clientY-b.clientY);
};

Viz.prototype.resize = function(){
  var r = this.stage.getBoundingClientRect();
  if(!r.width) return false;
  this.dpr = Math.min(window.devicePixelRatio||1, 2);
  this.cv.width  = Math.round(r.width  * this.dpr);
  this.cv.height = Math.round(r.height * this.dpr);
  this.W = r.width; this.H = r.height;
  return true;
};
Viz.prototype.reset = function(){
  this.yaw=-0.46; this.pitch=0.20; this.top=false;
  this.dist = this.scene ? this._fit() : 46;
  this.draw();
};
Viz.prototype._fit = function(){
  var s = this.scene;
  var r = Math.sqrt(Math.pow(s.len/2+2.5,2) + Math.pow(s.w/2+2.5,2));
  var ar = this.H ? this.W/this.H : 1.3;
  return Math.max(15, r * (ar<1 ? 2.45 : 1.85));
};
Viz.prototype.setTop = function(on){
  this.top = on;
  if(on){ this.pitch = 1.42; this.yaw = 0; }
  else  { this.pitch = 0.20; this.yaw = -0.46; }
  this.dist = this._fit();
  this.draw();
};

/* ---------- caméra ---------- */
Viz.prototype._cam = function(){
  var t=this.target, d=this.dist, p=this.pitch, y=this.yaw;
  var cam = V(t.x + d*Math.cos(p)*Math.sin(y), t.y + d*Math.sin(p), t.z + d*Math.cos(p)*Math.cos(y));
  var fwd = norm(sub(t,cam));
  var up  = Math.abs(fwd.y)>0.985 ? V(0,0,-1) : V(0,1,0);
  var rt  = norm(cross(fwd,up));
  return {p:cam, f:fwd, r:rt, u:cross(rt,fwd)};
};
Viz.prototype._toCam = function(c,p){
  var v = sub(p,c.p); return V(dot(v,c.r), dot(v,c.u), dot(v,c.f));
};
Viz.prototype._proj = function(q){
  return { x:this.W/2 + this.foc*q.x/q.z, y:this.H/2 - this.foc*q.y/q.z, z:q.z };
};
function clipNear(pts){
  var out=[], n=pts.length;
  for(var i=0;i<n;i++){
    var a=pts[i], b=pts[(i+1)%n], ai=a.z>=NEAR, bi=b.z>=NEAR;
    if(ai) out.push(a);
    if(ai!==bi) out.push(lerp3(a,b,(NEAR-a.z)/(b.z-a.z)));
  }
  return out;
}

/* ============================================================
   CONSTRUCTION
   ============================================================ */
Viz.prototype.build = function(cfg){
  this.scene = cfg;
  var m=cfg.model, w=cfg.w, L=cfg.len, ch=cfg.h, rise=cfg.rise, roof=m.roof, arc=m.arc;
  var hw=w/2, hwb, peak=ch+rise;
  var z0=-L/2, z1=L/2;
  var F=[], S=[];
  this.center = V(0, peak*0.45, 0);

  /* --- profil de l'arche, d'après les fiches « Mesures abris pour toiles » ---
     ground = largeur au sol · bar = largeur à la barre de porte · rise = pignon */
  var G = (m.geo||{}), shape = G.shape || "taper";
  var gW = G.ground || w, bW = G.bar || w;
  if(shape==="straight" || shape==="round"){ gW = w; bW = w; }
  var hg = gW/2, hb = bW/2;
  hw = hg;                                   // l'emprise au sol reste la référence
  var prof;
  if(shape==="shed"){
    /* Monopente : montant bas incliné d'un côté, montant haut vertical de l'autre.
       Toit d'un seul pan, du bas vers le haut. */
    prof = [[-hg,0], [-hg+(gW-bW), ch], [hg, ch+rise], [hg, 0]];
  } else if(shape==="round"){
    /* Double Rond : mur presque droit qui s'enroule en arche continue. */
    var y0 = ch*0.46, top = ch+rise, n2 = 9;
    prof = [[-hg,0],[-hg,y0]];
    for(var i=1;i<=n2;i++){
      var a=(i/n2)*(Math.PI/2);
      prof.push([-hg*Math.cos(a), y0+(top-y0)*Math.sin(a)]);
    }
    for(var i2=n2-1;i2>=1;i2--){
      var a2=(i2/n2)*(Math.PI/2);
      prof.push([hg*Math.cos(a2), y0+(top-y0)*Math.sin(a2)]);
    }
    prof.push([hg,y0]); prof.push([hg,0]);
  } else if(shape==="shoulder"){
    /* 12' TA : montants droits sur toute la hauteur utile, épaulement court,
       puis pignon surbaissé. C'est ce qui donne 12 pi au sol comme en haut. */
    var sy = ch*0.80;
    prof = [[-hg,0],[-hg,sy],[-hb,ch],[0,ch+rise],[hb,ch],[hg,sy],[hg,0]];
  } else if(shape==="straight"){
    prof = [[-hg,0],[-hg,ch],[0,ch+rise],[hg,ch],[hg,0]];
  } else {
    /* Simple 11' : le mur s'incline dès le sol, de 11 pi à 8'11". */
    prof = [[-hg,0],[-hb,ch],[0,ch+rise],[hb,ch],[hg,0]];
  }
  var hwb = hb;

  /* x du profil à une hauteur donnée, côté gauche (-1) ou droit (+1) */
  function xAt(y,side){
    var best=null;
    for(var i=0;i<prof.length-1;i++){
      var a=prof[i], b=prof[i+1];
      if((a[1]-y)*(b[1]-y)<=0 && a[1]!==b[1]){
        var t=(y-a[1])/(b[1]-a[1]), x=a[0]+(b[0]-a[0])*t;
        if(side<0 ? x<=0 : x>=0){ if(best===null || Math.abs(x)>Math.abs(best)) best=x; }
      }
    }
    return best===null ? side*hwb : best;
  }

  var nArch = Math.max(2, Math.round(L/arc)+1);
  var step  = L/(nArch-1);

  /* --- structure : arches + pannes --- */
  var FRAME = "#8A97A5", FRAME_D = "#6B7885";
  for(var a2=0;a2<nArch;a2++){
    var z = z0 + a2*step;
    var edge = (a2===0 || a2===nArch-1);
    for(var i2=0;i2<prof.length-1;i2++){
      S.push({a:V(prof[i2][0],prof[i2][1],z), b:V(prof[i2+1][0],prof[i2+1][1],z),
              w: edge?2.6:2.0, c: edge?FRAME_D:FRAME});
    }
  }
  var rails = roof==="gable" ? [[0,peak],[-hwb,ch],[hwb,ch]]
            : roof==="shed"  ? [[-hwb,ch],[hwb,ch+rise]]
            : [[0,peak],[-hwb*0.70,ch*0.94],[hwb*0.70,ch*0.94],[-hwb,ch*0.70],[hwb,ch*0.70]];
  for(var r2=0;r2<rails.length;r2++)
    S.push({a:V(rails[r2][0],rails[r2][1],z0), b:V(rails[r2][0],rails[r2][1],z1), w:1.8, c:FRAME});

  /* --- toile : opaque, découpée travée par travée --- */
  var TARP = cfg.tarpColor || [250,250,247];
  for(var i3=0;i3<prof.length-1;i3++){
    var p1=prof[i3], p2=prof[i3+1];
    for(var bay=0;bay<nArch-1;bay++){
      var za=z0+bay*step, zb=z0+(bay+1)*step;
      F.push({ pts:[V(p1[0],p1[1],za), V(p2[0],p2[1],za), V(p2[0],p2[1],zb), V(p1[0],p1[1],zb)],
               col:TARP, kind:"tarp" });
    }
  }

  /* --- murs de bout : l'ouverture fait TOUTE la largeur, jusqu'à la barre de porte.
     Les deux pans de toile sont roulés et sanglés contre les montants. --- */
  var dh = ch;
  var barL = xAt(ch,-1), barR = xAt(ch,1);
  var dw = Math.max(Math.abs(barL), Math.abs(barR));
  var self = this;
  var gableMid = null;
  function endWall(z){
    /* Tout ce qui dépasse la barre de porte reste fermé : c'est le pignon. */
    var top=[V(barL,ch,z)];
    for(var i=0;i<prof.length;i++) if(prof[i][1] > ch+1e-6) top.push(V(prof[i][0],prof[i][1],z));
    top.push(V(barR,ch,z));
    if(top.length>=3){
      F.push({pts:top, col:TARP, kind:"end"});
      if(gableMid===null){
        var cx=0, cy=0;
        for(var k=0;k<top.length;k++){ cx+=top[k].x/top.length; cy+=top[k].y/top.length; }
        gableMid={x:cx,y:cy};
      }
    }
    S.push({a:V(barL,dh,z), b:V(barR,dh,z), w:2.6, c:FRAME_D});
    roll(F,S,barL, dh, z, -1);
    roll(F,S,barR, dh, z,  1);
  }
  function roll(F,S,x,h,z,side){
    var R=0.34, seg=8, cx=x-side*R*1.05;
    for(var i=0;i<seg;i++){
      var a1=Math.PI*2*i/seg, a2=Math.PI*2*(i+1)/seg;
      F.push({pts:[V(cx+Math.cos(a1)*R,0.05,z+Math.sin(a1)*R),
                   V(cx+Math.cos(a2)*R,0.05,z+Math.sin(a2)*R),
                   V(cx+Math.cos(a2)*R,h,  z+Math.sin(a2)*R),
                   V(cx+Math.cos(a1)*R,h,  z+Math.sin(a1)*R)], col:[255,255,252], kind:"roll"});
    }
    F.push({pts:[V(cx-R,h,z-R),V(cx+R,h,z-R),V(cx+R,h,z+R),V(cx-R,h,z+R)], col:[248,248,244], kind:"roll"});
    for(var k=1;k<=2;k++){
      var y=h*k/3;
      S.push({a:V(cx-R*1.2,y,z-R*1.2), b:V(cx+R*1.2,y,z+R*1.2), w:2.2, c:"#E52329"});
    }
  }
  endWall(z0); endWall(z1);

  /* --- jupe de toile au sol : la toile déborde et se plaque au sol --- */
  var skirt = 0.85;
  F.push({pts:[V(-hw,0,z0),V(-hw,0,z1),V(-hw-skirt,0.02,z1+skirt*0.4),V(-hw-skirt,0.02,z0-skirt*0.4)], col:TARP, kind:"skirt"});
  F.push({pts:[V( hw,0,z0),V( hw+skirt,0.02,z0-skirt*0.4),V( hw+skirt,0.02,z1+skirt*0.4),V( hw,0,z1)], col:TARP, kind:"skirt"});

  /* --- fenêtres en ogive, livrées bouchées --- */
  var nWin = cfg.windows||0;
  if(nWin>0 && L>=8){
    var wy = Math.max(1.1, ch*0.30), wh = Math.min(2.6, ch*0.44), ww2 = Math.min(1.45, step*0.34);
    /* toujours centrées dans la PREMIÈRE section, jamais sur un montant */
    var zs = [z1 - step/2];
    if(nWin>=4) zs.push(z0 + step/2);
    for(var si=-1; si<=1; si+=2)
      for(var zi=0; zi<zs.length; zi++)
        window_(F,S,si,zs[zi],wy,wh,ww2);
  }
  function window_(F,S,side,zc,y0,hgt,halfW){
    /* x du mur à une hauteur donnée, décalé de 1 cm vers l'extérieur */
    function wx(y){
      var t = Math.min(1, Math.max(0,y)/ch);
      var x = (shape==="straight"||shape==="shoulder") ? hg : hg + (hb-hg)*t;
      return side*(x+0.06);
    }
    var top=y0+hgt, sh=top-hgt*0.30, pts=[];
    pts.push(V(wx(y0), y0, zc-halfW));
    pts.push(V(wx(y0), y0, zc+halfW));
    pts.push(V(wx(sh), sh, zc+halfW));
    var seg2=5;
    for(var i=1;i<seg2;i++){
      var a=Math.PI*(i/seg2);
      pts.push(V(wx(sh+Math.sin(a)*(top-sh)), sh+Math.sin(a)*(top-sh), zc+Math.cos(a)*halfW));
    }
    pts.push(V(wx(sh), sh, zc-halfW));
    F.push({pts:pts, col:[176,192,206], kind:"win"});
    for(var k=0;k<pts.length;k++)
      S.push({a:pts[k], b:pts[(k+1)%pts.length], w:1.5, c:"#7E8C9A"});
  }

  /* --- festons : les boucles élastiques au bas des murs, à l'intérieur --- */
  var fy = Math.min(1.0, ch*0.16), nf = Math.max(2, Math.round(L/1.6));
  for(var fi=0; fi<nf; fi++){
    var za=z0+L*fi/nf, zb2=z0+L*(fi+1)/nf, zm=(za+zb2)/2;
    for(var fs=-1; fs<=1; fs+=2){
      var xw = fs*(hw + (hwb-hw)*(fy/ch));
      S.push({a:V(xw,fy,za), b:V(fs*(hw+(hwb-hw)*(fy*0.55/ch)),fy*0.55,zm), w:0.9, c:"#B9C3CD"});
      S.push({a:V(fs*(hw+(hwb-hw)*(fy*0.55/ch)),fy*0.55,zm), b:V(xw,fy,zb2), w:0.9, c:"#B9C3CD"});
    }
  }

  /* --- emplacement du logo sur le pignon avant --- */
  var gm = gableMid || {x:0, y:ch+rise*0.45};
  var lw = Math.min(w*0.22, 2.8), lh = lw*0.40;
  var lx = gm.x, ly = gm.y;
  this.logoQuad = [ V(lx-lw/2, ly+lh/2, z1+0.02), V(lx+lw/2, ly+lh/2, z1+0.02),
                    V(lx+lw/2, ly-lh/2, z1+0.02), V(lx-lw/2, ly-lh/2, z1+0.02) ];
  this.logoQuadBack = [ V(lx+lw/2, ly+lh/2, z0-0.02), V(lx-lw/2, ly+lh/2, z0-0.02),
                        V(lx-lw/2, ly-lh/2, z0-0.02), V(lx+lw/2, ly-lh/2, z0-0.02) ];

  /* --- porte de côté, à la section et au côté choisis --- */
  if(cfg.door && nArch>=4){
    var sd = (cfg.doorSide===1?1:-1);
    var bay = Math.min(nArch-3, Math.max(1, cfg.doorBay||Math.floor((nArch-1)/2)));
    var zc  = z0 + (bay+0.5)*step;
    var sdh = Math.min(ch*0.90, ch-0.30), sdw = Math.min(1.45, step*0.36);
    function px(y){
      var t=Math.min(1,Math.max(0,y)/ch);
      var x=(shape==="straight"||shape==="shoulder") ? hg : hg + (hb-hg)*t;
      return sd*(x+0.10);
    }
    var dpts=[V(px(0.03),0.03,zc-sdw), V(px(0.03),0.03,zc+sdw), V(px(sdh),sdh,zc+sdw), V(px(sdh),sdh,zc-sdw)];
    F.push({pts:dpts, col:[228,232,236], kind:"sd", bias:true});
    for(var di=0;di<4;di++) S.push({a:dpts[di], b:dpts[(di+1)%4], w:2.2, c:"#5E6B78"});
    S.push({a:V(px(sdh),sdh,zc), b:V(px(0.03),0.03,zc), w:1.4, c:"#8B98A6"});
  }

  /* --- véhicules --- */
  this.vehFaces = [];
  if(cfg.veh){
    var v=cfg.veh, n=v.n||1, spots;
    if(v.mode==="cote"){ var g=w/4; spots=[{x:-g,z:0},{x:g,z:0}]; }
    else if(v.mode==="file"){ spots=[{x:0,z:-L/4-0.6},{x:0,z:L/4+0.6}]; }
    else spots=[{x:0,z:0}];
    for(var k2=0;k2<n && k2<spots.length;k2++)
      this._car(this.vehFaces, spots[k2].x, spots[k2].z, v.w, v.h, v.l, k2);
  }

  this.faces=F; this.segs=S; this.labels=cfg.labels||null; this.ori=cfg.ori||null;
  this.target = V(0, Math.max(2.0, peak*0.40), 0);
  return this;
};

Viz.prototype._car = function(out, cx, cz, vw, vh, vl, idx){
  var col   = idx===0 ? [42,84,140] : [154,58,54];
  var glass = [44,52,64], tire=[24,26,30], trim=[38,42,48];
  var wr=vh*0.155, ww=0.62, floor=wr*0.80, beltH=vh*0.58;
  var hw=vw/2, hwTop=hw*0.90;                 // carrosserie légèrement fuselée
  var zf=cz+vl/2, zb=cz-vl/2;

  /* caisse fuselée : 8 sommets, plus large en bas qu'en haut */
  quadBox([[-hw,floor,zb],[hw,floor,zb],[hwTop,beltH,zb],[-hwTop,beltH,zb],
           [-hw,floor,zf],[hw,floor,zf],[hwTop,beltH,zf],[-hwTop,beltH,zf]], col);
  /* bas de caisse plus sombre : donne du poids au véhicule */
  quadBox([[-hw,0.04,zb+0.15],[hw,0.04,zb+0.15],[hw,floor,zb+0.15],[-hw,floor,zb+0.15],
           [-hw,0.04,zf-0.15],[hw,0.04,zf-0.15],[hw,floor,zf-0.15],[-hw,floor,zf-0.15]], trim);
  /* habitacle : nettement plus étroit, décalé vers l'arrière */
  var cw=hw*0.76, cwTop=cw*0.86, cz0=cz-vl*0.30, cz1=cz0+vl*0.40;
  quadBox([[-cw,beltH,cz0],[cw,beltH,cz0],[cwTop,vh,cz0],[-cwTop,vh,cz0],
           [-cw,beltH,cz1],[cw,beltH,cz1],[cwTop,vh,cz1],[-cwTop,vh,cz1]], glass);
  /* roues */
  var wz=[cz-vl*0.30, cz+vl*0.31];
  for(var i=0;i<2;i++) for(var sg=-1;sg<=1;sg+=2){
    var x0=cx+sg*(hw-ww*0.42)-ww/2;
    box(x0, 0.02, wz[i]-wr, ww, wr*2, wr*2, tire);
  }
  function quadBox(P,c){
    /* P : 8 points [x,y,z] en repère véhicule, translatés en x par cx */
    var A=P.map(function(p){ return V(p[0]+cx, p[1], p[2]); });
    var f=[[0,1,2,3],[5,4,7,6],[4,0,3,7],[1,5,6,2],[3,2,6,7],[4,5,1,0]];
    for(var i=0;i<6;i++) out.push({pts:f[i].map(function(j){ return A[j]; }), col:c, kind:"veh"});
  }
  function box(x,y,z,dx,dy,dz,c){
    quadBoxRaw([[x,y,z],[x+dx,y,z],[x+dx,y+dy,z],[x,y+dy,z],
                [x,y,z+dz],[x+dx,y,z+dz],[x+dx,y+dy,z+dz],[x,y+dy,z+dz]],c);
  }
  function quadBoxRaw(P,c){
    var A=P.map(function(p){ return V(p[0],p[1],p[2]); });
    var f=[[0,1,2,3],[5,4,7,6],[4,0,3,7],[1,5,6,2],[3,2,6,7],[4,5,1,0]];
    for(var i=0;i<6;i++) out.push({pts:f[i].map(function(j){ return A[j]; }), col:c, kind:"veh"});
  }
};

/* ============================================================
   RENDU
   ============================================================ */
var SOIL = {
  asphalte:{c:[92,94,99],  g:"rgba(255,255,255,.10)", step:4},
  beton:   {c:[198,197,192],g:"rgba(120,120,116,.28)", step:4},
  pave:    {c:[190,170,154],g:"rgba(255,255,255,.40)", step:2},
  gazon:   {c:[136,164,110],g:"rgba(255,255,255,.11)", step:4},
  gravier: {c:[182,177,168],g:"rgba(255,255,255,.20)", step:4},
  none:    {c:[206,209,212],g:"rgba(255,255,255,.28)", step:4}
};

Viz.prototype.draw = function(){
  if(!this.scene) return;
  if(!this.cv.width && !this.resize()) return;
  var ctx=this.ctx, W=this.W, H=this.H, s=this;
  this.foc = Math.min(W,H) * (this.top?1.15:1.02);
  ctx.save();
  ctx.setTransform(this.dpr,0,0,this.dpr,0,0);
  ctx.clearRect(0,0,W,H);

  var c=this._cam(), draw=[];
  var L=this.scene.len, w=this.scene.w, hw=w/2, ctr=this.center;

  /* dalle */
  var gx=hw+Math.max(3.2,w*0.26), gz=L/2+Math.max(3.6,L*0.13);
  var so=SOIL[this.scene.soil]||SOIL.none;
  poly([V(-gx,0,-gz),V(gx,0,-gz),V(gx,0,gz),V(-gx,0,gz)], so.c, 1, {flat:true});
  for(var g=-Math.floor(gx/so.step)*so.step; g<=gx; g+=so.step) line(V(g,.012,-gz),V(g,.012,gz),0.5,so.g);
  for(var g2=-Math.floor(gz/so.step)*so.step; g2<=gz; g2+=so.step) line(V(-gx,.012,g2),V(gx,.012,g2),0.5,so.g);

  /* ombre portée, projetée depuis le soleil */
  var sh=[], pk=this.scene.h+(this.scene.rise||2);
  var k=pk/SUN.y*0.85;
  sh.push(V(-hw,0,-L/2)); sh.push(V(hw,0,-L/2));
  sh.push(V(hw - SUN.x*k, 0, -L/2 - SUN.z*k));
  sh.push(V(-hw - SUN.x*k, 0, L/2 - SUN.z*k));
  sh.push(V(-hw,0,L/2));
  poly([V(-hw-.3,.02,-L/2-.3),V(hw+.3,.02,-L/2-.3),
        V(hw+.3-SUN.x*k,.02,L/2+.3-SUN.z*k),V(-hw-.3-SUN.x*k,.02,L/2+.3-SUN.z*k)],
       [26,30,38], 0.17, {flat:true});
  poly([V(-hw-.2,.03,-L/2-.2),V(hw+.2,.03,-L/2-.2),V(hw+.2,.03,L/2+.2),V(-hw-.2,.03,L/2+.2)],
       [24,28,34], 0.14, {flat:true});

  if(this.showVeh && this.vehFaces)
    for(var i=0;i<this.vehFaces.length;i++) poly(this.vehFaces[i].pts, this.vehFaces[i].col, 1, {two:true});
  for(var i2=0;i2<this.faces.length;i2++){
    var f=this.faces[i2];
    poly(f.pts, f.col, 1,
         {two:f.kind!=="win" && f.kind!=="skirt", seam:(f.kind==="tarp"||f.kind==="end"),
          bias:(f.kind==="win"||f.kind==="sd")?0.3:0});
  }
  for(var i3=0;i3<this.segs.length;i3++) line(this.segs[i3].a, this.segs[i3].b, this.segs[i3].w, this.segs[i3].c);

  draw.sort(function(a,b){ return b.z-a.z; });
  for(var d=0;d<draw.length;d++){
    var it=draw[d];
    if(it.k==="p"){
      ctx.beginPath(); ctx.moveTo(it.pts[0].x,it.pts[0].y);
      for(var j=1;j<it.pts.length;j++) ctx.lineTo(it.pts[j].x,it.pts[j].y);
      ctx.closePath(); ctx.fillStyle=it.fill; ctx.fill();
      if(it.stroke){ ctx.lineWidth=it.sw; ctx.strokeStyle=it.stroke; ctx.stroke(); }
    } else {
      ctx.beginPath(); ctx.moveTo(it.a.x,it.a.y); ctx.lineTo(it.b.x,it.b.y);
      ctx.lineWidth=it.w; ctx.strokeStyle=it.c; ctx.lineCap="round"; ctx.stroke();
    }
  }

  /* logo Tempo sur la toile — mappage affine des 3 premiers coins */
  if(LOGO && LOGO.complete && LOGO.naturalWidth){
    drawLogo(this.logoQuad); drawLogo(this.logoQuadBack);
  }
  function drawLogo(q){
    if(!q) return;
    var cm = q.map(function(p){ return s._toCam(c,p); });
    for(var i=0;i<cm.length;i++) if(cm[i].z < NEAR) return;
    /* visible seulement si la face nous regarde */
    var n = norm(cross(sub(q[1],q[0]), sub(q[3],q[0])));
    var mid = V((q[0].x+q[2].x)/2,(q[0].y+q[2].y)/2,(q[0].z+q[2].z)/2);
    if(dot(n, sub(mid,ctr)) < 0) n = mul(n,-1);
    if(dot(n, sub(c.p,mid)) <= 0.02) return;
    var P = cm.map(function(v){ return s._proj(v); });
    var wpx = Math.hypot(P[1].x-P[0].x, P[1].y-P[0].y);
    if(wpx < 14) return;
    var k = s.dpr;                                  // le contexte est déjà à l'échelle dpr
    var ax=(P[1].x-P[0].x)/LOGO.naturalWidth,  ay=(P[1].y-P[0].y)/LOGO.naturalWidth;
    var bx=(P[3].x-P[0].x)/LOGO.naturalHeight, by=(P[3].y-P[0].y)/LOGO.naturalHeight;
    ctx.save();
    ctx.globalAlpha = 0.94;
    ctx.setTransform(ax*k, ay*k, bx*k, by*k, P[0].x*k, P[0].y*k);
    ctx.drawImage(LOGO, 0, 0);
    ctx.restore();
    ctx.setTransform(k,0,0,k,0,0);
  }

  /* repères d'orientation : on comprend tout de suite comment l'abri est posé */
  if(this.ori && !this.top){
    ori(V(0,0.02,gz+1.4),  this.ori.front);
    ori(V(0,0.02,-gz-1.4), this.ori.back);
    ori(V(-gx-1.4,0.02,0), this.ori.left);
    ori(V(gx+1.4,0.02,0),  this.ori.right);
  } else if(this.ori && this.top){
    ori(V(0,0.1,gz+1.1),  this.ori.front);
    ori(V(0,0.1,-gz-1.1), this.ori.back);
    ori(V(-gx-1.1,0.1,0), this.ori.left);
    ori(V(gx+1.1,0.1,0),  this.ori.right);
  }
  function ori(p,text){
    if(!text) return;
    var q=s._toCam(c,p); if(q.z<NEAR) return;
    var sp=s._proj(q);
    if(sp.x<-60||sp.x>W+60||sp.y<-20||sp.y>H+20) return;
    ctx.font='800 10px -apple-system,"Segoe UI",Roboto,sans-serif';
    ctx.textAlign="center"; ctx.textBaseline="middle";
    var wd=ctx.measureText(text).width+13;
    ctx.fillStyle="rgba(255,255,255,.72)";
    rr(sp.x-wd/2, sp.y-8, wd, 16, 8); ctx.fill();
    ctx.fillStyle="rgba(85,94,106,.98)";
    ctx.fillText(text, sp.x, sp.y+0.5);
  }

  /* cotes */
  if(this.labels){
    var sx=(c.p.x<0?-1:1), sz=(c.p.z<0?-1:1);
    tag(V(sx*hw*0.55, this.top?0.1:-0.28, sz*(gz-1.3)), this.labels.w);  // largeur, au bout visible
    tag(V(sx*(gx-0.5), this.top?0.1:-0.28, -sz*L*0.24), this.labels.l);  // longueur, le long du côté visible
    if(!this.top) tag(V(sx*(hw+1.7), this.scene.h*0.52, sz*(L/2+0.5)), this.labels.h);  // hauteur, au poteau de coin
  }
  ctx.restore();

  function tag(p,text){
    if(!text) return;
    var q=s._toCam(c,p); if(q.z<NEAR) return;
    var sp=s._proj(q);
    if(sp.x<-50||sp.x>W+50||sp.y<-30||sp.y>H+30) return;
    ctx.font='700 11px -apple-system,"Segoe UI",Roboto,sans-serif';
    ctx.textAlign="center"; ctx.textBaseline="middle";
    var wd=ctx.measureText(text).width+15;
    ctx.fillStyle="rgba(18,20,23,.82)";
    rr(sp.x-wd/2, sp.y-9.5, wd, 19, 9.5); ctx.fill();
    ctx.fillStyle="#fff"; ctx.fillText(text, sp.x, sp.y+0.5);
  }
  function rr(x,y,w2,h2,r){
    ctx.beginPath(); ctx.moveTo(x+r,y); ctx.lineTo(x+w2-r,y);
    ctx.quadraticCurveTo(x+w2,y,x+w2,y+r); ctx.lineTo(x+w2,y+h2-r);
    ctx.quadraticCurveTo(x+w2,y+h2,x+w2-r,y+h2); ctx.lineTo(x+r,y+h2);
    ctx.quadraticCurveTo(x,y+h2,x,y+h2-r); ctx.lineTo(x,y+r);
    ctx.quadraticCurveTo(x,y,x+r,y); ctx.closePath();
  }
  function poly(pts, col, alpha, o){
    var cam = pts.map(function(p){ return s._toCam(c,p); });
    cam = clipNear(cam);
    if(cam.length<3) return;
    var scr = cam.map(function(q){ return s._proj(q); });
    var lum;
    if(o.flat){ lum = 1; }
    else {
      var n = newell(pts);
      var mid = V(0,0,0), N=pts.length;
      for(var q2=0;q2<N;q2++){ mid.x+=pts[q2].x/N; mid.y+=pts[q2].y/N; mid.z+=pts[q2].z/N; }
      /* normale orientée vers l'extérieur de l'abri */
      if(dot(n, sub(mid,ctr)) < 0) n = mul(n,-1);
      lum = 0.70 + 0.28*Math.max(0,dot(n,SUN)) + 0.13*Math.max(0,dot(n,FILL));
      /* face vue de l'intérieur : plus sombre, c'est ce qui donne la profondeur */
      if(o.two && dot(n, sub(c.p,mid)) < 0) lum *= 0.60;
    }
    var r=Math.min(255,col[0]*lum), g3=Math.min(255,col[1]*lum), b=Math.min(255,col[2]*lum);
    var zz=0; for(var i4=0;i4<cam.length;i4++) zz+=cam[i4].z; zz/=cam.length;
    var it={ k:"p", pts:scr, z:zz-(o.bias||0), fill:"rgba("+(r|0)+","+(g3|0)+","+(b|0)+","+alpha+")" };
    if(o.seam){ it.stroke="rgba(120,130,142,.28)"; it.sw=0.8; }
    draw.push(it);
  }
  function line(a,b,wd,col){
    var A=s._toCam(c,a), B=s._toCam(c,b);
    if(A.z<NEAR && B.z<NEAR) return;
    if(A.z<NEAR) A=lerp3(A,B,(NEAR-A.z)/(B.z-A.z));
    if(B.z<NEAR) B=lerp3(B,A,(NEAR-B.z)/(A.z-B.z));
    var zz=(A.z+B.z)/2;
    draw.push({k:"s", a:s._proj(A), b:s._proj(B), z:zz-0.06, c:col, w:Math.max(0.7, wd*46/zz)});
  }
  function newell(p){
    var n=V(0,0,0);
    for(var i=0;i<p.length;i++){
      var a=p[i], b=p[(i+1)%p.length];
      n.x+=(a.y-b.y)*(a.z+b.z); n.y+=(a.z-b.z)*(a.x+b.x); n.z+=(a.x-b.x)*(a.y+b.y);
    }
    return norm(n);
  }
};

window.TEMPO_VIZ = Viz;
})();

/* ============================================================
   ABRIS TEMPO — Moteur 3D Three.js
   ------------------------------------------------------------
   Remplace le visualiseur Canvas 2D quand Three.js est chargé.
   Si le bundle n'est pas là, l'ancien moteur reste en place et
   l'outil fonctionne quand même : window.TEMPO_VIZ n'est
   réassigné qu'en cas de succès.

   Unité de travail : le pied. X = largeur, Y = hauteur, Z = longueur.
   Géométrie tirée des fiches « Mesures abris pour toiles » :
     C = largeur au sol · B = longueur de la barre de porte
     A = hauteur libre (à la barre de porte)
     E = flèche du pignon mesurée sur le cadre
     D = A + so + E  (so = décalage barre de porte → épaulement)
   ============================================================ */
(function(){
"use strict";
var THREE = window.THREE;
if(!THREE || !THREE.WebGLRenderer) return;          /* on garde le moteur 2D */

var D = window.TEMPO_DATA;
var PI = Math.PI;

/* ---------- constantes de structure ---------- */
var TUBE     = 0.07;      /* rayon des tubes */
var TUBE_END = 0.085;     /* arches de bout, plus grosses */
var IN       = 0.11;      /* retrait du cadre sous la toile (piège n°1) */
var Z_IN     = 0.09;      /* retrait en Z des arches de bout */
var RENF_L   = 4.0;       /* renfort d'arche : 48 po (pièce RENF) */
var ENTRE_BAS= 0.13;      /* entretoise au bas des pattes */
var ENTRE_D  = 0.70;      /* entretoises sous les coins */
var ENTRE_MIN= 5.00;      /* jamais plus bas que 5 pi du sol */
var SD_W     = 4.0;       /* porte de côté : 48 po (BPEZ4) */
var SD_H     = 70/12;     /* porte de côté : fermoir de 70 po (FERM70) */
var ROOF_LAP = 0.085;     /* débord du toit sur le joint (piège n°2) */

/* ---------- couleurs ---------- */
var C_TARP  = 0xffffff;
var C_FRAME = 0x9AA6B2;
var C_ROUGE = 0xE52329;

/* ============================================================
   TEXTURES PROCÉDURALES — sols
   ============================================================ */
var SOIL_CACHE = {};
function soilTexture(kind){
  if(SOIL_CACHE[kind]) return SOIL_CACHE[kind];
  var S = 256, cv = document.createElement("canvas");
  cv.width = cv.height = S;
  var c = cv.getContext("2d"), i, j, x, y;

  function noise(a, dark, light){
    var img = c.getImageData(0,0,S,S), d = img.data;
    for(i=0;i<d.length;i+=4){
      var n = (Math.random()-0.5)*a;
      d[i]  =Math.max(0,Math.min(255,d[i]  +n));
      d[i+1]=Math.max(0,Math.min(255,d[i+1]+n));
      d[i+2]=Math.max(0,Math.min(255,d[i+2]+n));
    }
    c.putImageData(img,0,0);
  }

  if(kind==="asphalte"){
    c.fillStyle="#43474C"; c.fillRect(0,0,S,S); noise(46);
    for(i=0;i<900;i++){
      c.fillStyle="rgba("+(90+Math.random()*60|0)+",95,100,.5)";
      c.fillRect(Math.random()*S, Math.random()*S, 1.6, 1.6);
    }
  } else if(kind==="beton"){
    c.fillStyle="#B9BCBE"; c.fillRect(0,0,S,S); noise(20);
    c.strokeStyle="rgba(120,124,128,.75)"; c.lineWidth=2;
    for(i=0;i<=S;i+=S/2){ c.beginPath(); c.moveTo(i,0); c.lineTo(i,S); c.moveTo(0,i); c.lineTo(S,i); c.stroke(); }
    for(i=0;i<180;i++){
      c.fillStyle="rgba(160,164,168,.45)";
      c.fillRect(Math.random()*S, Math.random()*S, 2, 2);
    }
  } else if(kind==="pave"){
    var bw = S/4, bh = S/8;
    c.fillStyle="#6E7378"; c.fillRect(0,0,S,S);
    for(j=0;j<8;j++){
      var off = (j%2)*bw/2;
      for(i=-1;i<5;i++){
        var g = 150 + (Math.random()*26|0);
        c.fillStyle="rgb("+g+","+(g-2)+","+(g-6)+")";
        c.fillRect(i*bw+off+1.6, j*bh+1.6, bw-3.2, bh-3.2);
      }
    }
    noise(11);
  } else if(kind==="gazon"){
    c.fillStyle="#4E7A3A"; c.fillRect(0,0,S,S);
    for(i=0;i<5200;i++){
      x=Math.random()*S; y=Math.random()*S;
      var g2 = 90 + (Math.random()*80|0);
      c.strokeStyle="rgba("+(g2*0.45|0)+","+g2+","+(g2*0.42|0)+",.75)";
      c.lineWidth=1;
      c.beginPath(); c.moveTo(x,y); c.lineTo(x+(Math.random()-0.5)*3, y-2-Math.random()*3); c.stroke();
    }
  } else if(kind==="gravier"){
    c.fillStyle="#8E8A82"; c.fillRect(0,0,S,S);
    for(i=0;i<2600;i++){
      var r = 1.4+Math.random()*3.4, g3 = 120+(Math.random()*90|0);
      c.fillStyle="rgb("+g3+","+(g3-6)+","+(g3-18)+")";
      c.beginPath(); c.arc(Math.random()*S, Math.random()*S, r, 0, 6.283); c.fill();
    }
    noise(18);
  } else {                                   /* terre */
    c.fillStyle="#6B5341"; c.fillRect(0,0,S,S); noise(34);
    for(i=0;i<700;i++){
      c.fillStyle="rgba("+(60+Math.random()*40|0)+",45,32,.5)";
      c.fillRect(Math.random()*S, Math.random()*S, 2.5, 2.5);
    }
  }
  var t = new THREE.CanvasTexture(cv);
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  if(THREE.SRGBColorSpace) t.colorSpace = THREE.SRGBColorSpace;
  t.anisotropy = 4;
  SOIL_CACHE[kind] = t;
  return t;
}

/* ---------- décor : ciel et terrain ----------
   Deux textures fabriquées au vol. Le ciel est un dégradé vertical posé
   sur une grande sphère ; le terrain est un disque dont le bord se fond
   dans la couleur d'horizon, pour qu'on ne voie jamais où il s'arrête. */
var HORIZON = "#E9EFF4";
var SKY_TEX=null, LAWN_TEX=null;
function skyTexture(){
  if(SKY_TEX) return SKY_TEX;
  var W=8, H=512, cv=document.createElement("canvas");
  cv.width=W; cv.height=H;
  var c=cv.getContext("2d");
  var g=c.createLinearGradient(0,0,0,H);
  g.addColorStop(0.00,"#8FB0D0");
  g.addColorStop(0.30,"#B9D0E4");
  g.addColorStop(0.52,"#DCE8F1");
  g.addColorStop(0.62,HORIZON);
  g.addColorStop(1.00,"#DFE5E9");
  c.fillStyle=g; c.fillRect(0,0,W,H);
  var t=new THREE.CanvasTexture(cv);
  t.wrapS=THREE.RepeatWrapping;
  if(THREE.SRGBColorSpace) t.colorSpace=THREE.SRGBColorSpace;
  SKY_TEX=t; return t;
}
function landTexture(){
  if(LAWN_TEX) return LAWN_TEX;
  var S=512, cv=document.createElement("canvas");
  cv.width=cv.height=S;
  var c=cv.getContext("2d"), i, x, y;
  c.fillStyle="#9CB585"; c.fillRect(0,0,S,S);
  for(i=0;i<34000;i++){
    x=Math.random()*S; y=Math.random()*S;
    var g2 = 176+(Math.random()*40|0);
    c.strokeStyle="rgba("+((g2*0.88)|0)+","+g2+","+((g2*0.79)|0)+",.30)";
    c.lineWidth=1;
    c.beginPath(); c.moveTo(x,y); c.lineTo(x+(Math.random()-0.5)*2.0, y-1.4-Math.random()*2.0); c.stroke();
  }
  /* le bord se fond dans l'horizon : on ne voit jamais où le terrain s'arrête */
  var g=c.createRadialGradient(S/2,S/2,S*0.05, S/2,S/2,S*0.50);
  g.addColorStop(0.00,"rgba(233,239,244,0)");
  g.addColorStop(0.30,"rgba(233,239,244,0.22)");
  g.addColorStop(0.58,"rgba(233,239,244,0.68)");
  g.addColorStop(0.82,"rgba(233,239,244,0.97)");
  g.addColorStop(1.00,"rgba(233,239,244,1)");
  c.fillStyle=g; c.fillRect(0,0,S,S);
  var t=new THREE.CanvasTexture(cv);
  t.anisotropy=8;
  if(THREE.SRGBColorSpace) t.colorSpace=THREE.SRGBColorSpace;
  LAWN_TEX=t; return t;
}

/* ---------- logo Tempo sur le pignon ----------
   On utilise le vrai logo (PNG transparent embarqué), pas un dessin.
   Il est décodé dès le chargement pour être prêt bien avant que le
   client n'arrive à l'écran de résultat. */
var LOGO_TEX = null, LOGO_RATIO = 1.7476;
function logoTexture(){
  if(LOGO_TEX) return LOGO_TEX;
  if(window.TEMPO_LOGO){
    var img = new Image();
    var t = new THREE.Texture(img);
    t.generateMipmaps = true;
    img.onload = function(){
      LOGO_RATIO = img.width/img.height;
      t.needsUpdate = true;
      if(window.TEMPO_LOGO_READY) window.TEMPO_LOGO_READY();
    };
    img.src = window.TEMPO_LOGO;
    if(THREE.SRGBColorSpace) t.colorSpace = THREE.SRGBColorSpace;
    t.anisotropy = 4;
    LOGO_TEX = t;
    return t;
  }
  /* repli : logo dessiné, si jamais le PNG n'est pas là */
  var W=512, H=293, cv=document.createElement("canvas");
  cv.width=W; cv.height=H;
  var c=cv.getContext("2d");
  c.fillStyle="#e2231a";
  c.beginPath(); c.ellipse(W/2, H/2, W*0.46, H*0.40, 0, 0, 6.283); c.fill();
  c.fillStyle="#fff"; c.textAlign="center"; c.textBaseline="middle";
  c.font="italic 800 104px Georgia,serif";
  c.fillText("Tempo", W/2, H/2+4);
  var t2=new THREE.CanvasTexture(cv);
  if(THREE.SRGBColorSpace) t2.colorSpace = THREE.SRGBColorSpace;
  LOGO_TEX=t2; return t2;
}
try{ logoTexture(); }catch(e){}

/* ---------- étiquette de cote ---------- */
function labelSprite(txt, color){
  var pad=14, fs=44;
  var cv=document.createElement("canvas"), c=cv.getContext("2d");
  c.font="800 "+fs+"px -apple-system,Segoe UI,Arial";
  var w=Math.ceil(c.measureText(txt).width)+pad*2, h=fs+pad*2;
  cv.width=w; cv.height=h;
  c=cv.getContext("2d");
  c.font="800 "+fs+"px -apple-system,Segoe UI,Arial";
  c.fillStyle=color||"#E52329";
  roundRect(c,0,0,w,h,h*0.34); c.fill();
  c.fillStyle="#fff"; c.textAlign="center"; c.textBaseline="middle";
  c.fillText(txt, w/2, h/2+1);
  var t=new THREE.CanvasTexture(cv);
  if(THREE.SRGBColorSpace) t.colorSpace = THREE.SRGBColorSpace;
  var s=new THREE.Sprite(new THREE.SpriteMaterial({map:t, depthTest:false, depthWrite:false, transparent:true}));
  s.renderOrder = 999;
  s.scale.set(w/h*0.95, 0.95, 1);
  s.userData.aspect = w/h;
  return s;
}
function roundRect(c,x,y,w,h,r){
  c.beginPath();
  c.moveTo(x+r,y); c.lineTo(x+w-r,y); c.quadraticCurveTo(x+w,y,x+w,y+r);
  c.lineTo(x+w,y+h-r); c.quadraticCurveTo(x+w,y+h,x+w-r,y+h);
  c.lineTo(x+r,y+h); c.quadraticCurveTo(x,y+h,x,y+h-r);
  c.lineTo(x,y+r); c.quadraticCurveTo(x,y,x+r,y); c.closePath();
}

/* ---------- mesures en pieds-pouces avec quarts ---------- */
function ftIn(v){
  var neg = v<0; v = Math.abs(v);
  var tot = Math.round(v*48)/48;                 /* au 1/4 de pouce */
  var f = Math.floor(tot + 1e-6);
  var inch = (tot - f)*12;
  var whole = Math.floor(inch + 1e-6);
  var q = Math.round((inch - whole)*4);
  if(q===4){ whole++; q=0; }
  if(whole===12){ f++; whole=0; }
  var FR = ["","¼","½","¾"][q];
  var s = f + "'";
  if(whole || q) s += whole + FR + '"';
  return (neg?"−":"") + s;
}

/* ============================================================
   PROFIL D'ARCHE
   ============================================================ */
var SO = { simple_reg:2.25/12, simple_hd:2.25/12, ta12:3.875/12, monopente:2.75/12,
           double_pointu:4.375/12, double_rond:4.375/12 };

function profile(m, w, A){
  var G = m.geo || {}, shape = G.shape || "taper";
  var gW = G.ground || w, bW = G.bar || gW;
  if(shape==="straight" || shape==="round"){ gW = w; bW = w; }
  var so = SO[m.id] != null ? SO[m.id] : 2.25/12;
  var E  = G.rise || (m.rise || 1.8333);
  var gh = gW/2, bh = bW/2, capY = null;
  var sh = A + so;                 /* épaulement : naissance des chevrons */
  var apex = sh + E;               /* pointe du cadre = D */
  var pts;

  if(shape==="shed"){
    /* Monopente : mur bas incliné, mur haut vertical, toit d'un seul pan. */
    pts = [[-gh,0], [-gh+(gW-bW), sh], [gh, apex], [gh, 0]];
  } else if(shape==="round"){
    /* Mur presque droit, épaule bien ronde, puis une couronne
       légèrement pointue — c'est la silhouette réelle du double Rond. */
    var y0=A*0.43, n=9, aMax=PI/2*0.62;
    var ry=(apex*0.785-y0)/Math.sin(aMax);
    pts=[[-gh,0],[-gh,y0]];
    for(var i=1;i<=n;i++){ var a=(i/n)*aMax; pts.push([-gh*Math.cos(a), y0+ry*Math.sin(a)]); }
    pts.push([0,apex]);
    for(var i2=n;i2>=1;i2--){ var a2=(i2/n)*aMax; pts.push([gh*Math.cos(a2), y0+ry*Math.sin(a2)]); }
    pts.push([gh,y0]); pts.push([gh,0]);
  } else if(shape==="ta"){
    /* 12' TA : mur droit comme un double Pointu, mais la barre de porte
       est plus haut dans l'arche — là où le chevron ne fait plus que B.
       Le chapeau au-dessus est donc un petit triangle.
       mur = (A − (1−B/C)·D) / (B/C) ; vérifié contre la fiche :
       A 7' → mur 6'6", faîte 8'4⅞". */
    var rr = bW/gW;
    var wallY = Math.max(A*0.55, (A - (1-rr)*apex)/rr);
    pts = [[-gh,0],[-gh,wallY],[0,apex],[gh,wallY],[gh,0]];
    capY = A;
  } else if(shape==="shoulder"){
    var sy = A*0.80;
    pts = [[-gh,0],[-gh,sy],[-bh,sh],[0,apex],[bh,sh],[gh,sy],[gh,0]];
  } else if(shape==="straight"){
    pts = [[-gh,0],[-gh,sh],[0,apex],[gh,sh],[gh,0]];
  } else {
    pts = [[-gh,0],[-bh,sh],[0,apex],[bh,sh],[gh,0]];
  }
  pts = fillet(pts, G.fillet||0);
  return { shape:shape, gh:gh, bh:bh, sh:sh, apex:apex, E:E, so:so, A:A, pts:pts,
           capY:(capY!=null?capY:sh) };
}
/* Arrondi des coins d'un profil : l'utilitaire 8' x 10' a des angles
   nettement plus doux que les grands abris. */
function fillet(pts, r){
  if(!r) return pts;
  var out=[pts[0]], i, k;
  for(i=1;i<pts.length-1;i++){
    var a=pts[i-1], b=pts[i], c=pts[i+1];
    var v1=[a[0]-b[0], a[1]-b[1]], v2=[c[0]-b[0], c[1]-b[1]];
    var l1=Math.sqrt(v1[0]*v1[0]+v1[1]*v1[1]), l2=Math.sqrt(v2[0]*v2[0]+v2[1]*v2[1]);
    if(l1<1e-6 || l2<1e-6){ out.push(b); continue; }
    var rr=Math.min(r, l1*0.42, l2*0.42);
    var p1=[b[0]+v1[0]/l1*rr, b[1]+v1[1]/l1*rr];
    var p2=[b[0]+v2[0]/l2*rr, b[1]+v2[1]/l2*rr];
    var N=4;
    for(k=0;k<=N;k++){
      var t=k/N, u=1-t;
      out.push([u*u*p1[0]+2*u*t*b[0]+t*t*p2[0], u*u*p1[1]+2*u*t*b[1]+t*t*p2[1]]);
    }
  }
  out.push(pts[pts.length-1]);
  return out;
}

/* x du profil à une hauteur donnée */
function xAt(P, y, side){
  var best=null, p=P.pts;
  for(var i=0;i<p.length-1;i++){
    var a=p[i], b=p[i+1];
    if((a[1]-y)*(b[1]-y)<=0 && a[1]!==b[1]){
      var t=(y-a[1])/(b[1]-a[1]), x=a[0]+(b[0]-a[0])*t;
      if(side<0 ? x<=0 : x>=0){ if(best===null || Math.abs(x)>Math.abs(best)) best=x; }
    }
  }
  return best===null ? side*P.bh : best;
}
/* profil rentré de IN le long de la normale locale : sur les modèles
   ronds, un simple retrait horizontal laisse les tubes percer le toit. */
function inset(P){
  var p=P.pts, n=p.length, out=[], i, j;
  var cy=P.apex*0.40, norms=[];
  for(i=0;i<n-1;i++){
    var dx=p[i+1][0]-p[i][0], dy=p[i+1][1]-p[i][1];
    var L=Math.sqrt(dx*dx+dy*dy)||1;
    var nx=-dy/L, ny=dx/L;
    var mx=(p[i][0]+p[i+1][0])/2, my=(p[i][1]+p[i+1][1])/2;
    if((mx-0)*nx+(my-cy)*ny < 0){ nx=-nx; ny=-ny; }        /* vers l'extérieur */
    norms.push([nx,ny]);
  }
  for(j=0;j<n;j++){
    var a=norms[Math.max(0,j-1)], b=norms[Math.min(norms.length-1,j)];
    var ux=a[0]+b[0], uy=a[1]+b[1];
    var Lu=Math.sqrt(ux*ux+uy*uy)||1; ux/=Lu; uy/=Lu;
    var x=p[j][0]-ux*IN, y=p[j][1]-uy*IN;
    if(p[j][1]<=0.001) y=0.02;
    out.push([x,y]);
  }
  return out;
}

/* largeur disponible d'un polygone à une hauteur donnée */
function spanAt(poly, y){
  var lo=1e9, hi=-1e9, i, a, b, t, x;
  for(i=0;i<poly.length;i++){
    a=poly[i]; b=poly[(i+1)%poly.length];
    if((a[1]-y)*(b[1]-y)>0 || a[1]===b[1]) continue;
    t=(y-a[1])/(b[1]-a[1]); x=a[0]+(b[0]-a[0])*t;
    if(x<lo) lo=x; if(x>hi) hi=x;
  }
  return hi>lo ? [lo,hi] : null;
}
/* place le logo au plus grand endroit où il tient vraiment dans le chapeau */
function placeLogo(poly, targetW){
  var by0=1e9, by1=-1e9, i;
  for(i=0;i<poly.length;i++){ by0=Math.min(by0,poly[i][1]); by1=Math.max(by1,poly[i][1]); }
  var best=null, k, it;
  for(k=0;k<=12;k++){
    var yc=by0+(by1-by0)*(0.16+0.58*k/12);
    var lw=targetW, lh=lw/LOGO_RATIO;
    for(it=0; it<7; it++){
      var s1=spanAt(poly, yc-lh/2), s2=spanAt(poly, yc+lh/2);
      if(!s1 || !s2){ lw*=0.75; lh=lw/LOGO_RATIO; continue; }
      var lo=Math.max(s1[0],s2[0]), hi=Math.min(s1[1],s2[1]);
      var avail=(hi-lo)*0.90;
      if(avail>=lw){ if(!best || lw>best.w) best={x:(lo+hi)/2, y:yc, w:lw, h:lh}; break; }
      lw=avail; lh=lw/LOGO_RATIO;
      if(lw < targetW*0.30) break;
    }
  }
  return best;
}

/* ============================================================
   PRIMITIVES
   ============================================================ */
function tube(ax,ay,az,bx,by,bz,r,mat){
  var dx=bx-ax, dy=by-ay, dz=bz-az;
  var len=Math.sqrt(dx*dx+dy*dy+dz*dz);
  if(len<1e-5) return null;
  var g=new THREE.CylinderGeometry(r,r,len,8,1,false);
  var mesh=new THREE.Mesh(g,mat);
  mesh.position.set((ax+bx)/2,(ay+by)/2,(az+bz)/2);
  mesh.quaternion.setFromUnitVectors(new THREE.Vector3(0,1,0), new THREE.Vector3(dx,dy,dz).normalize());
  mesh.castShadow=true;
  return mesh;
}

/* Bande plane entre deux points du profil, extrudée en Z, avec trous
   éventuels. On construit une Shape en (u = z, v = distance le long du
   segment) puis on la place par une matrice — pas de rotateY/rotateZ,
   donc aucun des pièges de signe du devis. */
function strip(p0, p1, z0, z1, holes, mat, lapDown){
  if(lapDown && p0[1] > p1[1]){ var sw=p0; p0=p1; p1=sw; }   /* v=0 toujours en bas */
  var dx=p1[0]-p0[0], dy=p1[1]-p0[1];
  var len=Math.sqrt(dx*dx+dy*dy);
  if(len<1e-4) return null;
  var v0 = -(lapDown||0);
  var shape=new THREE.Shape();
  shape.moveTo(z0, v0); shape.lineTo(z1, v0);
  shape.lineTo(z1, len); shape.lineTo(z0, len); shape.closePath();
  (holes||[]).forEach(function(h){ shape.holes.push(h); });
  var g=new THREE.ShapeGeometry(shape, 18);
  var m=new THREE.Mesh(g, mat);
  var e1=new THREE.Vector3(0,0,1);
  var e2=new THREE.Vector3(dx/len, dy/len, 0);
  var e3=new THREE.Vector3().crossVectors(e1,e2).normalize();
  var mat4=new THREE.Matrix4().makeBasis(e1,e2,e3);
  mat4.setPosition(p0[0], p0[1], 0);
  m.applyMatrix4(mat4);
  m.castShadow=true; m.receiveShadow=true;
  m.userData.basis = {o:[p0[0],p0[1],0], e1:e1.clone(), e2:e2.clone(), e3:e3.clone(), len:len};
  return m;
}
/* trou en ogive (rectangle + demi-cercle) dans le repère (u,v) d'une bande */
function archHole(uc, v0, halfU, h){
  var r=halfU, top=v0+h, straight=top-r;
  var p=new THREE.Path();
  p.moveTo(uc-halfU, v0);
  p.lineTo(uc+halfU, v0);
  p.lineTo(uc+halfU, straight);
  p.absarc(uc, straight, r, 0, PI, false);
  p.lineTo(uc-halfU, v0);
  p.closePath();
  return p;
}
function rectHole(uc, v0, halfU, h){
  var p=new THREE.Path();
  p.moveTo(uc-halfU, v0); p.lineTo(uc+halfU, v0);
  p.lineTo(uc+halfU, v0+h); p.lineTo(uc-halfU, v0+h);
  p.closePath();
  return p;
}
/* polygone quelconque dans le plan XY, à une position Z (pignons) */
function panel(poly, z, mat, holes){
  var s=new THREE.Shape();
  poly.forEach(function(p,i){ i ? s.lineTo(p[0],p[1]) : s.moveTo(p[0],p[1]); });
  s.closePath();
  (holes||[]).forEach(function(h){ s.holes.push(h); });
  var m=new THREE.Mesh(new THREE.ShapeGeometry(s, 18), mat);
  m.position.z=z; m.castShadow=true; m.receiveShadow=true;
  return m;
}

/* ============================================================
   VÉHICULES — silhouette de profil extrudée sur la largeur,
   avec passages de roue découpés, vitrage teinté, jantes,
   phares et rétroviseurs. Pas des boîtes.
   ============================================================ */
var VEHS = {
  berline: { nom:{fr:"Berline",en:"Sedan"},  l:15+1/12, w:5+11/12, h:4+7/12,
             wr:0.245, belt:0.575, ax:[-0.325,0.320],
             cab:[[-0.275,0],[-0.135,1],[0.055,1],[0.265,0]],
             cols:[0x24405F, 0x8E9296, 0x5A2230, 0x1D2126] },
  vus:     { nom:{fr:"VUS",en:"SUV"},        l:15+1/12, w:6+1/12,  h:5+7/12,
             wr:0.225, belt:0.545, ax:[-0.325,0.320],
             cab:[[-0.405,0],[-0.330,1],[0.150,1],[0.285,0]],
             cols:[0x33383F, 0x6E7379, 0x2B4257, 0x4A3A33] },
  camion:  { nom:{fr:"Camionnette",en:"Pickup"}, l:19.5, w:6+8/12, h:6+5/12,
             wr:0.200, belt:0.555, ax:[-0.305,0.315], bed:true,
             cab:[[-0.055,0],[0.020,1],[0.235,1],[0.395,0]],
             cols:[0x5E2A2A, 0x3B4149, 0x25415C, 0x9AA0A6] }
};

/* ------------------------------------------------------------
   Une carrosserie n'est pas un profil extrudé : c'est un volume
   qui change de largeur sur toute sa longueur. On la construit
   donc en cousant des sections transversales — nez qui rétrécit,
   épaules bombées, pavillon plus étroit que les portières.
   ------------------------------------------------------------ */
var SEC_N = 18;
function sg(x){ return x<0 ? -1 : 1; }
function lerp(a,b,t){ return a+(b-a)*t; }
function smoothstep(t){ t=Math.max(0,Math.min(1,t)); return t*t*(3-2*t); }
/* superellipse : rectangle aux coins arrondis, n grand = plus carré */
function section(cx, cy, hx, hy, n){
  var pts=[], i, th, c, s2;
  for(i=0;i<SEC_N;i++){
    th = i/SEC_N*2*PI;
    c=Math.cos(th); s2=Math.sin(th);
    pts.push([ cx + hx*sg(c)*Math.pow(Math.abs(c), 2/n),
               cy + hy*sg(s2)*Math.pow(Math.abs(s2), 2/n) ]);
  }
  return pts;
}
/* coud les sections entre elles et bouche les deux bouts */
function loft(st){
  var pos=[], idx=[], M=st.length, k, i;
  for(k=0;k<M;k++) for(i=0;i<SEC_N;i++) pos.push(st[k].p[i][0], st[k].p[i][1], st[k].z);
  for(k=0;k<M-1;k++) for(i=0;i<SEC_N;i++){
    var j=(i+1)%SEC_N;
    var a=k*SEC_N+i, b=k*SEC_N+j, c=(k+1)*SEC_N+j, d=(k+1)*SEC_N+i;
    idx.push(a,c,b, a,d,c);
  }
  [[0,true],[M-1,false]].forEach(function(o){
    var s3=st[o[0]], cx=0, cy=0, i2;
    for(i2=0;i2<SEC_N;i2++){ cx+=s3.p[i2][0]; cy+=s3.p[i2][1]; }
    cx/=SEC_N; cy/=SEC_N;
    var ci=pos.length/3; pos.push(cx, cy, s3.z);
    for(i2=0;i2<SEC_N;i2++){
      var j2=(i2+1)%SEC_N, a2=o[0]*SEC_N+i2, b2=o[0]*SEC_N+j2;
      if(o[1]) idx.push(ci, a2, b2); else idx.push(ci, b2, a2);
    }
  });
  var g=new THREE.BufferGeometry();
  g.setAttribute("position", new THREE.Float32BufferAttribute(pos,3));
  g.setIndex(idx); g.computeVertexNormals();
  return g;
}

/* ---------- reflet d'environnement ----------
   Une petite carte équirectangulaire fabriquée au vol : ciel en haut,
   sol en bas, une tache de soleil. Elle n'est appliquée QU'À la peinture
   et au vitrage des véhicules — l'éclairage de l'abri ne bouge pas. */
var ENV_TEX=null;
function envTexture(){
  if(ENV_TEX) return ENV_TEX;
  var W=256, H=128, cv=document.createElement("canvas");
  cv.width=W; cv.height=H;
  var c=cv.getContext("2d");
  var g=c.createLinearGradient(0,0,0,H);
  g.addColorStop(0.00,"#7F9EC0"); g.addColorStop(0.42,"#CFE0EE");
  g.addColorStop(0.50,"#EDF1F4"); g.addColorStop(0.52,"#9AA0A2");
  g.addColorStop(1.00,"#5B6063");
  c.fillStyle=g; c.fillRect(0,0,W,H);
  var sun=c.createRadialGradient(W*0.72,H*0.20,2, W*0.72,H*0.20,H*0.34);
  sun.addColorStop(0,"rgba(255,255,255,.95)"); sun.addColorStop(1,"rgba(255,255,255,0)");
  c.fillStyle=sun; c.fillRect(0,0,W,H);
  var t=new THREE.CanvasTexture(cv);
  t.mapping = THREE.EquirectangularReflectionMapping;
  if(THREE.SRGBColorSpace) t.colorSpace = THREE.SRGBColorSpace;
  ENV_TEX=t; return t;
}

/* profil de toit de l'habitacle, à partir de la silhouette v.cab */
function roofAt(v, t){
  var p=v.cab, i;
  for(i=0;i<p.length-1;i++){
    if(t>=p[i][0] && t<=p[i+1][0]){
      var f=(t-p[i][0])/((p[i+1][0]-p[i][0])||1);
      return lerp(p[i][1], p[i+1][1], smoothstep(f));
    }
  }
  return t<p[0][0] ? p[0][1] : p[p.length-1][1];
}

function vehicle(kind, idx){
  var v=VEHS[kind]||VEHS.vus, G=new THREE.Group();
  var l=v.l, w=v.w, h=v.h, wr=v.wr*h, belt=v.belt*h, hw=w/2;
  var col=v.cols[(idx||0) % v.cols.length];
  var env=envTexture();
  var paint=new THREE.MeshStandardMaterial({color:col, roughness:0.22, metalness:0.52,
              envMap:env, envMapIntensity:0.55, side:THREE.DoubleSide});
  var trim =new THREE.MeshStandardMaterial({color:0x2A2E33, roughness:0.5, metalness:0.35});
  var glass=new THREE.MeshStandardMaterial({color:0x121820, roughness:0.045, metalness:0.80,
              envMap:env, envMapIntensity:1.55, transparent:true, opacity:0.94,
              side:THREE.DoubleSide});
  var tire =new THREE.MeshStandardMaterial({color:0x15181B, roughness:0.94});
  var rim  =new THREE.MeshStandardMaterial({color:0xAEB5BC, roughness:0.40, metalness:0.60,
              envMap:env, envMapIntensity:0.45});
  var dark =new THREE.MeshStandardMaterial({color:0x1B1F24, roughness:0.8});

  var zCabR = v.cab[0][0], zCabF = v.cab[v.cab.length-1][0];   /* en fractions de l */
  var bedBack = v.bed ? zCabR-0.02 : -0.5;                     /* la caisse s'arrête là */

  /* ---------- bas de caisse ---------- */
  /* bas : monte au-dessus des essieux (passage de roue), redescend
     entre les deux (bas de caisse), remonte un peu aux pare-chocs */
  function botAt(t){
    var y = wr*0.62, k;
    for(k=0;k<v.ax.length;k++){
      var d=Math.abs(t - v.ax[k])/0.072;
      if(d<1) y = Math.max(y, lerp(wr*1.04, wr*0.62, smoothstep(d)));
    }
    var e=(Math.abs(t)-0.45)/0.05;
    if(e>0) y = Math.max(y, lerp(wr*0.62, wr*0.88, smoothstep(e)));
    return y;
  }
  /* haut : ceinture de caisse, qui plonge sur le capot et le coffre */
  function topAt(t){
    if(t > 0.30) return belt*lerp(1, 0.66, smoothstep((t-0.30)/0.20));
    if(t < -0.35) return belt*lerp(1, 0.88, smoothstep((-0.35-t)/0.15));
    return belt;
  }
  /* largeur : les épaules sont pleines, le nez et la queue rentrent */
  function widAt(t){
    var a=Math.abs(t), f=1;
    if(a>0.32) f=lerp(1, v.bed?0.955:0.815, smoothstep((a-0.32)/0.18));
    var g2=(0.16-Math.abs(t-v.ax[1]))/0.16;                /* léger renflement d'aile */
    if(g2>0) f += 0.018*smoothstep(g2);
    var g3=(0.16-Math.abs(t-v.ax[0]))/0.16;
    if(g3>0) f += 0.018*smoothstep(g3);
    return f;
  }
  function bodySections(t0, t1){
    var st=[], ts=[], k, T;
    for(k=0;k<=18;k++) ts.push(t0+(t1-t0)*k/18);
    v.ax.forEach(function(a){ [-0.09,-0.045,0.045,0.09].forEach(function(d){
      if(a+d>t0 && a+d<t1) ts.push(a+d); }); });
    ts.push(t0+0.004, t1-0.004);
    ts.sort(function(a,b){ return a-b; });
    for(k=0;k<ts.length;k++){
      T=ts[k];
      var yb=botAt(T), yt=topAt(T), hx=hw*widAt(T);
      var nn = 4.7 + 1.2*smoothstep((Math.abs(T)-0.30)/0.20);
      st.push({ z:T*l, p:section(0, (yb+yt)/2, hx, (yt-yb)/2, nn) });
    }
    return st;
  }
  var body=new THREE.Mesh(loft(bodySections(bedBack, 0.5)), paint);
  G.add(body);

    /* ---------- habitacle ----------
     Une arche : on part de la ceinture de caisse à droite, on passe
     par-dessus le pavillon, on redescend à gauche. Comme le profil est
     ouvert, on peut en découper des bandes — c'est ce qui donne les
     vitres latérales, le pare-brise et la lunette, exactement collés
     à la surface au lieu d'être des panneaux posés à côté. */
  var GH_M = 18, GH_V = 16;
  function ghPoint(t, vv){
    var rf = roofAt(v, t);
    var yTop = belt + (h-belt)*rf;
    var taper = 1 - 0.12*Math.pow(Math.abs((t-(zCabR+zCabF)/2)/(((zCabF-zCabR)/2)||1)), 3.0);
    var hx2 = hw*0.815*taper, hy2 = Math.max(0.02, yTop-belt);
    var th = PI*vv, c2=Math.cos(th), s4=Math.sin(th);
    return [ hx2*sg(c2)*Math.pow(Math.abs(c2), 2/6.0),
             belt + hy2*Math.pow(Math.abs(s4), 2/5.0),
             t*l ];
  }
  /* une bande de la surface de l'habitacle, décalée vers l'extérieur */
  function ghStrip(t0, t1, v0, v1, off, mat, nz, nv){
    nz=nz||10; nv=nv||6;
    var pos=[], idx3=[], i4, j3;
    for(i4=0;i4<=nz;i4++){
      var t=t0+(t1-t0)*i4/nz;
      for(j3=0;j3<=nv;j3++){
        var vv=v0+(v1-v0)*j3/nv;
        var q=ghPoint(t,vv);
        if(off){
          var q2=ghPoint(t, Math.min(1,vv+0.02)), q3=ghPoint(t, Math.max(0,vv-0.02));
          var dx=q2[0]-q3[0], dy=q2[1]-q3[1], n2=Math.sqrt(dx*dx+dy*dy)||1;
          q=[q[0]+dy/n2*off, q[1]-dx/n2*off, q[2]];
        }
        pos.push(q[0],q[1],q[2]);
      }
    }
    for(i4=0;i4<nz;i4++) for(j3=0;j3<nv;j3++){
      var a3=i4*(nv+1)+j3, b3=a3+1, c3=(i4+1)*(nv+1)+j3, d3=c3+1;
      idx3.push(a3,c3,b3, b3,c3,d3);
    }
    var g6=new THREE.BufferGeometry();
    g6.setAttribute("position", new THREE.Float32BufferAttribute(pos,3));
    g6.setIndex(idx3); g6.computeVertexNormals();
    return new THREE.Mesh(g6, mat);
  }
  /* la coque peinte : toute l'arche, d'un bout à l'autre */
  G.add(ghStrip(zCabR, zCabF, 0, 1, 0, paint, GH_M, GH_V));
  /* elle est fermée en bas par deux bandes verticales jusqu'à la caisse */
  var zT0=null, zT1=null, pC=v.cab, ci2;
  for(ci2=0; ci2<pC.length; ci2++){ if(pC[ci2][1]){ if(zT0===null) zT0=pC[ci2][0]; zT1=pC[ci2][0]; } }
  if(zT0===null){ zT0=zCabR; zT1=zCabF; }

  /* ---------- vitrage, découpé dans la surface de l'habitacle ---------- */
  var mA = 0.030;                                   /* épaisseur des montants */
  var wsF0 = zT1, wsF1 = zCabF - (zCabF-zT1)*0.16;  /* pare-brise */
  var wsR0 = zCabR + (zT0-zCabR)*0.16, wsR1 = zT0;  /* lunette */
  if(wsF1>wsF0+0.004) G.add(ghStrip(wsF0+0.006, wsF1, 0.20, 0.80, 0.022, glass, 6, 4));
  if(wsR1>wsR0+0.004) G.add(ghStrip(wsR0, wsR1-0.006, 0.20, 0.80, 0.022, glass, 6, 4));
  /* vitres latérales : deux par côté, séparées par le montant central */
  var sw0 = zCabR + (zT0-zCabR)*0.42, sw1 = zT1 + (zCabF-zT1)*0.42;
  var swM = (sw0+sw1)/2;
  [[0.055,0.300],[0.700,0.945]].forEach(function(vr){
    G.add(ghStrip(sw0, swM-mA, vr[0], vr[1], 0.022, glass, 6, 4));
    G.add(ghStrip(swM+mA, sw1, vr[0], vr[1], 0.022, glass, 5, 3));
  });

  /* ---------- caisse ouverte de la camionnette ---------- */
  if(v.bed){
    var bz0=-0.5*l+0.03*l, bz1=bedBack*l, bl2=bz1-bz0, bw=hw*0.955;
    var bedH = belt - wr*0.52;
    var floor=new THREE.Mesh(new THREE.BoxGeometry(bw*2*0.96, 0.07, bl2*0.97), dark);
    floor.position.set(0, wr*0.52+bedH*0.18, (bz0+bz1)/2); G.add(floor);
    [-1,1].forEach(function(sd){
      var wall=new THREE.Mesh(new THREE.BoxGeometry(w*0.055, bedH*0.86, bl2), paint);
      wall.position.set(sd*(bw-w*0.028), wr*0.52+bedH*0.60, (bz0+bz1)/2); G.add(wall);
    });
    var tail=new THREE.Mesh(new THREE.BoxGeometry(bw*2, bedH*0.86, 0.09), paint);
    tail.position.set(0, wr*0.52+bedH*0.60, bz0); G.add(tail);
    var fw=new THREE.Mesh(new THREE.BoxGeometry(bw*2, bedH*0.92, 0.09), paint);
    fw.position.set(0, wr*0.52+bedH*0.62, bz1); G.add(fw);
  }

  /* ---------- roues : pneu à flancs, jante à cinq rayons ---------- */
  var tw = w*0.132;
  v.ax.forEach(function(a){
    [-1,1].forEach(function(sd){
      var wheel=new THREE.Group(), k3;
      var t3=new THREE.Mesh(new THREE.CylinderGeometry(wr, wr, tw, 16), tire);
      t3.rotation.z=PI/2; wheel.add(t3);
      var sh=new THREE.Mesh(new THREE.CylinderGeometry(wr*0.94, wr*0.94, tw*1.10, 16), tire);
      sh.rotation.z=PI/2; wheel.add(sh);
      var disc=new THREE.Mesh(new THREE.CylinderGeometry(wr*0.64, wr*0.64, tw*0.30, 14), rim);
      disc.rotation.z=PI/2; disc.position.x=sd*tw*0.40; wheel.add(disc);
      /* cinq évidements sombres : ça se lit comme une jante en alliage */
      for(k3=0;k3<5;k3++){
        var ang=k3*(2*PI/5);
        var sl=new THREE.Mesh(new THREE.BoxGeometry(tw*0.16, wr*0.34, wr*0.16), tire);
        sl.rotation.x = ang;
        sl.position.set(sd*tw*0.52, Math.cos(ang)*wr*0.34, Math.sin(ang)*wr*0.34);
        wheel.add(sl);
      }
      var hub=new THREE.Mesh(new THREE.CylinderGeometry(wr*0.17, wr*0.17, tw*0.36, 14), rim);
      hub.rotation.z=PI/2; hub.position.x=sd*tw*0.50; wheel.add(hub);
      wheel.position.set(sd*(hw*widAt(a)-tw*0.26), wr, a*l);
      G.add(wheel);
    });
  });

  /* ---------- feux, calandre, pare-chocs, rétroviseurs ---------- */
  var lampF=new THREE.MeshStandardMaterial({color:0xEFF4F8, roughness:0.12, metalness:0.2,
              emissive:0xC8DAEA, emissiveIntensity:0.45, envMap:env, envMapIntensity:1.1});
  var lampR=new THREE.MeshStandardMaterial({color:0xB81C24, roughness:0.2, metalness:0.2,
              emissive:0x7E1216, emissiveIntensity:0.5});
  function lamp(t, mat, hgt){
    [-1,1].forEach(function(sd){
      var wf=widAt(t), yb3=botAt(t), yt3=topAt(t);
      var y=lerp(yb3, yt3, hgt);
      var m=new THREE.Mesh(new THREE.BoxGeometry(w*0.22, h*0.050, 0.09), mat);
      m.position.set(sd*hw*wf*0.60, y, t*l);
      G.add(m);
    });
  }
  lamp(0.478, lampF, 0.62);
  lamp(-0.478, lampR, 0.68);
  /* calandre + pare-chocs, en gris sombre : ça casse la masse peinte */
  [[0.492, 0.30], [-0.492, 0.26]].forEach(function(o){
    var t4=o[0], wf=widAt(t4);
    var bmp=new THREE.Mesh(new THREE.BoxGeometry(hw*wf*2*0.97, h*0.075, 0.09), trim);
    bmp.position.set(0, lerp(botAt(t4), topAt(t4), o[1]), t4*l);
    G.add(bmp);
  });
  var grl=new THREE.Mesh(new THREE.BoxGeometry(hw*widAt(0.49)*1.30, h*0.055, 0.06), trim);
  grl.position.set(0, lerp(botAt(0.49), topAt(0.49), 0.82), 0.49*l); G.add(grl);
  /* ligne de portière */
  [-1,1].forEach(function(sd){
    var dz=swM;
    var dl=new THREE.Mesh(new THREE.BoxGeometry(0.020, (belt-wr*0.80)*0.72, 0.018), trim);
    dl.position.set(sd*hw*widAt(dz)*0.995, (belt+wr*0.80)/2, dz*l);
    G.add(dl);
  });
  /* rétroviseurs, sur tige */
  [-1,1].forEach(function(sd){
    var mz=(zCabR+(zCabF-zCabR)*0.14)*l;
    var arm=new THREE.Mesh(new THREE.BoxGeometry(w*0.035, h*0.014, 0.05), trim);
    arm.position.set(sd*(hw*0.90), belt+(h-belt)*0.16, mz); G.add(arm);
    var mir=new THREE.Mesh(new THREE.BoxGeometry(w*0.030, h*0.032, 0.15), trim);
    mir.position.set(sd*(hw*0.955), belt+(h-belt)*0.18, mz); G.add(mir);
  });

  G.traverse(function(o){ if(o.isMesh){ o.castShadow=true; o.receiveShadow=true; } });
  G.userData.spec=v;
  return G;
}

/* ============================================================
   LE VISUALISEUR
   ============================================================ */
function Viz(canvas, stage){
  this.cv=canvas; this.stage=stage;
  this.showVeh=true; this.onInteract=null; this.onView=null;
  this.scene=null; this.dist=40; this.topView=false;
  this.opts=null;

  var r=new THREE.WebGLRenderer({canvas:canvas, antialias:(window.innerWidth>700), alpha:false});
  r.setClearColor(0xD7DFE7, 1);
  if(THREE.ACESFilmicToneMapping!==undefined){ r.toneMapping=THREE.NoToneMapping; }
  r.toneMappingExposure=1.0;
  r.shadowMap.enabled=true; r.shadowMap.type=THREE.PCFSoftShadowMap;
  if(THREE.SRGBColorSpace) r.outputColorSpace = THREE.SRGBColorSpace;
  this.r=r;

  var sc=new THREE.Scene();
  sc.background=new THREE.Color(0xE9EFF4);
  this.sc=sc;

  /* --- décor permanent : ciel et terrain ---
     Les deux sont volontairement NON éclairés : l'éclairage de l'abri est
     très fort (c'est ce qui rend la toile blanche), un sol éclairé par la
     même recette se retrouverait cramé. On peint donc les couleurs telles
     quelles, et c'est l'entrée du client qui reçoit l'ombre. */
  var sky=new THREE.Mesh(new THREE.SphereGeometry(320, 24, 12),
        new THREE.MeshBasicMaterial({map:skyTexture(), side:THREE.BackSide, depthWrite:false}));
  sky.renderOrder=-10; sc.add(sky);
  var land=new THREE.Mesh(new THREE.CircleGeometry(170, 48),
        new THREE.MeshBasicMaterial({map:landTexture()}));
  land.rotation.x=-PI/2; land.position.y=-0.03; land.renderOrder=-9; sc.add(land);
  this.land=land;

  var cam=new THREE.PerspectiveCamera(38, 1.6, 0.4, 600);
  this.cam=cam;

  /* Éclairage — recette du devis : soleil volontairement faible,
     hémisphérique fort, deux remplissages. Une toile blanche, ce
     n'est pas la couleur, c'est la lumière. */
  sc.add(new THREE.HemisphereLight(0xffffff, 0xCED7E0, 2.05));
  sc.add(new THREE.AmbientLight(0xffffff, 0.55));
  var sun=new THREE.DirectionalLight(0xffffff, 2.05);
  sun.position.set(26, 42, 20);
  sun.castShadow=true;
  sun.shadow.mapSize.set(2048,2048);
  sun.shadow.bias=-0.0007; sun.shadow.normalBias=0.05;
  var s=sun.shadow.camera;
  s.left=-42; s.right=42; s.top=42; s.bottom=-42; s.near=1; s.far=140;
  sc.add(sun); sc.add(sun.target);
  this.sun=sun;
  var f1=new THREE.DirectionalLight(0xffffff, 0.62); f1.position.set(-30, 18, -14); sc.add(f1);
  var f2=new THREE.DirectionalLight(0xffffff, 0.34); f2.position.set(14, 10, -34); sc.add(f2);

  this.root=new THREE.Group(); sc.add(this.root);
  this.dims=new THREE.Group(); sc.add(this.dims);

  /* Le terrain ne s'éclaire pas, mais il reçoit quand même l'ombre :
     un capteur d'ombre transparent posé juste au-dessus. */
  var shd=new THREE.Mesh(new THREE.CircleGeometry(90, 64),
          new THREE.ShadowMaterial({opacity:0.26}));
  shd.rotation.x=-PI/2; shd.position.y=-0.022; shd.receiveShadow=true;
  sc.add(shd);

  var self=this;
  var ctl=new THREE.OrbitControls(cam, canvas);
  ctl.enableDamping=true; ctl.dampingFactor=0.09;
  ctl.minDistance=8; ctl.maxDistance=180;
  ctl.maxPolarAngle=PI/2-0.03;
  ctl.enablePan=false;
  ctl.addEventListener("start", function(){ if(self.onInteract) self.onInteract(); });
  ctl.addEventListener("change", function(){
    if(self.topView && !self._settingTop){ self.topView=false; if(self.onView) self.onView(); }
  });
  this.ctl=ctl;

  /* boucle de rendu, en pause quand le canevas n'est pas à l'écran */
  this.visible=true;
  try{
    if(window.IntersectionObserver){
      new IntersectionObserver(function(e){ self.visible = e[0].isIntersecting; })
        .observe(stage||canvas);
    }
  }catch(e){}
  (function loop(){
    requestAnimationFrame(loop);
    if(!self.visible || !self.sc) return;
    self.ctl.update();
    self.faceLabels();
    self.r.render(self.sc, self.cam);
  })();
}

Viz.prototype.resize=function(){
  var el=this.stage||this.cv;
  var w=el.clientWidth||640, h=el.clientHeight||420;
  var dpr=Math.min(window.devicePixelRatio||1, window.innerWidth<700 ? 1.75 : 2);
  this.r.setPixelRatio(dpr);
  this.r.setSize(w,h,false);
  this.cam.aspect=w/h; this.cam.updateProjectionMatrix();
};
Viz.prototype.draw=function(){ /* la boucle s'en charge */ };
Viz.prototype._fit=function(){
  /* cadrage sur l'abri lui-même, pas sur l'entrée : sinon une grande
     entrée éloigne la caméra et l'abri devient minuscule */
  var b=this.shelter;
  if(!b) return 40;
  var sz=new THREE.Vector3(b.w*1.18, b.h*1.10, b.len*1.10);
  this.target=new THREE.Vector3(0, Math.max(b.h*0.42, 2), 0);
  var radius=Math.max(sz.x, sz.z, sz.y)*0.5;
  var vFov=this.cam.fov*PI/180;
  var hFov=2*Math.atan(Math.tan(vFov/2)*Math.max(1, this.cam.aspect));
  var d=Math.max(radius/Math.tan(vFov/2), radius/Math.tan(hFov/2));
  return d*1.30 + sz.y*0.4;
};
Viz.prototype.reset=function(){
  this.topView=false;
  this.dist=this._fit();
  var t=this.target||new THREE.Vector3(0,3,0);
  this.ctl.target.copy(t);
  this.cam.position.set(t.x+this.dist*0.62, t.y+this.dist*0.46, t.z+this.dist*0.70);
  this.ctl.update();
};
Viz.prototype.setTop=function(on){
  this.topView=!!on;
  this._settingTop=true;
  var t=this.target||new THREE.Vector3(0,3,0);
  if(on){
    this.cam.position.set(t.x+0.001, t.y+this.dist*1.05, t.z+0.001);
  } else {
    this.cam.position.set(t.x+this.dist*0.62, t.y+this.dist*0.46, t.z+this.dist*0.70);
  }
  this.ctl.target.copy(t);
  this.ctl.update();
  var self=this; setTimeout(function(){ self._settingTop=false; }, 60);
};
/* les étiquettes gardent une taille lisible quelle que soit la distance */
Viz.prototype.faceLabels=function(){
  var d=this.cam.position.distanceTo(this.ctl.target);
  var k=d*0.0135;
  for(var i=0;i<this.dims.children.length;i++){
    var o=this.dims.children[i];
    if(o.isSprite && o.userData.aspect) o.scale.set(o.userData.aspect*k, k, 1);
  }
};

function clearGroup(g){
  for(var i=g.children.length-1;i>=0;i--){
    var o=g.children[i];
    o.traverse(function(n){
      if(n.geometry) n.geometry.dispose();
      if(n.material){
        if(n.material.map && n.material.map.isCanvasTexture && n.material.map !== LOGO_TEX
           && !SOIL_CACHE_HAS(n.material.map)) n.material.map.dispose();
        n.material.dispose();
      }
    });
    g.remove(o);
  }
}
function SOIL_CACHE_HAS(t){ for(var k in SOIL_CACHE) if(SOIL_CACHE[k]===t) return true; return false; }

/* ============================================================
   CONSTRUCTION
   ============================================================ */
Viz.prototype.build=function(o){
  this.opts=o;
  clearGroup(this.root); clearGroup(this.dims);

  var m=o.model, w=o.w, L=o.len, A=o.h;
  var P=profile(m, w, A);
  var arc=(m.arc||4);
  var nArch=Math.max(2, Math.round(L/arc)+1), nBay=nArch-1;
  var step=L/nBay;
  var z1=L/2, z0=-L/2;                       /* z1 = AVANT (fenêtres) */

  var self=this;
  this.target=new THREE.Vector3(0, P.apex*0.42, 0);
  this.shelter={w:w, len:L, h:P.apex};

  /* ---------- matériaux ---------- */
  var tarpMat=new THREE.MeshStandardMaterial({
    color:C_TARP, roughness:0.96, side:THREE.DoubleSide,
    emissive:C_TARP, emissiveIntensity:0.02
  });
  var frameMat=new THREE.MeshStandardMaterial({color:C_FRAME, roughness:0.45, metalness:0.55});
  var glassMat=new THREE.MeshStandardMaterial({color:0xC9D6DF, roughness:0.28, metalness:0.05,
                    transparent:true, opacity:0.42, side:THREE.DoubleSide});
  var pvcMat=new THREE.MeshStandardMaterial({color:0xEDEFF1, roughness:0.6});
  var showTarp = o.showTarp !== false;
  var famDouble = (m.fam === "double");

  /* ============ ENTRÉE DU CLIENT ============ */
  var dv=o.drive||{};
  var dW=dv.w||Math.max(w+4, 18), dL=dv.l||Math.max(L+4, 22);
  var soil=soilTexture(o.soil||"asphalte").clone();
  soil.wrapS=soil.wrapT=THREE.RepeatWrapping;
  soil.repeat.set(dW/4, dL/4);
  soil.needsUpdate=true;
  /* le terrain s'ajuste à la taille de l'abri : le fondu d'horizon garde
     toujours la même place à l'écran, qu'on regarde un 5 pi ou un 44 pi */
  if(this.land){ var lr=Math.max(46, (L+w)*1.75)/170; this.land.scale.set(lr,lr,1); }
  /* le gazon de l'entrée est volontairement assourdi : sous notre éclairage
     il partirait sinon dans un vert fluo, très loin du terrain autour */
  var padTint = (o.soil==="terre") ? 0xCFC4B6 : 0xffffff;
  var pad=new THREE.Mesh(new THREE.PlaneGeometry(dW,dL),
        new THREE.MeshStandardMaterial({map:soil, color:padTint, roughness:0.95}));
  pad.rotation.x=-PI/2; pad.receiveShadow=true;
  this.root.add(pad);

  /* ============ OSSATURE ============ */
  var IP=inset(P);
  var frame=new THREE.Group(); this.root.add(frame);
  /* La barre de porte va d'un montant à l'autre, à la hauteur libre.
     On la prend sur le profil lui-même : sur le monopente elle rejoint
     ainsi le mur haut, et sur les murs droits elle fait toute la largeur. */
  var barL = xAt(P,A,-1) + IN*0.6, barR = xAt(P,A,1) - IN*0.6;

  for(var a=0;a<nArch;a++){
    var z=z0+a*step, edge=(a===0||a===nArch-1);
    if(edge) z += (a===0 ? Z_IN : -Z_IN);       /* piège n°1 : ne pas percer les pignons */
    var r=edge?TUBE_END:TUBE;
    for(var i=0;i<IP.length-1;i++){
      var t=tube(IP[i][0],IP[i][1],z, IP[i+1][0],IP[i+1][1],z, r, frameMat);
      if(t) frame.add(t);
    }
    if(edge){
      /* barre de porte : seulement aux deux bouts, à la hauteur libre A */
      var t2=tube(barL, A, z, barR, A, z, TUBE, frameMat);
      if(t2) frame.add(t2);
    } else if(m.fam !== "rangement"){
      /* Les abris de rangement, mini-monopente et utilitaire n'ont de
         barre qu'aux deux bouts : rien sur les arches du milieu. */
      /* renfort d'arche 48 po sur les modèles simples, raidisseur pleine
         largeur sur TA / monopente / doubles — voir fiches de pièces */
      if(P.shape==="taper"){
        var yR=renfortY(P, RENF_L);
        var t3=tube(-RENF_L/2, yR, z, RENF_L/2, yR, z, TUBE*0.85, frameMat);
        if(t3) frame.add(t3);
      } else {
        var t4=tube(barL, A, z, barR, A, z, TUBE*0.9, frameMat);
        if(t4) frame.add(t4);
      }
    }
  }
  /* Entretoises pleine longueur : 5 sur les abris simples,
     7 sur les doubles (bas de patte, sous les coins, mi-pente du
     toit de chaque côté, et le faîte). */
  var isDouble = (m.fam === "double");
  var isShed   = (P.shape === "shed");
  var runs=[];
  var cL=cornerOf(P,-1), cR=cornerOf(P,1);
  runs.push([xAt(P,ENTRE_BAS,-1)+IN, ENTRE_BAS]);
  runs.push([xAt(P,ENTRE_BAS, 1)-IN, ENTRE_BAS]);
  var ycL, ycR;
  if(isShed){
    /* Monopente : les deux entretoises hautes sont à la même hauteur,
       sous le coin BAS, et la cinquième est au milieu du pan de toit. */
    ycL = ycR = Math.max(ENTRE_MIN, P.sh - ENTRE_D);
  } else {
    ycL = Math.max(ENTRE_MIN, cL[1]-ENTRE_D);
    ycR = Math.max(ENTRE_MIN, cR[1]-ENTRE_D);
  }
  ycL = Math.min(ycL, P.apex-0.6); ycR = Math.min(ycR, P.apex-0.6);
  runs.push([xAt(P,ycL,-1)+IN, ycL]);
  runs.push([xAt(P,ycR, 1)-IN, ycR]);
  if(isDouble){
    var mL=midSlope(P,-1), mR=midSlope(P,1);
    if(mL) runs.push(inward(mL));
    if(mR) runs.push(inward(mR));
  }
  var topV=IP[0];
  for(var ti=1;ti<IP.length;ti++) if(IP[ti][1]>topV[1]) topV=IP[ti];
  if(isShed){
    /* milieu du pan de toit, entre le coin bas et le point haut */
    var lowC=[-P.gh+(P.pts[1][0]+P.gh), P.sh];
    var mid=[(P.pts[1][0]+P.pts[2][0])/2, (P.pts[1][1]+P.pts[2][1])/2];
    runs.push(inward(mid));
  } else {
    runs.push([topV[0], topV[1]]);
  }
  runs.forEach(function(p){
    var t=tube(p[0],p[1],z0+Z_IN, p[0],p[1],z1-Z_IN, TUBE*0.8, frameMat);
    if(t) frame.add(t);
  });
  this.entreY = ycR;

  /* T-Bar des abris doubles : du faîte jusqu'à la barre de porte,
     sur chaque arche. C'est elle qui tient la portée. */
  if(isDouble){
    for(var ab=0;ab<nArch;ab++){
      var zb=z0+ab*step;
      if(ab===0) zb+=Z_IN; else if(ab===nArch-1) zb-=Z_IN;
      var tb=tube(0, A, zb, topV[0], topV[1], zb, TUBE*0.85, frameMat);
      if(tb) frame.add(tb);
    }
  }

  /* Monopente : renfort de coin dans l'angle supérieur, entre le haut
     du toit et le mur du côté haut. */
  if(isShed && m.fam !== "rangement"){
    var hi=[P.pts[2][0], P.pts[2][1]];              /* coin haut */
    var onRoof=[hi[0]+(P.pts[1][0]-hi[0])*0.24, hi[1]+(P.pts[1][1]-hi[1])*0.24];
    var onWall=[hi[0], hi[1]-(hi[1]-P.sh)*0.34 - 0.9];
    for(var as=0;as<nArch;as++){
      var zs=z0+as*step;
      if(as===0) zs+=Z_IN; else if(as===nArch-1) zs-=Z_IN;
      var a1=inward(onRoof), b1=inward(onWall);
      var tc=tube(a1[0],a1[1],zs, b1[0],b1[1],zs, TUBE*0.8, frameMat);
      if(tc) frame.add(tc);
    }
  }

  /* Diagonales de contreventement : du bas de l'entretoise de la 2e arche
     vers le milieu du poteau de la 1re. 2 sur un simple (4 à partir de
     32 pi), 4 sur un double (6 à partir de 32 pi). */
  (function(){
    var pairs=[];
    if(nBay>=1) pairs.push([z1, z1-step]);
    if(isDouble && nBay>=2) pairs.push([z0, z0+step]);
    if(L>=32 && nBay>=4){
      var k=Math.floor(nBay/2);
      pairs.push([z0+k*step, z0+(k-1)*step]);
    }
    pairs.forEach(function(pr){
      [-1,1].forEach(function(sg){
        var yTop=Math.max(2.8, (sg<0?ycL:ycR)*0.78);
        var xa=xAt(P,ENTRE_BAS,sg) - sg*IN;
        var xb=xAt(P,yTop,sg)      - sg*IN;
        var t=tube(xa, ENTRE_BAS+0.02, pr[1], xb, yTop, pr[0], TUBE*0.65, frameMat);
        if(t) frame.add(t);
      });
    });
  })();

  /* le coin d'arche : le point le plus large au-dessus du sol */
  function cornerOf(P, side){
    var best=null, p=P.pts;
    for(var i=0;i<p.length;i++){
      if(p[i][1] < 0.15) continue;
      if(side<0 ? p[i][0]>0 : p[i][0]<0) continue;
      if(!best || Math.abs(p[i][0])>Math.abs(best[0])+1e-6) best=p[i];
    }
    return best || [side*P.bh, P.sh];
  }
  /* mi-pente du toit : à mi-longueur d'arc entre le coin et le faîte */
  function midSlope(P, side){
    var p=P.pts, c=cornerOf(P,side), seq=[], i, started=false;
    for(i=0;i<p.length;i++){
      var same = side<0 ? p[i][0]<=0.001 : p[i][0]>=-0.001;
      if(!started){ if(p[i]===c){ started=true; seq.push(p[i]); } continue; }
      if(side<0){ seq.push(p[i]); if(p[i][0]>=-0.001) break; }
      else       { seq.unshift(p[i]); if(p[i][0]<=0.001) break; }
    }
    if(side>0){
      seq=[]; started=false;
      for(i=p.length-1;i>=0;i--){
        if(!started){ if(p[i]===c){ started=true; seq.push(p[i]); } continue; }
        seq.push(p[i]); if(p[i][0]<=0.001) break;
      }
    }
    if(seq.length<2) return null;
    var tot=0, seg=[];
    for(i=0;i<seq.length-1;i++){
      var dx=seq[i+1][0]-seq[i][0], dy=seq[i+1][1]-seq[i][1];
      var l=Math.sqrt(dx*dx+dy*dy); seg.push(l); tot+=l;
    }
    var half=tot/2, acc=0;
    for(i=0;i<seg.length;i++){
      if(acc+seg[i] >= half){
        var t=(half-acc)/seg[i];
        return [seq[i][0]+(seq[i+1][0]-seq[i][0])*t, seq[i][1]+(seq[i+1][1]-seq[i][1])*t];
      }
      acc+=seg[i];
    }
    return null;
  }
  /* rentrer un point du profil sous la toile */
  function inward(pt){
    var cy=P.apex*0.40, dx=pt[0]-0, dy=pt[1]-cy;
    var L2=Math.sqrt(dx*dx+dy*dy)||1;
    return [pt[0]-dx/L2*IN, pt[1]-dy/L2*IN];
  }

  function renfortY(P, len){
    /* hauteur où l'écartement entre les deux chevrons vaut « len » */
    for(var y=P.sh; y<P.apex; y+=0.02){
      if(Math.abs(xAt(P,y,1)-xAt(P,y,-1)) <= len) return y;
    }
    return P.sh + (P.apex-P.sh)*0.38;
  }

  /* ============ TOILE ============ */
  if(showTarp){
    var tarp=new THREE.Group(); this.root.add(tarp);

    /* --- repérage des bandes du profil --- */
    var segs=[];
    for(var s2=0;s2<P.pts.length-1;s2++){
      var a1=P.pts[s2], b1=P.pts[s2+1];
      if(a1[1] > b1[1]){ var sw=a1; a1=b1; b1=sw; }      /* v = 0 toujours au bas */
      var dx=b1[0]-a1[0], dy=b1[1]-a1[1];
      var vertical=Math.abs(dy)>=Math.abs(dx);
      var side=((a1[0]+b1[0])/2) < 0 ? -1 : 1;
      var low=Math.min(a1[1],b1[1]);
      segs.push({a:a1,b:b1,vertical:vertical,side:side,low:low,len:Math.sqrt(dx*dx+dy*dy),i:s2});
    }
    /* la bande qui reçoit fenêtres et porte de côté : celle qui part du sol */
    var host={}; segs.forEach(function(g){
      if(g.low<0.02 && g.len>1.5){
        var k=g.side;
        if(!host[k] || g.len>host[k].len) host[k]=g;
      }
    });

    /* --- fenêtres : 2 (une par mur) dans la section avant, 4 sur le monopente --- */
    var nWin=(o.windows!=null)?o.windows:2;
    var winHalf=Math.min(1.25, step*0.30);
    var winZ=[z1-step/2];
    if(nWin>=4) winZ.push(z0+step/2);

    /* --- porte de côté --- */
    var sdSide=o.doorSide||-1, sdBay=o.doorBay||0;
    var sdZ = o.door ? (z0 + (sdBay+0.5)*step) : null;
    /* La porte de côté est un produit fini : sa hauteur ne bouge pas
       quand on monte l'abri. On ne la rabote que si le pan est plus
       court qu'elle, ce qui n'arrive pas sur un abri d'auto. */
    var sdMaxH = SD_H;

    segs.forEach(function(g){
      var holes=[], marks=[];
      var isHost = (host[g.side]===g);
      if(isHost && showTarp){
        if(nWin>0 && L>=8){
          /* Sur une arche courbe on ne peut pas découper un trou dans une
             bande plane : la fenêtre est alors appliquée sur la courbe,
             mais toujours à la même taille et à la même hauteur —
             30 po de large, 36 po de haut, allège à 36 po. */
          var wH=3.0, wS=3.0;
          var flatHost = (P.shape!=="round") && (g.len >= wS+wH+0.3);
          if(flatHost){
            winZ.forEach(function(zc){
              holes.push(archHole(zc, wS, winHalf, wH));
              marks.push({type:"win", u:zc, v:wS, hu:winHalf, h:wH});
            });
          } else {
            winZ.forEach(function(zc){ curvedWindow(g.side, zc, wS, wH, winHalf); });
          }
        }
        if(sdZ!==null && g.side===sdSide && g.len>=sdMaxH+0.3){
          holes.push(rectHole(sdZ, 0.02, SD_W/2, sdMaxH));
          marks.push({type:"door", u:sdZ, v:0.02, hu:SD_W/2, h:sdMaxH});
        }
      }
      var lap = (!g.vertical) ? ROOF_LAP : 0;          /* piège n°2 : joint toit/mur */
      var mesh=strip(g.a, g.b, z0, z1, holes, tarpMat, lap);
      if(mesh){ tarp.add(mesh); fillMarks(mesh, marks); }
    });

    /* fenêtre posée sur un profil courbe : pas de découpe, un panneau
       de mica appliqué qui suit la pente entre deux hauteurs */
    /* Fenêtre sur une arche courbe : on ne peut pas percer une bande
       plane, alors on tisse un panneau qui épouse la courbe du profil.
       Un panneau plat resterait enfoui dans la toile — c'est ce qui
       rendait la fenêtre invisible sur le double Rond. */
    function curvedWindow(side, zc, sill, h, halfW){
      var N=18, k, xs=[], ys=[], arc=[0];
      for(k=0;k<=N;k++){ var yy=sill+h*k/N; ys.push(yy); xs.push(xAt(P,yy,side)); }
      for(k=1;k<=N;k++){
        var dxa=xs[k]-xs[k-1], dya=ys[k]-ys[k-1];
        arc.push(arc[k-1]+Math.sqrt(dxa*dxa+dya*dya));
      }
      var total=arc[N];
      if(total<1.2) return;
      function weave(hwMax, off, mat){
        var pos=[], idx=[], j;
        var topStart=total-hwMax;
        for(j=0;j<=N;j++){
          var v=arc[j], hw=hwMax;
          if(v>topStart){
            var t=(v-topStart)/hwMax;
            hw = hwMax*Math.sqrt(Math.max(0, 1-t*t));
          }
          var j0=Math.min(N-1, j), j1=j0+1;
          var dx=xs[j1]-xs[j0], dy=ys[j1]-ys[j0];
          var Ln=Math.sqrt(dx*dx+dy*dy)||1;
          var nx=dy/Ln, ny=-dx/Ln;
          if(nx*side<0){ nx=-nx; ny=-ny; }
          var X=xs[j]+nx*off, Y=ys[j]+ny*off;
          pos.push(X, Y, zc-hw);
          pos.push(X, Y, zc+hw);
        }
        for(j=0;j<N;j++){
          var i0=j*2, i1=j*2+1, i2=(j+1)*2, i3=(j+1)*2+1;
          idx.push(i0,i1,i2, i1,i3,i2);
        }
        var g=new THREE.BufferGeometry();
        g.setAttribute("position", new THREE.Float32BufferAttribute(pos,3));
        g.setIndex(idx); g.computeVertexNormals();
        var m=new THREE.Mesh(g, mat);
        m.castShadow=false; m.receiveShadow=true;
        tarp.add(m);
      }
      weave(halfW*1.12, 0.045,
        new THREE.MeshStandardMaterial({color:0x39424C, roughness:0.7, side:THREE.DoubleSide}));
      weave(halfW, 0.075,
        new THREE.MeshStandardMaterial({color:0xB7C6D2, roughness:0.25, metalness:0.05,
          transparent:true, opacity:0.9, side:THREE.DoubleSide}));
    }

    function fillMarks(mesh, marks){
      var B=mesh.userData.basis;
      function place(node, u, v, off){
        var p=new THREE.Vector3(B.o[0],B.o[1],B.o[2])
          .addScaledVector(B.e1,u).addScaledVector(B.e2,v).addScaledVector(B.e3, off||0);
        node.position.copy(p);
        node.quaternion.setFromRotationMatrix(new THREE.Matrix4().makeBasis(B.e1,B.e2,B.e3));
        tarp.add(node);
      }
      marks.forEach(function(mk){
        if(mk.type==="win"){
          /* panneau translucide dans l'ouverture, livré bouché en usine */
          var s=new THREE.Shape();
          s.moveTo(-mk.hu,0); s.lineTo(mk.hu,0); s.lineTo(mk.hu, mk.h-mk.hu);
          s.absarc(0, mk.h-mk.hu, mk.hu, 0, PI, false);
          s.closePath();
          var g2=new THREE.Mesh(new THREE.ShapeGeometry(s,18), glassMat);
          place(g2, mk.u, mk.v, 0.012);
        } else {
          if(o.sideOpen===false){
            /* fermée : un panneau clipé, 2 fermoirs de PVC verticaux (FERM70) */
            var pn=new THREE.Mesh(new THREE.PlaneGeometry(mk.hu*2, mk.h), tarpMat);
            pn.position.set(0,0,0);
            var grp=new THREE.Group();
            pn.position.set(0, mk.h/2, 0); grp.add(pn);
            [-1,1].forEach(function(sg){
              var f=new THREE.Mesh(new THREE.BoxGeometry(0.12, mk.h*0.97, 0.12), pvcMat);
              f.position.set(sg*mk.hu*0.94, mk.h/2, 0.04); grp.add(f);
            });
            place(grp, mk.u, mk.v, 0.02);
          } else {
            /* ouverte : le panneau roulé sur le montant */
            var rl=new THREE.Group();
            var cyl=new THREE.Mesh(new THREE.CylinderGeometry(0.20,0.20,mk.h*0.96,12), tarpMat);
            cyl.position.set(-mk.hu*0.92, mk.h/2, 0); rl.add(cyl);
            [0.30,0.70].forEach(function(f){
              var st=new THREE.Mesh(new THREE.TorusGeometry(0.22,0.028,6,14),
                     new THREE.MeshStandardMaterial({color:C_ROUGE, roughness:0.6}));
              st.rotation.y=PI/2;
              st.position.set(-mk.hu*0.92, mk.h*f, 0); rl.add(st);
            });
            place(rl, mk.u, mk.v, 0.10);
          }
        }
      });
    }

    /* --- pignons : chapeau toujours couvert + logo, portes en dessous --- */
    endWall(z1, true);   /* AVANT */
    endWall(z0, false);  /* ARRIÈRE */

    function endWall(z, front){
      var sgn = front ? 1 : -1;
      /* Le chapeau part de l'épaulement, pas de la barre de porte : sinon
         la bande de quelques pouces entre les deux se lit comme un
         deuxième angle dans le toit. */
      /* Le chapeau descend juste sous la barre de porte, sinon on
         voit la barre dépasser au-dessus de l'ouverture. */
      var capY = Math.min(P.capY, A) - 0.14;
      var lx=xAt(P,capY,-1), rx=xAt(P,capY,1);

      var poly=[[lx,capY]];
      P.pts.forEach(function(p){ if(p[1] > capY+0.001) poly.push([p[0],p[1]]); });
      poly.push([rx,capY]);
      var cap=panel(poly, z+sgn*0.004, tarpMat);
      tarp.add(cap);

      /* logo : sur l'avant seulement, discret, et toujours dans le chapeau */
      if(front){
        var lg2=placeLogo(poly, Math.min((function(){
          var x0=1e9,x1=-1e9;
          poly.forEach(function(q){ x0=Math.min(x0,q[0]); x1=Math.max(x1,q[0]); });
          return (x1-x0)*0.30;
        })(), 3.4));
        if(lg2){
          var lg=new THREE.Mesh(new THREE.PlaneGeometry(lg2.w, lg2.h),
                 new THREE.MeshBasicMaterial({map:logoTexture(), transparent:true, side:THREE.DoubleSide}));
          lg.position.set(lg2.x, lg2.y, z+sgn*0.03);
          tarp.add(lg);
        }
      }

      /* Ouverture de bout : elle suit le profil de l'arche. Sur le
         double Rond, une porte fermée doit avoir les coins arrondis,
         pas la silhouette pointue d'un abri simple. */
      var NS=14;
      function sideProfile(sg){
        var out=[], k;
        for(k=0;k<=NS;k++){ var yy=capY*k/NS; out.push([xAt(P,yy,sg), yy]); }
        return out;
      }
      var Lp=sideProfile(-1), Rp=sideProfile(1);
      var opn=Lp.concat(Rp.slice().reverse());
      var open = front ? (o.frontOpen!==false) : (o.backOpen!==false);
      if(!open){
        if(famDouble){
          /* Double : deux panneaux qui se rejoignent au centre, bords
             arrondis comme l'arche. */
          tarp.add(panel(Lp.concat([[0,capY],[0,0]]), z+sgn*0.012, tarpMat));
          tarp.add(panel([[0,0],[0,capY]].concat(Rp.slice().reverse()), z+sgn*0.012, tarpMat));
          var seam=tube(0,0.05,z+sgn*0.03, 0,capY-0.05,z+sgn*0.03, 0.035,
                   new THREE.MeshStandardMaterial({color:0x2A2F35, roughness:0.8}));
          if(seam) tarp.add(seam);
        } else {
          /* Simple : la porte de bout est d'un seul morceau. */
          tarp.add(panel(opn, z+sgn*0.012, tarpMat));
        }
      } else {
        /* Ouverte : la toile roulée épouse le montant. Sur les modèles
           courbes (double Rond) le rouleau suit l'arche au lieu de la
           traverser en ligne droite. */
        [-1,1].forEach(function(sg){
          var yA=0.10, yB=Math.max(yA+1, capY*0.94);
          var N=7, ptsR=[], k;
          for(k=0;k<=N;k++){
            var yy=yA+(yB-yA)*k/N;
            ptsR.push([xAt(P,yy,sg) - sg*0.28, yy]);
          }
          var zr=z+sgn*0.20;
          for(k=0;k<N;k++){
            var t=tube(ptsR[k][0],ptsR[k][1],zr, ptsR[k+1][0],ptsR[k+1][1],zr, 0.20, tarpMat);
            if(t) tarp.add(t);
          }
          [0.32,0.72].forEach(function(f){
            var i0=Math.min(N-1, Math.floor(f*N));
            var p0=ptsR[i0], p1=ptsR[i0+1];
            var dir=new THREE.Vector3(p1[0]-p0[0], p1[1]-p0[1], 0).normalize();
            var st=new THREE.Mesh(new THREE.TorusGeometry(0.225,0.030,6,16),
                   new THREE.MeshStandardMaterial({color:C_ROUGE, roughness:0.6}));
            st.position.set((p0[0]+p1[0])/2, (p0[1]+p1[1])/2, zr);
            st.quaternion.setFromUnitVectors(new THREE.Vector3(0,0,1), dir);
            tarp.add(st);
          });
        });
      }
    }
  }

  /* ============ VÉHICULES ============ */
  this.vehGroup=new THREE.Group(); this.root.add(this.vehGroup);
  this.vehGroup.visible=this.showVeh;
  var list=o.vehicles||[];
  if(!list.length && o.veh) list=[{type:o.veh.kind||"vus", n:1}];
  var flat=[];
  list.forEach(function(v){ for(var i=0;i<(v.n||0);i++) flat.push(v.type); });
  this.vehFit=null;
  if(flat.length){
    var GAPX=1.5, GAPZ=2+2/12, SIDE=1.5;
    /* On remplit d'abord la largeur, puis on empile en profondeur :
       quatre voitures deviennent donc 2 x 2, pas quatre à la file. */
    var usable=Math.max(3, w-SIDE);
    var rows=[], cur=[], curW=0;
    flat.forEach(function(k){
      var sp=VEHS[k]||VEHS.vus;
      var add=(cur.length?GAPX:0)+sp.w;
      if(cur.length && curW+add>usable){ rows.push({v:cur,w:curW}); cur=[]; curW=0; add=sp.w; }
      cur.push(k); curW+=add;
    });
    if(cur.length) rows.push({v:cur,w:curW});

    var needL=0, needW=0, ri, ci;
    rows.forEach(function(r,i){
      var maxL=0;
      r.v.forEach(function(k){ maxL=Math.max(maxL,(VEHS[k]||VEHS.vus).l); });
      r.l=maxL;
      needL += maxL + (i?GAPZ:0);
      needW = Math.max(needW, r.w);
    });

    var zc=-needL/2, self2=this, gi=0;
    rows.forEach(function(r,i){
      if(i) zc+=GAPZ;
      var x=-r.w/2;
      r.v.forEach(function(k,j){
        var sp=VEHS[k]||VEHS.vus;
        if(j) x+=GAPX;
        var g=vehicle(k, gi++);
        g.position.set(x+sp.w/2, 0, zc+r.l/2);
        x+=sp.w;
        self2.vehGroup.add(g);
      });
      zc+=r.l;
    });
    this.vehFit={ need:needL, have:L, ok:needL<=L+0.01,
                  needW:needW+SIDE, haveW:w, okW:(needW+SIDE)<=w+0.01,
                  rows:rows.length, cols:rows[0]?rows[0].v.length:0, n:flat.length };
  }

  /* ============ COTES ============ */
  if(o.showDims){
    var L2=(o.lang==="en");
    var yTop=P.apex;
    dimLine(this.dims, [-w/2-2.2, 0.02, z0], [-w/2-2.2, 0.02, z1],
            (L2?"Length ":"Longueur ")+ftIn(L)+" · "+nBay+(L2?" sections":" sections"));
    dimLine(this.dims, [-w/2, 0.02, z1+1.1], [w/2, 0.02, z1+1.1],
            (L2?"Width ":"Largeur ")+ftIn(w));
    dimLine(this.dims, [w/2+2.6, 0, z0], [w/2+2.6, yTop, z0],
            (L2?"Total height ":"Hauteur totale ")+ftIn(yTop));
    dimLine(this.dims, [w/2+0.9, 0, z1], [w/2+0.9, A, z1],
            (L2?"Clearance ":"Hauteur libre ")+ftIn(A));
    if(dv.w) dimLine(this.dims, [-dW/2, 0.03, -dL/2-1.0], [dW/2, 0.03, -dL/2-1.0],
            (L2?"Driveway ":"Entrée ")+ftIn(dW), "#3D454F");
    if(dv.l) dimLine(this.dims, [dW/2+1.0, 0.03, -dL/2], [dW/2+1.0, 0.03, dL/2],
            (L2?"Depth ":"Profondeur ")+ftIn(dL), "#3D454F");
    var av=labelSprite(o.ori?o.ori.front:"AVANT", "#101317");
    av.position.set(0, 0.6, z1+2.8); this.dims.add(av);
  }

  function dimLine(g, a, b, txt, col){
    var mat=new THREE.MeshBasicMaterial({color:col?0x3D454F:0xE52329, depthTest:false});
    var t=tube(a[0],a[1],a[2], b[0],b[1],b[2], 0.035, mat);
    if(t){ t.renderOrder=900; t.castShadow=false; g.add(t); }
    [a,b].forEach(function(p){
      var s=new THREE.Mesh(new THREE.SphereGeometry(0.10,8,6), mat);
      s.position.set(p[0],p[1],p[2]); s.renderOrder=900; g.add(s);
    });
    var lb=labelSprite(txt, col||"#E52329");
    lb.position.set((a[0]+b[0])/2, (a[1]+b[1])/2+0.35, (a[2]+b[2])/2);
    g.add(lb);
  }

  /* ---------- repères d'orientation ---------- */
  if(o.ori){
    var off=Math.max(2.4, w*0.22);
    addOri(o.ori.front, 0, z1+off);
    addOri(o.ori.back,  0, z0-off);
    addOri(o.ori.left, -w/2-off, 0);
    addOri(o.ori.right, w/2+off, 0);
  }
  function addOri(txt,x,z){
    var s=labelSprite(txt, "#5A6470");
    s.position.set(x, 0.22, z);
    self.dims.add(s);
  }

  /* ---------- ombres et cadrage ---------- */
  this.sun.target.position.set(0,0,0);
  this.sun.target.updateMatrixWorld();
  this.dist=this._fit();
  if(!this._placed){ this.reset(); this._placed=true; }
  else { this.ctl.target.copy(this.target); this.ctl.update(); }
  this.scene=this.root;
};

Object.defineProperty(Viz.prototype, "showVeh", {
  get:function(){ return this._showVeh!==false; },
  set:function(v){ this._showVeh=!!v; if(this.vehGroup) this.vehGroup.visible=!!v; }
});

Viz.VEHS = VEHS;
Viz.ftIn = ftIn;
window.TEMPO_VIZ_2D = window.TEMPO_VIZ;
window.TEMPO_VIZ = Viz;
window.TEMPO_VIZ_IS_3D = true;
})();

(function(){
"use strict";
var D = window.TEMPO_DATA;
var M = D.MODELS, VEH = D.VEH, ACC = D.ACC, ftIn = D.ftIn, F = D.F;
var PRICES = window.TEMPO_PRICES || {};
var lang = "fr";

/* ============================================================
   RÉSOLUTION SHOPIFY
   Sur la boutique, on relit /products/<handle>.js pour obtenir
   l'id de variante, le prix réel et la disponibilité. Hors ligne
   (aperçu local), on retombe sur la table de prix embarquée.
   ============================================================ */
var shopCache = {}, shopOK = null;

function fetchProduct(handle){
  if(shopCache[handle]) return shopCache[handle];
  if(typeof fetch !== "function"){ return (shopCache[handle] = Promise.resolve(null)); }
  var url = (location.protocol.indexOf("http")===0 ? "" : D.CFG.base) + "/products/" + handle + ".js";
  /* Plafond de 4 s : une boutique lente ne doit jamais bloquer l'affichage
     de la commande, qui s'affiche de toute façon avec les prix embarqués. */
  var p = Promise.race([
    fetch(url, {credentials:"same-origin"}).then(function(r){ return r.ok ? r.json() : null; }),
    new Promise(function(res){ setTimeout(function(){ res(null); }, 4000); })
  ]).catch(function(){ return null; });
  shopCache[handle] = p;
  return p;
}
/* -> {id, price, available, title} ou null */
function resolve(handle, sku){
  if(!handle) return Promise.resolve(null);
  return fetchProduct(handle).then(function(prod){
    if(!prod || !prod.variants) return null;
    var v = null, i;
    if(sku){ for(i=0;i<prod.variants.length;i++) if(prod.variants[i].sku===sku){ v=prod.variants[i]; break; } }
    if(!v && prod.variants.length===1) v = prod.variants[0];
    if(!v) return null;
    return { id:v.id, price:v.price/100, available:v.available, title:v.title, sku:v.sku,
         compareAt:(v.compare_at_price ? v.compare_at_price/100 : null) };
  });
}
function fallbackPrice(sku, handle){
  if(sku && PRICES[sku]!==undefined) return PRICES[sku];
  if(handle && D.DOOR_PRICE[handle]!==undefined) return D.DOOR_PRICE[handle];
  return null;
}

/* ============================================================
   MOTEUR DE RECOMMANDATION
   ============================================================ */
var PAIRS = { "2voitures":["voiture","voiture"], "mixte":["voiture","vus"],
              "2vus":["vus","vus"], "2gros":["camionnette","camionnette"] };
var MIN_LEN = { voiture:16, vus:20, fourgonnette:20, camionnette:24, fourgon_haut:24 };
var GROS = { vus:1, camionnette:1, fourgonnette:1, fourgon_haut:1 };

function small(v){ return v<1 ? Math.round(v*12)+(lang==="fr"?" po":" in") : ftIn(v); }
function vehLabel(k){
  var fr={voiture:"une voiture",vus:"un VUS",camionnette:"une camionnette",fourgonnette:"une fourgonnette",fourgon_haut:"un fourgon à toit haut"};
  var en={voiture:"a car",vus:"an SUV",camionnette:"a pickup",fourgonnette:"a minivan",fourgon_haut:"a high-roof van"};
  return (lang==="fr"?fr:en)[k]||k;
}
function vehLabelN(a){
  var L=lang==="fr";
  if(!a) return "";
  if(a.nb==="1") return vehLabel(a.veh);
  var base = vehLabelPair(a.veh2);
  if(a.nb==="3grid") return L ? ("trois véhicules — "+base+" côte à côte et un troisième devant")
                              : ("three vehicles — "+base+" side by side and a third in front");
  return base;
}
function vehLabelPair(k){
  var fr={"2voitures":"deux voitures","mixte":"une voiture et un VUS","2vus":"deux VUS","2gros":"deux camionnettes"};
  var en={"2voitures":"two cars","mixte":"a car and an SUV","2vus":"two SUVs","2gros":"two pickups"};
  return (lang==="fr"?fr:en)[k]||k;
}
function vehPoss(a){
  var L=lang==="fr";
  if(a.nb==="1"){
    var fr={voiture:"votre voiture",vus:"votre VUS",camionnette:"votre camionnette",fourgonnette:"votre fourgonnette",fourgon_haut:"votre fourgon"};
    var en={voiture:"your car",vus:"your SUV",camionnette:"your pickup",fourgonnette:"your minivan",fourgon_haut:"your van"};
    return (L?fr:en)[a.veh]||(L?"votre véhicule":"your vehicle");
  }
  var fr2={"2voitures":"vos deux voitures","mixte":"votre voiture et votre VUS","2vus":"vos deux VUS","2gros":"vos deux camionnettes"};
  var en2={"2voitures":"your two cars","mixte":"your car and SUV","2vus":"your two SUVs","2gros":"your two pickups"};
  return (L?fr2:en2)[a.veh2]||(L?"vos véhicules":"your vehicles");
}
function soilLabel(k){
  var fr={asphalte:"asphalte",beton:"béton",pave:"pavé uni",gazon:"gazon ou terre",gravier:"gravier"};
  var en={asphalte:"asphalt",beton:"concrete",pave:"interlocking pavers",gazon:"grass or soil",gravier:"gravel"};
  return (lang==="fr"?fr:en)[k]||k;
}
function heightsFor(m,w,len){
  if(m.id==="double_rond") return (len===20||len===25) ? m.H.slice() : [F(7,10)];
  return m.H.slice();
}
function pickH(m,w,len,req){
  var hs=heightsFor(m,w,len);
  for(var i=0;i<hs.length;i++) if(hs[i] >= req-0.02) return hs[i];
  return null;
}
function nextLen(m,need){
  for(var i=0;i<m.L.length;i++) if(m.L[i] >= need-0.01) return m.L[i];
  return m.L[m.L.length-1];
}

function recommend(a){
  var why=[], out={ why:why, alt:null };
  var L = lang==="fr";

  /* ---------- RANGEMENT ---------- */
  if(a.usage==="rangement"){
    var big=a.quoi==="gros", lng=(a.quoi==="bois"||a.quoi==="velos");
    var id = big ? "utilitaire" : (a.rlieu==="mur" ? (lng?"mini_mono_12":"mini_mono_8") : (lng?"rangement_12":"rangement_8"));
    var m0=M[id];
    out.model=m0; out.w=m0.w[0]; out.len=m0.L[0]; out.h=m0.H[0]; out.veh=null; out.kind="rangement";
    if(big) why.push(L?"C'est le plus grand des abris de rangement : 8 pi sur 10 pi, hauteur libre de 6'4\". Assez pour une motoneige, un VTT ou de la grosse machinerie."
                      :"It's the largest storage shelter: 8 ft by 10 ft, 6'4\" clearance. Enough for a snowmobile, an ATV or large machinery.");
    if(a.rlieu==="mur"&&!big) why.push(L?"La mini-monopente a une pente unique : elle s'appuie contre un mur ou un cabanon et la neige tombe du côté opposé."
                                        :"The mini mono-slope has a single slope: it leans against a wall or shed and snow falls on the opposite side.");
    if(a.rlieu!=="mur"&&!big) why.push(L?"Le toit pointu est autonome : il tient seul, en plein espace dégagé."
                                        :"The peaked roof is free-standing: it stands on its own in open space.");
    why.push(L?"Hauteur libre de "+ftIn(m0.H[0])+", mesurée à la barre de porte."
              :"Clearance height of "+ftIn(m0.H[0])+", measured at the door bar.");
    why.push(L?"Aucune fenêtre sur ce modèle — c'est normal, tous les abris de rangement sont fermés."
              :"No windows on this model — that's normal, all storage shelters are fully enclosed.");
    return finish(out,a);
  }

  /* ---------- VÉHICULES ---------- */
  var add = D.ROOF_ADD[a.toit||"rien"]||0;
  var v1, v2=null, mode="single", nVeh=1;
  if(a.nb==="1"){ v1=VEH[a.veh]; }
  else {
    var p=PAIRS[a.veh2]||["voiture","voiture"];
    v1=VEH[p[0]]; v2=VEH[p[1]]; nVeh=2;
    mode = (a.nb==="2cote" || a.nb==="3grid") ? "cote" : "file";
    if(a.nb==="3grid"){ nVeh=3; }
    a._pair=p;
  }
  var reqH = Math.max(v1.h, v2?v2.h:0) + add + 0.25;
  var mdl, wdt, sumW;

  var maxW = a.entreeW || null;          // largeur utile de l'entrée
  if(mode==="cote"){
    sumW = v1.w + v2.w;
    var both = (a.veh2==="2vus"||a.veh2==="2gros");
    wdt = sumW<=11.5 ? 16 : (sumW<=13 ? 18 : 20);
    if(both && wdt<18) wdt=18;
    mdl = M.double_pointu;
    if(maxW){
      var want = wdt, fits = null;
      for(var wi=mdl.w.length-1; wi>=0; wi--) if(mdl.w[wi] <= maxW+0.05){ fits = mdl.w[wi]; break; }
      if(fits===null){ out.tooNarrow = {need:want, have:maxW}; wdt = mdl.w[0]; }
      else if(fits < want){ out.tooNarrow = {need:want, have:maxW}; wdt = fits; }
      else if(fits > want && sumW + 6 <= fits + 0.05){
        wdt = fits;                       // il reste de la place : on en profite
        out.upsized = true;
      }
    }
    why.push(L?"Vos deux véhicules font environ "+ftIn(sumW)+" de large ensemble. Avec le dégagement nécessaire pour ouvrir les portières des deux côtés et au centre, il vous faut un "+wdt+" pi."
              :"Your two vehicles are about "+ftIn(sumW)+" wide together. With the clearance needed to open doors on both sides and in the middle, you need "+wdt+" ft of width.");
    if(a.nb==="3grid") why.push(L?"Le troisième véhicule se gare devant les deux autres : c'est la longueur qui absorbe l'ajout, pas la largeur. On vous propose un abri double assez long pour deux rangées."
                                :"The third vehicle parks in front of the other two: the length absorbs it, not the width. We're giving you a double shelter long enough for two rows.");
    if(both) why.push(L?"Deux véhicules de cette taille n'entrent pas dans un 16 pi : il resterait environ un pied par espace, impossible d'ouvrir une portière. C'est l'erreur la plus fréquente."
                       :"Two vehicles this size won't fit in a 16 ft shelter: you'd be left with about a foot on each side — not enough to open a door. This is the most common mistake.");
  } else {
    var vkey = a.nb==="1" ? a.veh : (a._pair?a._pair[0]:"voiture");
    var reqW = v1.w + 3;
    if(a.lieu==="mur" && reqW<=10.5){
      mdl=M.monopente; wdt=10.5;
      why.push(L?"Collé sur un mur, la monopente est le bon choix : son toit à pente unique fait tomber toute la neige du côté opposé au bâtiment."
                :"Against a wall, the mono-slope is the right choice: its single-slope roof drops all the snow on the side away from the building.");
    } else if(maxW && maxW < 11 && maxW >= 10.5 && !GROS[vkey]){
      mdl=M.monopente; wdt=10.5;
      why.push(L?"Votre entrée fait "+ftIn(maxW)+" de large : le 11 pi n'y entre pas, mais la monopente de 10'6\" oui. Elle est aussi le bon choix quand l'espace est serré d'un côté."
                :"Your driveway is "+ftIn(maxW)+" wide: an 11 ft shelter won't fit, but the 10'6\" mono-slope will. It's also the right call when space is tight on one side.");
    } else if(reqW > 11){
      /* Le véhicule ne rentre pas dans un 11 pi : le 12' TA s'impose. */
      mdl=M.ta12; wdt=12;
      why.push(L?"Avec "+ftIn(v1.w)+" de large, votre véhicule ne laisse pas assez de dégagement dans un abri de 11 pi. Le 12' TA est le seul abri simple assez large."
                :"At "+ftIn(v1.w)+" wide, your vehicle doesn't leave enough clearance in an 11 ft shelter. The 12' TA is the only single shelter wide enough.");
    } else {
      /* Choix par défaut : le HD. Le client pourra descendre au Régulier
         ou monter au 12' TA depuis le sélecteur de gamme. */
      mdl=M.simple_hd; wdt=11;
      why.push(L?"On part du 11' HD : son poteau mini-ovale de calibre 16 est nettement plus rigide que le calibre 17 du régulier, pour un écart de prix modeste. C'est notre meilleur rapport qualité-prix."
                :"We start with the 11' HD: its 16-gauge mini-oval post is far more rigid than the 17-gauge post on the Regular model, for a modest price difference. It's our best value.");
      why.push(L?"Un abri simple de 11 pi laisse environ "+ftIn((11-v1.w)/2)+" de chaque côté de votre véhicule : assez pour ouvrir les portières confortablement."
                :"An 11 ft single shelter leaves about "+ftIn((11-v1.w)/2)+" on each side of your vehicle: enough to open the doors comfortably.");
      if(GROS[vkey]) why.push(L?"Vous pourrez comparer avec le 12' TA juste en dessous : un pied de plus, des murs droits, et le poteau de nos abris doubles. C'est le haut de gamme des abris simples."
                                :"You can compare with the 12' TA just below: one more foot, straight walls, and the post from our double shelters. It's the top of the single-shelter range.");
    }
  }
  if(a.vent==="expose" && mdl.id==="simple_reg") mdl=M.simple_hd;
  if(a.vent==="expose")
    why.push(L?"Terrain exposé : on vous met la version renforcée, poteau calibre 16. C'est ce qui fait la différence quand le vent pousse tout l'hiver."
              :"Exposed lot: we're giving you the reinforced version, 16-gauge post. That's what makes the difference when the wind blows all winter long.");

  var h = pickH(mdl, wdt, mdl.L[0], reqH);
  if(h===null && mdl.fam==="simple" && mdl.id!=="ta12"){ mdl=M.ta12; wdt=12; h=pickH(mdl,wdt,mdl.L[0],reqH); }
  if(h===null) out.advisor="haut";

  if(maxW){
    var gw = (mdl.geo && mdl.geo.ground) || wdt;
    var margin = (maxW - gw)/2;
    if(margin >= 0){
      why.push(L?"Votre entrée fait "+ftIn(maxW)+" de large et l'abri en occupe "+ftIn(gw)+" au sol : il vous reste "+ftIn(margin)+" de chaque côté."+
                 (margin<3.5?" C'est moins que les 4 pi conseillés pour déneiger le toit confortablement — pensez à l'accès des deux côtés."
                            :" De quoi déneiger le toit des deux côtés sans forcer.")
                :"Your driveway is "+ftIn(maxW)+" wide and the shelter takes up "+ftIn(gw)+" at ground level: that leaves "+ftIn(margin)+" on each side."+
                 (margin<3.5?" That's less than the 4 ft we recommend to clear the roof comfortably — plan your access on both sides."
                            :" Enough to clear the roof from both sides without struggling."));
    }
  }
  var vkey2 = a.nb==="1" ? a.veh : (a._pair?a._pair[0]:"voiture");
  var need = (mode==="file") ? (v1.l+v2.l+6)
           : (a.nb==="3grid") ? (Math.max(v1.l,v2?v2.l:0)*2 + 6)
           : Math.max(v1.l+4, MIN_LEN[vkey2]||16);
  var len = nextLen(mdl, need);
  if(a.entreeL){
    var cap=null;
    for(var i=0;i<mdl.L.length;i++) if(mdl.L[i] <= a.entreeL+0.01) cap=mdl.L[i];
    if(cap!==null){ if(cap<need) out.tooShort=true; len=cap; }
  }
  if(mdl.id==="double_rond") h = pickH(mdl,wdt,len,reqH);

  out.model=mdl; out.w=wdt; out.len=len; out.h=h||mdl.H[mdl.H.length-1]; out.kind="auto"; out.reqH=reqH;
  out.veh = { w:v1.w, h:v1.h, l:v1.l, n:nVeh, mode:(a.nb==="3grid"?"grid":(mode==="single"?"single":mode)) };
  if(v2){ out.veh.w=Math.max(v1.w,v2.w); out.veh.h=Math.max(v1.h,v2.h); out.veh.l=Math.max(v1.l,v2.l); }

  why.push(L?"Hauteur libre de "+ftIn(out.h)+" — mesurée à la barre de porte, pas au sommet du toit. C'est le point le plus bas, et c'est lui qui compte."
            :"Clearance height of "+ftIn(out.h)+" — measured at the door bar, not at the peak. That's the lowest point, and that's the one that counts.");
  if(add>0) why.push(L?"On a ajouté "+small(add)+" pour ce que vous avez sur le toit. Beaucoup de clients l'oublient et se retrouvent coincés."
                      :"We added "+small(add)+" for what's on your roof. Many customers forget this and get stuck.");
  why.push(L?"Longueur de "+len+" pi : de la place pour ouvrir le hayon à l'intérieur et circuler devant le véhicule."
            :"Length of "+len+" ft: room to open the tailgate inside and walk in front of the vehicle.");

  /* alternatives */
  if(mdl.id==="double_pointu" && wdt>=18 && out.h<=F(7,10)+0.02){
    var rl=nextLen(M.double_rond,len), rh=pickH(M.double_rond,wdt,rl,reqH);
    if(rh) out.alt={ model:M.double_rond, w:wdt, len:rl, h:rh,
      fr:"Le double Rond offre une plus belle ouverture et une grande hauteur au centre. Sa toile est soudée, donc parfaitement étanche — mais elle n'est pas réparable.",
      en:"The double Round offers a nicer opening and great height at the centre. Its cover is welded, so perfectly watertight — but it cannot be repaired." };
  } else if(mdl.id==="simple_reg"){
    out.alt={ model:M.simple_hd, w:11, len:len, h:out.h,
      fr:"La version HD a un poteau mini-ovale plus épais, calibre 16. Si votre entrée prend le vent ou que vous voulez le garder longtemps, ça vaut la différence.",
      en:"The HD version has a thicker mini-oval post, 16 gauge. If your driveway catches wind or you plan to keep it a long time, it's worth the difference." };
  } else if(mdl.id==="monopente"){
    var mh = pickH(M.simple_hd, 11, len, reqH);
    if(mh) out.alt={ model:M.simple_hd, w:11, len:len, h:mh,
      fr:"Si la neige peut tomber des deux côtés, l'abri simple 11' HD à toit pointu est un demi-pied plus large et coûte moins cher. La monopente ne se justifie que si un mur bloque un côté.",
      en:"If snow can fall on both sides, the 11' HD peaked single shelter is half a foot wider and costs less. The mono-slope is only worth it when a wall blocks one side." };
  } else if(mdl.id==="ta12"){
    out.alt={ model:M.simple_hd, w:11, len:len, h:pickH(M.simple_hd,11,len,reqH)||F(8,6),
      fr:"Si votre espace est vraiment serré, l'abri simple 11 pi HD entre dans une entrée plus étroite. Vous perdez un pied de largeur et le confort de circulation.",
      en:"If your space is really tight, the 11 ft HD single fits a narrower driveway. You lose a foot of width and the room to move around." };
    if(!out.alt.h) out.alt=null;
  }
  return finish(out,a);
}

/* Gamme bon / meilleur / le top — seulement pour les abris simples 11-12 pi */
function tierList(R, A){
  if(!R || R.kind!=="auto" || R.model.roof==="shed" || R.model.fam!=="simple") return null;
  var add = D.ROOF_ADD[A.toit||"rien"]||0;
  var reqH = (R.veh ? R.veh.h : 5) + add + 0.25;
  var out = [];
  for(var i=0;i<D.TIERS.length;i++){
    var t = D.TIERS[i], m = M[t.id];
    var w = m.w[0];
    var len = nextLen(m, R.len);
    var h = pickH(m, w, len, Math.max(reqH, 0));
    if(h===null) h = m.H[m.H.length-1];
    var sku = m.sku(w, len, h);
    out.push({ tier:t, model:m, w:w, len:len, h:h, sku:sku,
               price:fallbackPrice(sku), current:(m.id===R.model.id) });
  }
  return out;
}
function applyTier(R, A, modelId){
  var m = M[modelId];
  var add = D.ROOF_ADD[A.toit||"rien"]||0;
  var reqH = (R.veh ? R.veh.h : 5) + add + 0.25;
  var len = nextLen(m, R.len);
  var h = pickH(m, m.w[0], len, reqH); if(h===null) h = m.H[m.H.length-1];
  R.model = m; R.w = m.w[0]; R.len = len; R.h = h; R.rise = D.riseOf(m, R.w);
  recompute(R);
  return R;
}

function finish(out,a){
  out.rise = D.riseOf(out.model,out.w);
  out.soil = a.sol || "none";
  recompute(out);
  return out;
}
function recompute(R){
  var m=R.model, len=R.len;
  R.anchors = Math.round(D.anchorCount(m,len));
  R.pavers  = D.paverCount(m,len);
  R.sku     = m.sku(R.w, len, R.h);
  R.doorHandle = m.door ? m.door(R.w, R.h) : null;
}

/* ============================================================
   LIGNES DE COMMANDE
   Chaque ligne : {key, sku, handle, name, desc, qty, price,
                   required, checked, variantId, available}
   ============================================================ */
/* Répartit n ancrages en formats réels (6, 4, 2), le moins de paquets possible. */
function packSplit(n, sizes){
  var out=[], left=n;
  for(var i=0;i<sizes.length;i++){
    var q = Math.floor(left/sizes[i]);
    if(q>0){ out.push({size:sizes[i], qty:q}); left -= q*sizes[i]; }
  }
  if(left>0){
    var sm = sizes[sizes.length-1];
    var last = out.length ? out[out.length-1] : null;
    if(last && last.size===sm) last.qty++;
    else out.push({size:sm, qty:1});
  }
  return out;
}

function buildOrder(R, A){
  var L = lang==="fr", lines = [], soil = A.sol;
  function acc(code, qty, group, checked, warn){
    var a = ACC[code];
    return { key:code, kind:"acc", group:group, sku:a.sku, handle:a.handle, variantId:a.id,
             name:L?a.fr:a.en, desc:L?a.frD:a.enD,
             qty:Math.max(1,Math.round(qty)), price:a.price,
             checked:checked!==false, warn:warn||null };
  }

  /* ---------- 1. L'abri ---------- */
  lines.push({
    key:"shelter", kind:"shelter", group:"shelter", sku:R.sku, handle:R.model.handle,
    name:(L?R.model.nameFR:R.model.nameEN)+" — "+ftIn(R.w)+" x "+R.len+"' x "+ftIn(R.h),
    desc:L?"Structure galvanisée à 280 g/m² de zinc, toile avec portes avant et arrière, quincaillerie, cordes, ancrages cavaliers et plan de montage inclus."
          :"Galvanized structure (280 g/m² of zinc), cover with front and rear doors, hardware, ropes, U-anchors and assembly instructions included.",
    qty:1, price:fallbackPrice(R.sku), locked:true, checked:true
  });

  /* ---------- 2. Requis : l'ancrage, d'après le sol ---------- */
  var wAnchor = L
    ? "Sans ancrage adéquat, un abri de cette taille se soulève. Nos ancrages sont testés à 1000 lb chacun et un abri mal ancré n'est couvert ni par la garantie, ni par plusieurs assureurs. C'est la pièce qu'on vous demande de ne pas retirer."
    : "Without proper anchoring, a shelter this size will lift right off the ground. Our anchors are tested at 1000 lb each, and a poorly anchored shelter is covered neither by the warranty nor by many insurers. This is the one item we ask you not to remove.";
  if(soil==="gazon" || soil==="gravier"){
    packSplit(R.anchors,[4,2]).forEach(function(pk,i){
      lines.push(acc("ANCBAS"+pk.size, pk.qty, "req", true, i===0?wAnchor:null));
    });
    lines.push(acc("CAB4", Math.max(1, Math.round(R.anchors/8)), "sug", false, L
      ? "Les câbles-guides sont ce qui transmet la charge du vent aux ancrages à bascule. Sans eux, les bascules ne travaillent pas et l'abri se déforme au premier gros vent. C'est la pièce la plus souvent oubliée, et celle qu'on retrouve le plus dans les réclamations."
      : "Guy cables are what transfer wind load to the toggle anchors. Without them the toggles do nothing and the shelter twists out of shape in the first big windstorm. It's the most frequently forgotten part, and the one we see most in claims."));
  } else if(soil==="beton" || soil==="pave"){
    packSplit(R.anchors,[6,4,2]).forEach(function(pk,i){
      lines.push(acc("PER"+pk.size, pk.qty, "req", true, i===0?wAnchor:null));
    });
    lines.push(acc("SANGLETEMPO", R.anchors, "sug", false));
    lines.push(acc("MECHEPLUS", 1, "sug", false, L
      ? "Les ancrages permanents se percent au béton avec une perceuse à percussion et une mèche de 22 mm. Sans la bonne mèche, l'installation s'arrête là. C'est un achat de première année seulement."
      : "Permanent anchors are drilled into concrete with a hammer drill and a 22 mm bit. Without the right bit, the installation stops there. You only buy it once, the first year."));
  } else if(soil==="asphalte"){
    packSplit(R.anchors,[6,4,2]).forEach(function(pk,i){
      lines.push(acc("PER"+pk.size, pk.qty, "req", true, i>0?null:(L
      ? "Vos cavaliers sont inclus, mais ils s'arrachent et se replantent chaque année et l'asphalte finit par s'user aux mêmes endroits. Les permanents se percent une fois, se réutilisent, et tiennent nettement mieux dans le vent."
      : "Your U-anchors are included, but they're pulled and re-driven every year and the asphalt eventually wears out in the same spots. Permanent anchors are drilled once, reused, and hold far better in wind.")));
    });
    lines.push(acc("SANGLETEMPO", R.anchors, "sug", false));
    lines.push(acc("MECHEPLUS", 1, "sug", false));
  }
  if(soil) lines.push(acc("CORD150", 1, "sug", false));
  /* Protecteurs de patte : requis sur tous les sols. Sur pavé ils
     évitent que le bloc se fende, sur asphalte et gazon ils empêchent
     la patte de s'enfoncer et de percer. */
  lines.push(acc(R.model.paver, R.pavers, "req", true,
    soil==="pave"
      ? (L?"Sur pavé uni, la patte d'arche concentre toute la charge sur un seul bloc. Sans protecteur, le bloc se fend ou s'enfonce — et une réparation de pavé coûte bien plus cher que les protecteurs."
          :"On interlocking pavers, the arch leg concentrates all the load on a single block. Without a protector the block cracks or sinks — and repairing pavers costs far more than the protectors.")
      : (L?"La patte d'arche concentre toute la charge de l'abri sur quelques pouces carrés. Le protecteur répartit cette charge : la patte ne s'enfonce pas, ne marque pas votre surface, et l'abri reste d'aplomb tout l'hiver."
          :"The arch leg concentrates the shelter's entire load on a few square inches. The protector spreads that load: the leg doesn't sink, doesn't mark your surface, and the shelter stays level all winter.")));

  /* ---------- 3. Ce que vous avez demandé ---------- */
  if(A.pcote==="oui" && D.canSideDoor(R.model, R.len)){
    var codes = D.sideDoorFor(R.model, R.h);
    var sur = (A.pcoteSect==="bout");
    for(var ci=0; ci<codes.length; ci++){
      var sd = D.SIDEDOOR[codes[ci]];
      lines.push({
        key:"SD_"+sd.sku, kind:"sidedoor", group:"req", sku:sd.sku, handle:sd.handle, variantId:sd.id,
        name:(L?sd.fr:sd.en) + (ci===0 ? (function(){ var pl=doorPlace(R,A); return pl?" — "+pl:""; })() : ""),
        desc: ci>0 ? (L?"Complément obligatoire de la porte de côté sur cette configuration.":"Mandatory companion part for the side door in this configuration.")
              : (sur ? (L?"Dans la première ou la dernière section, la porte doit être cousue sur mesure à l'atelier de Laval et des frais de couture additionnels peuvent s'appliquer. Vérifiez auprès d'un vendeur — laissez-la dans votre demande."
                          :"In the first or last section, the door must be custom-sewn at our Laval workshop and additional sewing charges may apply. Check with an advisor — keep it on your request.")
                     : (L?"Kit auto-installable dans une section du milieu, sans couture. Vous l'installez vous-même, et elle peut aussi s'ajouter après coup."
                          :"Self-install kit in a middle section, no sewing. You install it yourself, and it can also be added later.")),
        qty:1, price:sd.price, checked:true, custom:sur
      });
    }
  }
  if(A.raccord==="oui" && R.kind==="auto"){
    var feet = A.raccordLen || 4;
    var opening = A.raccordOuv || 9;
    var fl = D.flapFor(R.model, feet);
    if(fl) lines.push({
      key:"FLAP", kind:"flap", group:"req", sku:fl.sku, handle:fl.handle, variantId:fl.id,
      name:L?fl.fr:fl.en, qty:1, price:fl.price, checked:true,
      desc:L?"Il couvre les "+feet+" pi qui séparent l'abri de votre garage. Plus de neige qui s'accumule dans l'entrebâillement, plus de vent qui s'engouffre — et on passe au sec de l'abri jusqu'à la porte."
            :"It covers the "+feet+" ft between the shelter and your garage. No more snow piling up in the gap, no more wind rushing through — and you stay dry from the shelter to the door."
    });
    var nWire = D.wirelockCount(opening);
    lines.push({
      key:"WIRE", kind:"wirelock", group:"req", sku:D.WIRELOCK.WIRE.sku, handle:D.WIRELOCK.WIRE.handle,
      variantId:D.WIRELOCK.WIRE.id, name:L?D.WIRELOCK.WIRE.fr:D.WIRELOCK.WIRE.en,
      qty:nWire, price:D.WIRELOCK.WIRE.price, checked:true,
      desc:L?"Chaque ensemble comprend un rail de 6 pi et sa broche : le rail se visse au mur, la broche y coince la toile du flap. Il en faut sur les deux montants et au-dessus de l'ouverture de "+opening+" pi, soit "+nWire+" ensembles. Le rail reste vissé à l'année."
            :"Each set includes one 6 ft rail and its locking wire: the rail screws to the wall, the wire locks the flap fabric into it. You need them on both jambs and above the "+opening+" ft opening — "+nWire+" sets. The rail stays up year-round."
    });
  }

  /* ---------- 4. Suggéré ---------- */
  if(R.doorHandle) lines.push({
    key:"door", kind:"door", group:"sug", sku:null, handle:R.doorHandle,
    name:L?"Porte Tempo-Clip de bout — "+ftIn(R.h):"Tempo-Clip end door — "+ftIn(R.h),
    desc:L?"Elle se clipse et se déclipse en quelques secondes, sans se battre avec les élastiques par −20 °C. C'est l'accessoire dont les clients nous reparlent le plus."
          :"It clips and unclips in seconds, without fighting with bungee cords at −20 °C. It's the accessory customers come back to talk about most.",
    qty:1, price:fallbackPrice(null,R.doorHandle), checked:false
  });
  lines.push(acc("LUM", 1, "sug", false));
  if(A.vent==="expose") lines.push(acc("BANDU", 2, "sug", false));
  lines.push(acc("RATP", 1, "sug", false));
  if(soil==="asphalte"||soil==="beton") lines.push(acc("GRAISSE", 1, "sug", false));

  /* Regroupement : l'abri, puis le requis, puis le suggéré. */
  var rank={shelter:0, req:1, sug:2};
  return lines.map(function(l,i){ return [l,i]; })
    .sort(function(a,b){ return (rank[a[0].group]-rank[b[0].group]) || (a[1]-b[1]); })
    .map(function(x){ return x[0]; });
}

/* Résolution en direct des id de variante et des prix */
function hydrate(lines){
  var jobs = lines.map(function(l){
    return resolve(l.handle, l.sku).then(function(v){
      if(v){
      l.variantId=v.id; l.price=v.price; l.available=v.available; l.resolved=true;
      l.compareAt = v.compareAt || null;
      if(!l.sku && v.sku) l.sku=v.sku;
      if(v.available===false){ l.checked=false; l.stockOut=true; }
      else l.stockOut=false;
      }
      return l;
    });
  });
  return Promise.all(jobs).then(function(){
    shopOK = lines.some(function(l){ return l.resolved; });
    /* La boutique répond mais cette porte n'existe pas dans ce format :
       on retire la ligne plutôt que d'afficher un article introuvable. */
    if(shopOK){
      for(var i=lines.length-1;i>=0;i--)
        if(lines[i].kind==="door" && !lines[i].resolved) lines.splice(i,1);
    }
    return lines;
  });
}
/* Le panier n'est proposé que si l'abri lui-même est résolu : on ne veut
   surtout pas qu'un client reparte avec les accessoires sans l'abri. */
/* Une porte cousue sur mesure passe obligatoirement par un conseiller :
   dans ce cas on retire le panier automatique. */
function needsAdvisor(lines){
  for(var i=0;i<lines.length;i++) if(lines[i].checked && lines[i].custom) return true;
  return false;
}
function shelterOut(lines){
  for(var i=0;i<lines.length;i++)
    if(lines[i].kind==="shelter" && lines[i].available===false) return true;
  return false;
}
function cartUrl(lines){
  if(needsAdvisor(lines) || shelterOut(lines)) return null;
  var shelter = null;
  for(var i=0;i<lines.length;i++) if(lines[i].kind==="shelter") shelter=lines[i];
  if(!shelter || !shelter.variantId) return null;
  var parts = lines.filter(function(l){ return l.checked && l.variantId && l.available!==false; })
                   .map(function(l){ return l.variantId+":"+l.qty; });
  if(!parts.length) return null;
  return D.CFG.base + "/cart/" + parts.join(",");
}
/* Passage au panier depuis la boutique.
   On écrit la trace de la configuration à TROIS endroits, parce qu'un seul
   ne suffit pas selon le thème et le mode de paiement utilisés :
     1. propriétés de la ligne « abri »  -> visibles sous l'article, dans le panier
        ET sur la commande dans l'admin. C'est l'endroit le plus fiable.
     2. note de commande                 -> bloc « Note » de la commande.
     3. attributs de panier              -> bloc « Détails supplémentaires ».
   Les propriétés dont le nom commence par « _ » sont masquées au client
   mais conservées et affichées dans l'admin Shopify.
   ============================================================ */
function checkout(lines, pack, done, fail){
  if(typeof fetch !== "function") return fail("nofetch");
  if(location.protocol.indexOf("http")!==0) return fail("local");
  var items = lines.filter(function(l){ return l.checked && l.variantId && l.available!==false; })
                   .map(function(l,i){
                     var it = {id:l.variantId, quantity:l.qty};
                     if(l.kind==="shelter") it.properties = pack.props;
                     return it;
                   });
  if(!items.length) return fail("empty");
  var H = {"Content-Type":"application/json", "Accept":"application/json"};
  fetch("/cart/add.js",{method:"POST",headers:H,credentials:"same-origin",
        body:JSON.stringify({items:items})})
    .then(function(r){
      if(!r.ok) return r.text().then(function(t){ throw new Error("add "+r.status+" "+t.slice(0,160)); });
      return fetch("/cart/update.js",{method:"POST",headers:H,credentials:"same-origin",
        body:JSON.stringify({attributes:pack.attrs, note:pack.note})});
    })
    .then(function(r2){
      if(!r2.ok) return r2.text().then(function(t){ throw new Error("update "+r2.status+" "+t.slice(0,160)); });
      return r2.json();
    })
    .then(function(cart){ done(cart); })
    .catch(function(e){ fail("http", e && e.message); });
}

/* Articles cochés qui ne peuvent pas aller au panier (rupture ou sur mesure) */
function offCart(lines){
  return lines.filter(function(l){
    return l.checked && (l.available===false || !l.variantId) && l.kind!=="shelter";
  });
}
/* Un accessoire décoché entraîne ceux qui n'ont plus de raison d'être. */
var DEPS = { PER4:["SANGLETEMPO","MECHEPLUS","GRAISSE"], ANCBAS4:["CAB4"] };
function applyDeps(lines, key, checked){
  var kids = DEPS[key];
  if(!kids) return;
  lines.forEach(function(l){
    if(kids.indexOf(l.key)>=0 && !l.required) l.checked = checked ? l.checked : false;
  });
}
function total(lines){
  var t=0, complete=true;
  lines.forEach(function(l){
    if(!l.checked) return;
    if(l.price===null||l.price===undefined){ complete=false; return; }
    t += l.price*l.qty;
  });
  return { value:t, complete:complete };
}

/* ============================================================
   CONSEILS ET MISES EN GARDE
   ============================================================ */
function tips(R,A){
  var L=lang==="fr", t=[];
  t.push({ic:"ruler", h:L?"Ce configurateur montre nos dimensions standard":"This configurator shows our standard sizes",
    b:L?"Les largeurs, longueurs et hauteurs proposées ici sont celles que nous tenons en stock. Pour une longueur irrégulière, une hauteur particulière ou une toile 4 saisons, ça se fait — mais ça passe par un vendeur. Écrivez-nous à "+D.CFG.email+" ou appelez au "+D.CFG.tel+", avec vos mesures."
       :"The widths, lengths and heights offered here are the ones we stock. An irregular length, a special height or a 4-season cover is possible — but it goes through an advisor. Email us at "+D.CFG.email+" or call "+D.CFG.tel+" with your measurements."});
  t.push({ic:"calendar", h:L?"Achetez en août ou en septembre":"Buy in August or September",
    b:L?"C'est la période où les délais sont les plus courts et les prix les meilleurs de l'année. Fin octobre et novembre, tout le Québec commande en même temps."
       :"That's when lead times are shortest and prices best. In late October and November, all of Quebec orders at once."});
  t.push({ic:"truck", h:L?"Prévoyez le transport":"Plan for transport",
    b:L?"Un abri n'arrive pas en boîte compacte : les paquets de poteaux dépassent 10 pi. Il faut une camionnette, une remorque ou un gros VUS sièges rabattus — sinon, choisissez la livraison."
       :"A shelter doesn't come in a compact box: post bundles exceed 10 ft. You need a pickup, a trailer or a large SUV with the seats folded down — otherwise choose delivery."});
  t.push({ic:"users", h:L?"Deux personnes, environ "+(R.model.fam==="double"?"3 h":"2 h"):"Two people, about "+(R.model.fam==="double"?"3 hours":"2 hours"),
    b:L?"Aucun outil requis pour le montage, sauf une perceuse à percussion si vous prenez des ancrages permanents."
       :"No tools required to assemble, except a hammer drill if you choose permanent anchors."});
  if(A.sol==="gazon"||A.sol==="gravier")
    t.push({ic:"snow", h:L?"Posez vos ancrages avant le gel":"Install your anchors before freeze-up",
      b:L?"Même si vous montez l'abri plus tard. Une fois le sol gelé, une bascule devient très difficile voire impossible à enfoncer."
         :"Even if you assemble the shelter later. Once the ground freezes, a toggle anchor becomes very hard or impossible to drive."});
  t.push({ic:"rake", h:L?"Gardez 4 pi de dégagement de chaque côté":"Keep 4 ft of clearance on each side",
    b:L?"Le toit se déneige de l'extérieur, régulièrement et des deux côtés. Pensez aussi à l'endroit où la neige tombée va s'accumuler tout l'hiver."
       :"The roof is cleared from the outside, regularly and on both sides. Also think about where the fallen snow will pile up all winter."});
  t.push({ic:"cover", h:L?"Une toile testée, une garantie qui suit":"A tested cover, a warranty that follows",
    b:L?"Toile de polyéthylène vierge 185 g/m², testée de façon indépendante par le CTT de Saint-Hyacinthe. Notre garantie couvre tout défaut de fabrication pour la durée de vie utile de l'abri."
       :"Virgin 185 g/m² polyethylene cover, independently tested by the CTT in Saint-Hyacinthe. Our warranty covers any manufacturing defect for the useful life of the shelter."});
  return t;
}

/* Section de la porte de côté, comptée depuis l'avant.
   Jamais une section de bout : le calcul est forcé sur une section
   du milieu, comme le curseur du panneau 3D. */
function doorSection(R){
  var arc=(R.model&&R.model.arc)||4;
  var nBay=Math.max(1, Math.round(R.len/arc));
  if(nBay<3) return null;
  var bay=Math.min(nBay-2, Math.max(1, R.doorBay || Math.floor(nBay/2)));
  var no=nBay-bay;                          /* numéro vu de l'avant */
  return { bay:bay, no:no, nBay:nBay, from:(no-1)*arc, to:no*arc };
}
function ordinal(n, L){
  if(!L){
    var t=n%100, u=n%10;                       /* 11e-13e font « th », pas « st » */
    return n + ((t>=11&&t<=13) ? "th" : (u===1?"st":u===2?"nd":u===3?"rd":"th"));
  }
  return n===1 ? "1re" : (n+"e");
}
/* « 4e section, côté droit » — ce que le client et l'installateur lisent. */
function doorPlace(R,A){
  var L=lang==="fr", sec=doorSection(R), out=[];
  if(sec) out.push(ordinal(sec.no,L)+(L?" section":" section"));
  var sd = R.doorSide!=null ? (R.doorSide>0?"droite":"gauche") : A.pcoteSide;
  if(sd && sd!=="nsp") out.push(L ? (sd==="gauche"?"côté gauche":"côté droit")
                                  : (sd==="gauche"?"left side":"right side"));
  var tx = out.join(L?", ":", ");
  if(sec) tx += L ? " ("+sec.from+"–"+sec.to+" pi de l'avant)"
                  : " ("+sec.from+"–"+sec.to+" ft from the front)";
  return tx;
}
function warnings(R,A){
  var L=lang==="fr", w=[];
  w.push(L?"<b>Vérifiez le règlement de votre municipalité</b> avant d'acheter : dates permises, hauteur, superficie et distances varient beaucoup d'une ville à l'autre, et certaines les interdisent complètement. La conformité est la responsabilité du propriétaire."
          :"<b>Check your municipality's by-laws</b> before buying: permitted dates, height, area and setbacks vary a lot from one city to the next, and some ban them outright. Compliance is the owner's responsibility.");
  w.push(L?"<b>Jamais de blocs de béton ni de pesées libres.</b> C'est dangereux, ça annule la garantie, et certains assureurs refusent de couvrir un abri ancré ainsi. Nos ancrages sont testés à 1000 lb chacun."
          :"<b>Never use concrete blocks or loose weights.</b> It's dangerous, it voids the warranty, and some insurers refuse to cover a shelter anchored that way. Our anchors are tested at 1000 lb each.");
  w.push(L?"<b>Gardez un minimum de 4 pi entre l'abri et un mur, ou entre deux abris.</b> C'est l'espace qu'il faut pour que la neige qui glisse du toit puisse s'accumuler tout l'hiver — et pour pouvoir déneiger le toit."
          :"<b>Keep at least 4 ft between the shelter and a wall, or between two shelters.</b> That's the space needed for snow sliding off the roof to pile up all winter — and to clear the roof.");
  w.push(L?"<b>Aucun chauffage ni appareil à combustion</b> dans l'abri : chaufferette, BBQ, génératrice. Risque d'intoxication au monoxyde de carbone et d'incendie."
          :"<b>No heaters or combustion appliances</b> in the shelter: space heater, BBQ, generator. Risk of carbon monoxide poisoning and fire.");
  w.push(L?"<b>Restez à au moins 5 pi d'une borne-fontaine</b> et à 2 pi de la rue — sous réserve du règlement de votre ville, qui a préséance."
          :"<b>Stay at least 5 ft from a fire hydrant</b> and 2 ft from the street — subject to your city's by-laws, which take precedence.");
  w.push(L?"<b>Ne suspendez rien à la structure</b> — vélos, pneus, tablettes. Ça déforme les arches et les dommages ne sont pas couverts."
          :"<b>Don't hang anything from the structure</b> — bikes, tires, shelves. It bends the arches and the damage is not covered.");
  if(A.sol==="gravier") w.push(L?"Sur pierre concassée compactée, la bascule doit atteindre le sol naturel sous la couche de pierre pour se déployer. Si le fond est trop dur, appelez-nous : il existe des ancrages plus longs."
                                :"On compacted crushed stone, the toggle must reach natural soil beneath the stone layer to deploy. If the base is too hard, call us — we have longer anchors.");
  if(R.model.welded) w.push(L?"<b>La toile du double Rond est soudée</b> — parfaitement étanche, mais <b>non réparable</b>. À savoir avant l'achat, pas après la déchirure."
                             :"<b>The double Round cover is welded</b> — perfectly watertight, but <b>not repairable</b>. Good to know before buying, not after a tear.");
  if(A.veh==="fourgon_haut") w.push(L?"<b>Faites mesurer votre fourgon.</b> Entre un toit bas et un toit haut, l'écart va de 7'6\" à 9'2\". Ne présumez jamais."
                                      :"<b>Get your van measured.</b> Roof height runs anywhere from 7'6\" to 9'2\" depending on the model. Never assume.");
  if(R.tooNarrow) w.push(L?"<b>Attention à la largeur.</b> Pour vos véhicules il faudrait un "+R.tooNarrow.need+" pi, mais votre entrée n'en fait que "+ftIn(R.tooNarrow.have)+". On vous a mis le plus grand qui entre — vérifiez avec un conseiller avant de commander, il se peut que les portières n'ouvrent pas au complet."
                          :"<b>Careful with the width.</b> Your vehicles call for "+R.tooNarrow.need+" ft of width, but your driveway is only "+ftIn(R.tooNarrow.have)+". We've fitted the largest that goes in — check with an advisor before ordering, because the doors may not open fully.");
  if(R.tooShort) w.push(L?"<b>Votre espace est plus court que la longueur recommandée.</b> On a réduit la longueur en conséquence, mais vérifiez que vous pourrez encore ouvrir votre hayon à l'intérieur."
                          :"<b>Your space is shorter than the recommended length.</b> We reduced the length accordingly, but check that you can still open your tailgate inside.");
  w.push(L?"La garantie couvre le <b>défaut de fabrication</b> pour la durée de vie utile. Les dommages de neige, de vent ou de mauvais ancrage relèvent de votre assurance habitation."
          :"The warranty covers <b>manufacturing defects</b> for the useful life of the product. Snow, wind or poor-anchoring damage falls under your home insurance.");
  return w;
}

window.TEMPO_ENGINE = {
  recommend:recommend, recompute:recompute, buildOrder:buildOrder, hydrate:hydrate,
  cartUrl:cartUrl, offCart:offCart, needsAdvisor:needsAdvisor, shelterOut:shelterOut, checkout:checkout, applyDeps:applyDeps, total:total,
  tierList:tierList, applyTier:applyTier, tips:tips, warnings:warnings, resolve:resolve,
  heightsFor:heightsFor, doorSection:doorSection, doorPlace:doorPlace, vehLabel:vehLabel, vehLabelN:vehLabelN, vehLabelPair:vehLabelPair, vehPoss:vehPoss,
  soilLabel:soilLabel, fallbackPrice:fallbackPrice,
  setLang:function(l){ lang=l; }, getLang:function(){ return lang; },
  shopReachable:function(){ return shopOK; }
};
})();

(function(){
"use strict";
var D = window.TEMPO_DATA;

/* ============================================================
   COLLECTE — chaque configuration devient une ligne dans votre
   banque de données. Une seule URL à remplir (CFG.logUrl).
   Rien n'est envoyé si l'URL est vide : l'outil fonctionne
   normalement, il ne journalise simplement pas.
   ============================================================ */

/* Identifiant de session : une seule ligne par visiteur, qu'on
   met à jour au fil de ses actions plutôt que d'en empiler dix. */
function newId(){
  var s = "";
  var chars = "0123456789abcdefghijklmnopqrstuvwxyz";
  for(var i=0;i<10;i++) s += chars.charAt(Math.floor(Math.random()*chars.length));
  return "c" + Date.now().toString(36) + s.slice(0,6);
}
var SID = (function(){
  try{
    var k = "tempo_cfg_sid", v = sessionStorage.getItem(k);
    if(!v){ v = newId(); sessionStorage.setItem(k, v); }
    return v;
  }catch(e){ return newId(); }
})();

/* Envoi « tire et oublie ». sendBeacon survit à la redirection
   vers /cart — c'est justement l'événement qu'on veut le moins
   perdre. On retombe sur fetch+keepalive si besoin. */
function send(payload){
  var url = D.CFG.logUrl;
  if(!url) return false;
  var body = JSON.stringify(payload);
  try{
    if(navigator.sendBeacon){
      var blob = new Blob([body], {type:"text/plain;charset=UTF-8"});
      if(navigator.sendBeacon(url, blob)) return true;
    }
  }catch(e){}
  try{
    fetch(url, {method:"POST", mode:"no-cors", keepalive:true,
                headers:{"Content-Type":"text/plain;charset=UTF-8"}, body:body});
    return true;
  }catch(e2){ return false; }
}

/* ============================================================
   PARTAGE ET REPRISE — la configuration tient dans l'adresse.
   Le client peut la garder, l'envoyer à son conjoint, revenir
   dessus. Et le lien se retrouve dans votre banque : un vendeur
   rouvre exactement l'écran que le client avait devant lui.
   ============================================================ */
function b64e(s){
  try{ return btoa(unescape(encodeURIComponent(s))).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,""); }
  catch(e){ return ""; }
}
function b64d(s){
  try{
    s = s.replace(/-/g,"+").replace(/_/g,"/");
    while(s.length % 4) s += "=";
    return decodeURIComponent(escape(atob(s)));
  }catch(e){ return ""; }
}
function encodeState(A, R, ORDER){
  var off=[], on=[];
  (ORDER||[]).forEach(function(l){
    if(l.locked) return;
    if(l.group==="sug" && l.checked) on.push(l.key);
    if(l.group!=="sug" && !l.checked) off.push(l.key);
  });
  var o = { a:A, m:R&&R.model&&R.model.id, w:R&&R.w, l:R&&R.len, h:R&&R.h,
            db:R&&R.doorBay, ds:R&&R.doorSide, on:on, off:off, v:1 };
  return b64e(JSON.stringify(o));
}
function decodeState(str){
  var raw = b64d(str);
  if(!raw) return null;
  try{ return JSON.parse(raw); }catch(e){ return null; }
}
function shareUrl(A, R, ORDER){
  var base = location.href.split("#")[0];
  return base + "#config=" + encodeState(A, R, ORDER);
}
/* Numero de soumission : deterministe et partage avec l'affichage (section). */
function _soumP2(n){ return ("0"+n).slice(-2); }
function _soumDate(){ var d=new Date(); return _soumP2(d.getFullYear()%100)+_soumP2(d.getMonth()+1)+_soumP2(d.getDate()); }
function _soumHash(str){ var h=5381,i; for(i=0;i<str.length;i++){ h=((h<<5)+h+str.charCodeAt(i))>>>0; } return ("0000"+(h%100000)).slice(-5); }
function soumissionNo(A, R, ORDER){
  try{ var st = encodeState(A, R, ORDER); return st ? (_soumDate()+_soumHash(st)) : ""; }catch(e){ return ""; }
}
function readUrlState(){
  var h = location.hash || "";
  var i = h.indexOf("config=");
  if(i < 0) return null;
  return decodeState(h.slice(i + 7));
}

/* ============================================================
   LIGNE DE DONNÉES — plate, une colonne par information utile.
   ============================================================ */
function row(evt, A, R, ORDER, extra){
  var L = (window.TEMPO_ENGINE && window.TEMPO_ENGINE.getLang()) === "en" ? "en" : "fr";
  var E = window.TEMPO_ENGINE, ftIn = D.ftIn;
  var tot = (E && ORDER) ? E.total(ORDER) : {value:null};
  var items = (ORDER||[]).filter(function(l){ return l.checked; });
  var o = {
    sid: SID,
    evt: evt,
    ts: (function(){ try{ return new Date().toISOString(); }catch(e){ return ""; } })(),
    lang: L,
    page: (function(){ try{ return location.href.split("#")[0]; }catch(e){ return ""; } })(),
    ref: (function(){ try{ return document.referrer || ""; }catch(e){ return ""; } })(),
    device: (function(){ try{ return (window.innerWidth < 700 ? "mobile" : "bureau"); }catch(e){ return ""; } })()
  };
  if(A){
    o.usage   = A.usage || "";
    o.nb      = A.nb || "";
    o.vehicule= A.nb === "1" ? (A.veh||"") : (A.veh2||"");
    o.toit    = A.toit || "";
    o.lieu    = A.lieu || "";
    o.entree_l= A.entreeW || "";
    o.entree_L= A.entreeL || "";
    o.sol     = A.sol || "";
    o.vent    = A.vent || "";
    o.pcote   = A.pcote === "oui" ? ((A.pcoteSide||"?") + " / " + (A.pcoteSect||"?")) : "non";
    o.raccord = A.raccord === "oui" ? ((A.raccordLen||"") + " pi / ouverture " + (A.raccordOuv||"") + " pi") : "non";
    o.quoi    = A.quoi || "";
    o.avis    = A._accepted || "";
  }
  if(R && R.model){
    o.modele    = R.model.id;
    o.modele_nom= L === "en" ? R.model.nameEN : R.model.nameFR;
    o.sku       = R.sku || "";
    o.largeur   = R.w;
    o.longueur  = R.len;
    o.hauteur   = ftIn ? ftIn(R.h) : R.h;
    o.ancrages  = R.anchors || "";
    o.trop_etroit = R.tooNarrow ? ("besoin " + R.tooNarrow.need + " pi / dispo " + R.tooNarrow.have + " pi") : "";
  }
  if(ORDER){
    o.total    = tot.value !== null ? Math.round(tot.value*100)/100 : "";
    o.nb_lignes= items.length;
    o.articles = items.map(function(l){ return (l.sku||l.key) + "x" + l.qty; }).join(" ");
  }
  o.lien = shareUrl(A, R, ORDER);
  try{ o.soumission = soumissionNo(A, R, ORDER); }catch(e){}
  if(extra) for(var k in extra) o[k] = extra[k];
  return o;
}

var last = {}, timer = null;
function track(evt, A, R, ORDER, extra){
  if(!D.CFG.logUrl) return;
  var payload = row(evt, A, R, ORDER, extra);
  /* On regroupe les ajustements de curseur : une seule ligne
     « config » par seconde plutôt qu'une par pixel déplacé. */
  if(evt === "config"){
    var sig = [payload.sku, payload.total, payload.pcote, payload.raccord].join("|");
    if(last.config === sig) return;
    last.config = sig;
    if(timer) clearTimeout(timer);
    timer = setTimeout(function(){ send(payload); }, 900);
    return;
  }
  send(payload);
}

window.TEMPO_TRACK = {
  track: track, sid: SID, shareUrl: shareUrl,
  encodeState: encodeState, readUrlState: readUrlState, send: send,
  soumission: soumissionNo
};
})();

(function(){
"use strict";
var D=window.TEMPO_DATA, I=window.TEMPO_I18N, E=window.TEMPO_ENGINE, Viz=window.TEMPO_VIZ;
var T=I.T, Q=I.QUESTIONS, IC=I.IC, M=D.MODELS, ftIn=D.ftIn, money=D.money;

var lang="fr", A={}, path=[], R=null, ORDER=[], viz=null, cur=null, seen=false, editing=false;

/* Journalisation : silencieuse et sans conséquence si CFG.logUrl est vide. */
function TRK(evt, extra){
  try{ if(window.TEMPO_TRACK) window.TEMPO_TRACK.track(evt, A, R, ORDER, extra); }catch(e){}
}

function $(id){ return document.getElementById(id); }
function tx(k){ return (T[lang]&&T[lang][k])||T.fr[k]||k; }
function fmt(s){ var a=arguments; return String(s).replace(/%(\d)/g,function(_,i){ return a[+i]; }); }
function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];}); }
function svg(p){ return '<svg viewBox="0 0 24 24">'+p+'</svg>'; }
function $$(sel,root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }

/* ---------- langue ---------- */
function applyLang(){
  E.setLang(lang);
  A.lang = lang;                       /* voyage avec le lien partagé */
  document.documentElement.lang = lang;
  $$("[data-t]").forEach(function(n){ n.textContent = tx(n.getAttribute("data-t")); });
  /* la bulle d'aide de la 3D tient sur une ligne : version courte au téléphone */
  var vh=$("vizHint");
  if(vh) vh.textContent = tx(window.matchMedia("(max-width:560px)").matches ? "vizDragM" : "vizDrag");
  $("langFR").setAttribute("aria-pressed", lang==="fr");
  $("langEN").setAttribute("aria-pressed", lang==="en");
  if(cur) renderQuestion(cur);
  if(R){ ORDER = E.buildOrder(R,A); hydrateAndRender(); renderResult(); }
  links(); logoLink();
}
function headerLogo(){
  var e=$("hdLogo"); if(e && window.TEMPO_LOGO) e.src=window.TEMPO_LOGO;
}
/* Le logo ramène à l'accueil, dans la langue courante. L'adresse vient du
   réglage « base_url » de la section : rien de codé en dur. */
function logoLink(){
  var a=$("hdLogoLink"); if(!a) return;
  var base=(D.CFG.base||"https://www.abristempo.com").replace(/\/+$/,"");
  a.href = base + (lang==="en" ? "/en" : "") + "/";
}
function links(){
  var q = lang==="fr" ? D.CFG.quoteFR : D.CFG.quoteEN;
  ["btnQuote","barQuote","advQuote","docQuote"].forEach(function(id){ var e=$(id); if(e) e.href=q; });
}

/* ---------- écrans ---------- */
function show(id){
  $$(".tscreen").forEach(function(s){ s.classList.toggle("on", s.id===id); });
  $("btnRestart").hidden = (id==="scrIntro");
  try{ $("tempo-app").scrollIntoView({behavior:"smooth",block:"start"}); }catch(e){ window.scrollTo(0,0); }
}
function progress(p){ $("progBar").style.width = Math.max(0,Math.min(100,p))+"%"; }

/* ---------- flux ---------- */
function active(){ return Q.filter(function(q){ return !q.when || q.when(A); }); }
function step(){
  if(A.usage==="gros")       return advisor("Big");
  if(A.usage==="commercial") return advisor("Com");
  if(A.usage==="entree")     return advisor("Entree");
  if(A.nb==="3large")        return advisor("Wide3");
  var list=active(), q=null;
  for(var i=0;i<list.length;i++) if(!(list[i].id in A)){ q=list[i]; break; }
  if(!q) return result();
  cur=q; editing=false;
  var idx=list.indexOf(q)+1;
  progress(idx/(list.length+1)*100);
  $("qEdit").hidden = true;
  $("qNum").hidden  = false;
  $("qNum").textContent = fmt(tx("qOf"), idx, list.length);
  renderQuestion(q);
  show("scrQuestion");
}

/* Modifier une seule réponse depuis le récapitulatif, sans perdre le reste. */
function editQ(id){
  var q=null;
  for(var i=0;i<Q.length;i++) if(Q[i].id===id) q=Q[i];
  if(!q) return;
  editing=true; cur=q;
  progress(100);
  $("qEdit").hidden = false;
  $("qNum").hidden  = true;
  renderQuestion(q);
  $("btnBack").hidden = false;
  show("scrQuestion");
}
/* On ne jette que les réponses devenues sans objet. */
function prune(){
  Q.forEach(function(q){ if(q.when && !q.when(A)) delete A[q.id]; });
  path = path.filter(function(id){ return id in A; });
}
function finishEdit(id){
  editing=false;
  $("qEdit").hidden=true; $("qNum").hidden=false;
  prune();
  if(path.indexOf(id)<0) path.push(id);
  step();          /* pose une question devenue nécessaire, sinon revient au résultat */
}
function advisor(kind){
  progress(100);
  TRK("conseiller", {motif:kind});
  $("advTitle").textContent = tx("advTitle"+kind);
  $("advText").textContent  = tx("advText"+kind);
  var a=$("advQuote");
  if(kind==="Entree"){
    a.href = D.CFG.base + (lang==="en"?"/en":"") + "/collections/abri-d-entree";
    a.querySelector("span").textContent = tx("advSeeEntree");
  } else {
    a.href = lang==="fr"?D.CFG.quoteFR:D.CFG.quoteEN;
    a.querySelector("span").textContent = tx("ctaQuote");
  }
  var bk=$("advBack").querySelector("span");
  if(kind==="Wide3") bk.textContent = lang==="fr" ? "Revenir à la question" : "Back to the question";
  else               bk.textContent = tx("restart");
  show("scrAdvisor");
}

function renderQuestion(q){
  var L=q[lang]||q.fr;
  $("qTitle").textContent=L.q;
  $("qHint").textContent=L.hint||"";
  $("qHint").style.display=L.hint?"":"none";
  var body=$("qBody"); body.innerHTML="";
  $("btnBack").hidden = path.length===0;
  $("btnNext").hidden = true;

  if(q.type==="raccord"){
    var L2 = lang==="fr";
    var pr=document.createElement("div"); pr.className="topts";
    var opts = L2
      ? [[4,"Environ 4 pieds","l'abri est presque collé au garage"],
         [7,"Environ 7 pieds","un espace de dégagement normal"],
         [10,"Environ 10 pieds","il y a une bonne distance à couvrir"]]
      : [[4,"About 4 feet","the shelter is nearly touching the garage"],
         [7,"About 7 feet","a normal clearance gap"],
         [10,"About 10 feet","there's a good distance to cover"]];
    opts.forEach(function(o){
      var b=document.createElement("button");
      b.type="button"; b.className="topt";
      b.setAttribute("aria-pressed", A[q.id]===o[0]);
      b.innerHTML='<div class="ic">'+svg(IC.wall)+'</div><div class="tx"><b>'+esc(o[1])+'</b><small>'+esc(o[2])+'</small></div>';
      b.onclick=function(){
        A[q.id]=o[0];
        var ov=parseFloat($("fOuv").value); A.raccordOuv=(ov&&ov>=2)?ov:9;
        if(editing) return finishEdit(q.id);
        path.push(q.id); step();
      };
      pr.appendChild(b);
    });
    body.appendChild(pr);
    var wr2=document.createElement("div"); wr2.className="tfields"; wr2.style.marginTop="16px";
    wr2.innerHTML='<div class="tfield"><label>'+
      (L2?"Largeur de l'ouverture à border (porte de garage, en pieds)":"Width of the opening to frame (garage door, in feet)")+
      '</label><input type="number" inputmode="numeric" min="2" max="30" step="1" id="fOuv" value="'+(A.raccordOuv||9)+'">'+
      '<small style="display:block;font-size:12px;color:var(--ink-3);margin-top:6px">'+
      (L2?"C'est ce qui détermine le nombre de rails Wirelock à visser dans le mur. Une porte simple prend habituellement 4 longueurs de 6 pi."
         :"This sets how many Wirelock rails to screw to the wall. A single door usually takes 4 lengths of 6 ft.")+
      '</small></div>';
    body.appendChild(wr2);
    return;
  }

  if(q.type==="entree"){
    var L3=lang==="fr";
    var wr=document.createElement("div"); wr.className="tfields";
    wr.innerHTML=
      '<div class="tfield"><label>'+(L3?"Largeur de l\'entrée (pieds)":"Driveway width (feet)")+
        '</label><input type="number" inputmode="decimal" min="6" max="60" step="0.5" id="fEW" value="'+(A.entreeW||"")+'" placeholder="'+(L3?"ex. 18":"e.g. 18")+'"></div>'+
      '<div class="tfield"><label>'+(L3?"Longueur disponible (pieds)":"Available length (feet)")+
        '</label><input type="number" inputmode="decimal" min="6" max="70" step="0.5" id="fEL" value="'+(A.entreeL||"")+'" placeholder="'+(L3?"ex. 24":"e.g. 24")+'"></div>';
    body.appendChild(wr);
    var hint=document.createElement("p");
    hint.className="tmini"; hint.style.textAlign="left"; hint.style.margin="0 0 18px";
    hint.textContent = L3
      ? "Mesurez du bord à bord de la surface où l'abri sera posé. Prévoyez idéalement 4 pi de dégagement de chaque côté pour déneiger le toit — on vous le rappellera."
      : "Measure edge to edge of the surface where the shelter will sit. Ideally allow 4 ft of clearance on each side to clear snow off the roof — we'll remind you.";
    body.appendChild(hint);
    var o2=document.createElement("div"); o2.className="topts";
    o2.innerHTML='<button class="topt"><div class="ic">'+svg(IC.question)+'</div><div class="tx"><b>'+
      (L3?"Je ne les ai pas sous la main":"I don't have them handy")+'</b><small>'+
      (L3?"On partira des dimensions standards pour votre véhicule.":"We'll start from the standard sizes for your vehicle.")+
      '</small></div></button>';
    body.appendChild(o2);
    $("btnNext").hidden=false;
    $("btnNext").onclick=function(){
      var w=parseFloat($("fEW").value), l=parseFloat($("fEL").value);
      A.entreeW=(w&&w>=6)?w:null; A.entreeL=(l&&l>=6)?l:null;
      A[q.id]=(A.entreeW||A.entreeL)?"oui":"non";
      if(editing) return finishEdit(q.id);
      path.push(q.id); step();
    };
    o2.querySelector("button").onclick=function(){
      A.entreeW=null; A.entreeL=null; A[q.id]="non";
      if(editing) return finishEdit(q.id);
      path.push(q.id); step();
    };
    return;
  }

  var box=document.createElement("div");
  box.className="topts"+(q.opts.length<=2?" two":"");
  q.opts.forEach(function(op){
    var t=op[lang]||op.fr;
    var b=document.createElement("button");
    b.type="button"; b.className="topt";
    b.setAttribute("aria-pressed", A[q.id]===op.v);
    b.innerHTML='<div class="ic">'+svg(op.ic)+'</div><div class="tx"><b>'+esc(t[0])+'</b>'+
                (t[1]?'<small>'+esc(t[1])+'</small>':'')+'</div>';
    b.onclick=function(){
      A[q.id]=op.v;
      if(editing) return finishEdit(q.id);
      var seenQ=false, drop={};
      for(var i=0;i<Q.length;i++){ if(Q[i].id===q.id){ seenQ=true; continue; } if(seenQ) drop[Q[i].id]=1; }
      for(var k in drop) delete A[k];
      path = path.filter(function(id){ return !drop[id] && id!==q.id; });
      path.push(q.id); step();
    };
    box.appendChild(b);
  });
  body.appendChild(box);
}
$("btnBack").onclick=function(){
  if(editing){ editing=false; $("qEdit").hidden=true; $("qNum").hidden=false; result(); return; }
  var last=path.pop();
  if(last===undefined){ reset(); return; }
  delete A[last]; step();
};

/* ============================================================
   RÉCAPITULATIF DES RÉPONSES — visible, et modifiable une par une
   ============================================================ */
var QLAB = {
  usage:["À abriter","Sheltering"], nb:["Véhicules","Vehicles"],
  veh:["Véhicule","Vehicle"], veh2:["Véhicules","Vehicles"],
  toit:["Sur le toit","On the roof"], lieu:["Emplacement","Location"],
  quoi:["À ranger","To store"], rlieu:["Emplacement","Location"],
  entree:["Entrée","Driveway"], sol:["Sol","Ground"], vent:["Terrain","Wind exposure"],
  pcote:["Porte de côté","Side door"], pcoteSide:["Côté","Side"],
  pcoteSect:["Position","Position"], raccord:["Raccord maison","House connection"],
  raccordLen:["Ouverture à couvrir","Opening to cover"]
};
function recapRows(){
  var L=lang==="fr", out=[];
  active().forEach(function(q){
    if(!(q.id in A)) return;
    var lab=(QLAB[q.id]||[q.id,q.id])[L?0:1], val="";
    if(q.id==="entree"){
      val = (A.entreeW||A.entreeL)
        ? ((A.entreeW?ftIn(A.entreeW):"?")+" x "+(A.entreeL?ftIn(A.entreeL):"?"))
        : (L?"Non fournies":"Not provided");
    } else if(q.id==="raccordLen"){
      val = (A.raccordOuv||9)+(L?" pi · abri à ":" ft · shelter ")+(A.raccordLen||4)+(L?" pi du mur":" ft from the wall");
    } else {
      for(var i=0;i<q.opts.length;i++) if(q.opts[i].v===A[q.id]) val=(q.opts[i][lang]||q.opts[i].fr)[0];
    }
    if(val) out.push({id:q.id, lab:lab, val:val});
  });
  return out;
}
var PEN='<svg viewBox="0 0 24 24"><path d="M4 20h4L18.5 9.5a2.1 2.1 0 0 0-3-3L5 17v3z"/></svg>';
function renderRecap(){
  var box=$("recapList"); if(!box) return;
  box.innerHTML="";
  var rows=recapRows();
  rows.forEach(function(r){
    var b=document.createElement("button");
    b.type="button";
    b.setAttribute("aria-label", (lang==="fr"?"Modifier — ":"Change — ")+r.lab+" : "+r.val);
    b.title = tx("recapChange");
    b.innerHTML='<i>'+esc(r.lab)+'</i><b>'+esc(r.val)+'</b>'+PEN;
    b.onclick=function(){ editQ(r.id); };
    box.appendChild(b);
  });
  setCnt("recapCnt", rows.length);
}
function setCnt(id, n){
  var e=$(id); if(!e) return;
  e.textContent = n ? (n+" "+(lang==="fr"?(n>1?"points":"point"):(n>1?"items":"item"))) : "";
  e.hidden = !n;
}

/* ============================================================
   RÉSULTAT
   ============================================================ */
function result(){
  progress(100);
  R = E.recommend(A);
  ORDER = E.buildOrder(R,A);
  window.TEMPO_R = R; window.TEMPO_ORDER = ORDER;
  renderResult();
  show("scrResult");
  setTimeout(initViz, 60);
  hydrateAndRender();
}
/* On affiche tout de suite avec les prix embarqués, puis on repasse
   avec les prix et la disponibilité en direct de la boutique. */
function hydrateAndRender(){
  renderOrder();
  var mine = ORDER;
  function done(){ if(mine===ORDER){ renderOrder(); refreshHeadlinePrice(); renderTiers(); } }
  E.hydrate(mine).then(done, done);
}
function refreshHeadlinePrice(){
  if(!R) return;
  var sh=null, i;
  for(i=0;i<ORDER.length;i++) if(ORDER[i].kind==="shelter"){ sh=ORDER[i]; break; }
  var p  = (sh && sh.price!==null && sh.price!==undefined) ? sh.price : E.fallbackPrice(R.sku);
  var ca = (sh && sh.compareAt!=null && sh.compareAt > p) ? sh.compareAt : null;
  var el=$("mPrice");
  if(el){
    if(p===null||p===undefined){ el.textContent = tx("priceOnline"); }
    else if(ca){
      el.innerHTML = '<span class="tsale">'+money(p,lang)+'</span>'+
                     ' <s class="twas">'+money(ca,lang)+'</s>';
    } else {
      el.textContent = money(p,lang);
    }
  }
  var nt=$("mPriceNote"); if(nt) nt.textContent = (p===null||p===undefined) ? "" : tx("priceNote");
}

function renderResult(){
  var m=R.model, L=lang==="fr";
  $("resTitle").textContent = R.kind==="rangement"?tx("resTitleRang"):tx("resTitleAuto");
  $("resSub").textContent = R.kind==="rangement" ? tx("resSubRang")
    : fmt(tx("resSubAuto"), E.vehLabelN(A), E.soilLabel(A.sol));
  $("mName").textContent = L?m.nameFR:m.nameEN;
  $("mSub").textContent  = L?m.specFR:m.specEN;
  $("mSku").textContent  = (L?"Code : ":"Item code: ")+R.sku;
  renderDims();
  $("whyList").innerHTML = R.why.map(function(x){ return "<li>"+x+"</li>"; }).join("");
  setCnt("whyCnt", R.why.length);

  var ab=$("altBox"); ab.innerHTML="";
  if(R.alt){
    var al=R.alt, d=document.createElement("div");
    d.className="talt";
    d.innerHTML='<div style="flex:1"><b>'+esc(L?al.model.nameFR:al.model.nameEN)+'</b><p>'+
                esc(L?al.fr:al.en)+'</p></div><button class="swap">'+esc(tx("altSwap"))+'</button>';
    d.querySelector(".swap").onclick=function(){
      var old={ model:R.model, w:R.w, len:R.len, h:R.h,
                fr:"Revenir au modèle recommandé au départ.", en:"Go back to the model we recommended first." };
      R.model=al.model; R.w=al.w; R.len=al.len; R.h=al.h; R.rise=D.riseOf(R.model,R.w);
      E.recompute(R); R.alt=old;
      ORDER=E.buildOrder(R,A);
      renderResult(); buildControls(); syncViz(true); hydrateAndRender();
    };
    ab.appendChild(d);
  }

  renderTiers();
  renderRecap();
  sizeAlerts();

  var tp=E.tips(R,A);
  $("tipsList").innerHTML = tp.map(function(t){
    return '<div class="ttip"><div class="ic">'+svg(IC[t.ic]||IC.question)+'</div><div><b>'+
           esc(t.h)+'</b><p>'+esc(t.b)+'</p></div></div>';
  }).join("");
  setCnt("tipsCnt", tp.length);
  var wl=E.warnings(R,A);
  $("warnList").innerHTML = wl.map(function(x){ return "<li>"+x+"</li>"; }).join("");
  setCnt("warnCnt", wl.length);
  links();
}
function renderTiers(){
  var card=$("tierCard"), box=$("tierList");
  var list = E.tierList(R,A);
  if(!list){ card.hidden=true; return; }
  card.hidden=false; box.innerHTML="";
  var L=lang==="fr";
  var ref = null;
  for(var i=0;i<list.length;i++) if(list[i].current) ref=list[i];
  var base = ref && ref.price!=null ? ref.price : null;
  list.forEach(function(o){
    var t=o.tier, b=document.createElement("button");
    b.type="button"; b.className="ttier";
    b.setAttribute("aria-pressed", o.current);
    var delta = "";
    if(base!==null && o.price!=null && !o.current){
      var d = o.price - base;
      delta = '<span class="'+(d>0?"up":"dn")+'">'+(d>0?"+":"−")+money(Math.abs(d),lang)+'</span>';
    } else if(o.current){
      delta = '<span>'+esc(L?"votre choix":"your choice")+'</span>';
    }
    b.innerHTML =
      '<span class="rad"><i></i></span>'+
      '<span>'+
        '<span class="lab">'+esc(L?t.labFR:t.labEN)+
          (t.recommended?'<span class="best">'+esc(L?"Recommandé":"Recommended")+'</span>':'')+'</span>'+
        '<h4>'+esc(L?o.model.nameFR:o.model.nameEN)+'</h4>'+
        '<p class="sub">'+esc(L?t.tagFR:t.tagEN)+'</p>'+
        '<ul>'+(L?t.proFR:t.proEN).map(function(x){ return "<li>"+esc(x)+"</li>"; }).join("")+'</ul>'+
      '</span>'+
      '<span class="amt"><b>'+(o.price==null?esc(tx("priceOnline")):money(o.price,lang))+'</b>'+delta+'</span>';
    b.onclick=function(){
      if(o.current) return;
      E.applyTier(R,A,o.model.id);
      R.alt=null;
      ORDER=E.buildOrder(R,A);
      renderResult(); buildControls(); syncViz(true); hydrateAndRender();
      TRK("modele", {gamme:o.tier.key});
    };
    box.appendChild(b);
  });
}
function renderDims(){
  $("mDims").innerHTML =
    cell(tx("dimW"), ftIn(R.w), D.metric(R.w)) +
    cell(tx("dimL"), R.len+"'", D.metric(R.len)) +
    cell(tx("dimH"), ftIn(R.h), tx("hAtDoor"));
  function cell(l,v,s){ return '<div><span>'+esc(l)+'</span><b>'+esc(v)+'</b><small>'+esc(s)+'</small></div>'; }
}

/* ---------- lignes de commande ---------- */
var CHK='<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';
var GRP = {
  shelter:{fr:["Votre abri",""],                    en:["Your shelter",""]},
  req:    {fr:["Requis pour votre configuration","On explique pourquoi avant de vous laisser le retirer"],
           en:["Required for your setup","We explain why before letting you remove it"]},
  sug:    {fr:["Suggéré pour vous","Cochez ce qui vous intéresse"],
           en:["Suggested for you","Check off whatever interests you"]}
};
var openWarn = null;

function renderOrder(){
  window.TEMPO_ORDER = ORDER;      /* la référence globale suit les reconstructions */
  var L=lang==="fr", box=$("orderLines");
  box.innerHTML="";
  var last=null;
  ORDER.forEach(function(l){
    var g = l.group||"sug";
    if(g!==last){
      last=g;
      var h=document.createElement("div"); h.className="tgrp";
      h.innerHTML='<b>'+esc((L?GRP[g].fr:GRP[g].en)[0])+'</b>'+
        ((L?GRP[g].fr:GRP[g].en)[1]?'<small>'+esc((L?GRP[g].fr:GRP[g].en)[1])+'</small>':'');
      box.appendChild(h);
    }
    box.appendChild(lineEl(l));
  });
  refreshTotals();
}

function lineEl(l){
  var L=lang==="fr";
  var row=document.createElement("div");
  row.className="tline"+(l.checked?"":" off");
  var badge = l.kind==="shelter" ? '<span class="pill inc">'+esc(tx("yourShelter"))+'</span>'
            : l.group==="req"    ? '<span class="pill req">'+esc(l.warn?tx("required"):tx("asked"))+'</span>'
            : '<span class="pill sug">'+esc(tx("suggested"))+'</span>';
  var skuPill = l.sku ? '<span class="pill sku">'+esc(l.sku)+'</span>' : '';
  var unit = (l.price==null) ? tx("priceOnline") : money(l.price,lang);
  var tot  = (l.price==null) ? "—" : money(l.price*l.qty,lang);
  var flags = "";
  var oos = (l.available===false);
  if(oos)           flags += '<span class="pill req">'+esc(tx("oosPill"))+'</span>';
  else if(l.custom) flags += '<span class="pill req">'+esc(L?"Sur mesure — par un conseiller":"Custom — via an advisor")+'</span>';
  if(oos) row.className += " oos";
  row.innerHTML =
    '<button class="tcheck" aria-checked="'+(l.checked?"true":"false")+'"'+((l.locked||oos)?" disabled":"")+
      ' aria-label="'+esc(l.name)+'">'+CHK+'</button>'+
    '<div class="tx"><b>'+esc(l.name)+'</b><small>'+esc(l.desc||"")+'</small>'+
      '<div class="meta">'+badge+skuPill+
      (l.qty>1?'<span class="pill sku">'+tx("sumQty")+' '+l.qty+'</span>':'')+flags+'</div></div>'+
    '<div class="amt"><b>'+esc(tot)+'</b>'+(l.qty>1?'<small>'+esc(unit)+' '+tx("each")+'</small>':'')+'</div>'+
    (oos ? '<div class="tline-oos"><b>'+esc(L?"En rupture de stock.":"Out of stock.")+'</b> '+
           esc(tx("oosLine").replace(/^[^.]*\.\s*/, "")) + '</div>' : '');

  if(!l.locked && !oos){
    row.querySelector(".tcheck").onclick=function(){
      if(l.checked && l.warn){ showWarn(row,l); return; }   /* on explique avant de retirer */
      l.checked=!l.checked;
      E.applyDeps(ORDER,l.key,l.checked);
      renderOrder();
    };
  }
  return row;
}

/* Panneau d'explication avant qu'un article requis soit retiré. */
function showWarn(row,l){
  if(row.querySelector(".tline-warn")) return;
  var L=lang==="fr";
  var w=document.createElement("div");
  w.className="tline-warn";
  w.innerHTML='<p><b>'+esc(L?"Avant de retirer cet article :":"Before you remove this item:")+'</b> '+esc(l.warn)+'</p>'+
    '<div class="btns"><button class="keep">'+esc(L?"Le garder":"Keep it")+'</button>'+
    '<button class="drop">'+esc(L?"Je comprends, le retirer quand même":"I understand, remove it anyway")+'</button></div>';
  row.appendChild(w);
  w.querySelector(".keep").onclick=function(){ w.remove(); };
  w.querySelector(".drop").onclick=function(){
    l.checked=false; E.applyDeps(ORDER,l.key,false); renderOrder();
  };
}

function refreshTotals(){
  var t=E.total(ORDER);
  var v = t.complete ? money(t.value,lang) : money(t.value,lang)+" +";
  $("ordTotalVal").textContent=v;
  $("barTotal").textContent=v;
  var url=E.cartUrl(ORDER);
  var on = !!url;
  ["btnCart","barCart"].forEach(function(id){
    var e=$(id);
    e.href="#";
    e.onclick=function(ev){ ev.preventDefault(); if(on) openDisc(); };
    if(on){ e.removeAttribute("aria-disabled"); e.style.pointerEvents=""; e.style.opacity=""; }
    else  { e.setAttribute("aria-disabled","true"); e.style.pointerEvents="none"; e.style.opacity=".45"; }
  });
  var oosShelter = E.shelterOut(ORDER);
  var adv = E.needsAdvisor(ORDER) && !oosShelter;
  $("oosBox").hidden = !oosShelter;
  $("advBox").hidden = !adv;
  if(adv) $("advNeedTx").textContent = tx("advNeedTx");
  $("cartNote").textContent = (adv||oosShelter) ? "" : (on ? tx("cartReady") : tx("cartOffline"));
  $("btnCart").hidden = adv || oosShelter;
  $("barCart").hidden = adv || oosShelter;
  buildSummary();
  syncUrl();
  TRK("config");
}
/* L'adresse suit la configuration : un signet ou un retour arrière la retrouve. */
var urlTimer=null;
function syncUrl(){
  if(!window.TEMPO_TRACK || !R) return;
  if(urlTimer) clearTimeout(urlTimer);
  urlTimer = setTimeout(function(){
    try{
      if(!history.replaceState) return;
      var h = "#config=" + window.TEMPO_TRACK.encodeState(A,R,ORDER);
      if(location.hash !== h) history.replaceState(null, "", location.href.split("#")[0] + h);
    }catch(e){}
  }, 500);
}

/* ---------- bon de commande ---------- */
function pad(v,n){ v=String(v); while(v.length<n) v+=" "; return v; }
function padL(v,n){ v=String(v); while(v.length<n) v=" "+v; return v; }

function buildSummary(){
  if(!R) return;
  var L=lang==="fr";
  var logo=$("docLogo"); if(logo && window.TEMPO_LOGO) logo.src=window.TEMPO_LOGO;
  try{
    $("docDate").textContent = new Date().toLocaleDateString(L?"fr-CA":"en-CA",
      {year:"numeric",month:"long",day:"numeric"});
  }catch(e){ $("docDate").textContent=""; }

  /* étiquettes de configuration */
  var cfg=[];
  cfg.push(ftIn(R.w)+" x "+R.len+"' x "+ftIn(R.h)+" "+(L?"libre":"clearance"));
  if(R.kind==="auto") cfg.push(E.vehLabelN(A));
  if(A.toit&&A.toit!=="rien") cfg.push(L?"accessoire de toit":"roof accessory");
  if(A.entreeW||A.entreeL) cfg.push((L?"entrée déclarée ":"declared driveway ")+
    (A.entreeW?ftIn(A.entreeW):"?")+" x "+(A.entreeL?ftIn(A.entreeL):"?"));
  if(A.sol) cfg.push(E.soilLabel(A.sol));
  if(A.lieu) cfg.push({degage:L?"entrée dégagée":"open driveway",mur:L?"contre un mur":"against a wall",
                       etroit:L?"espace étroit":"narrow space"}[A.lieu]||"");
  if(A.vent==="expose") cfg.push(L?"terrain exposé":"exposed lot");
  if(A.pcote==="oui"){
    var pl=E.doorPlace(R,A);
    cfg.push((L?"porte de côté":"side door")+(pl?" — "+pl:""));
  }
  if(A.raccord==="oui") cfg.push((L?"raccord maison sur ":"house connection over ")+(A.raccordLen||4)+(L?" pi":" ft"));
  $("docCfg").innerHTML = cfg.filter(Boolean).map(function(c){ return "<span>"+esc(c)+"</span>"; }).join("");

  /* lignes */
  var rows="", t=0, complete=true, lastG=null, txt=[];
  txt.push(tx("sumTitle"));
  txt.push("");
  txt.push(cfg.filter(Boolean).join(" · "));
  txt.push("");
  ORDER.forEach(function(l){
    if(!l.checked) return;
    var g=l.group||"sug";
    if(g!==lastG){
      lastG=g;
      var gl=(L?GRP[g].fr:GRP[g].en)[0];
      rows+='<tr class="grp"><td colspan="5">'+esc(gl)+"</td></tr>";
      txt.push("— "+gl.toUpperCase()+" —");
    }
    var u=(l.price==null)?tx("priceOnline"):money(l.price,lang);
    var m=(l.price==null)?"—":money(l.price*l.qty,lang);
    if(l.price==null) complete=false; else t+=l.price*l.qty;
    rows+='<tr><td class="code">'+esc(l.sku||"—")+'</td><td>'+esc(l.name)+
          '</td><td class="r">'+l.qty+'</td><td class="r">'+esc(u)+'</td><td class="r">'+esc(m)+"</td></tr>";
    txt.push(pad(l.sku||"—",13)+pad("x"+l.qty,5)+padL(m,13)+"  "+l.name);
  });
  /* pièces nécessaires mais en rupture : elles ne sont pas cochées, mais on les
     inscrit quand même sur le bon de commande pour que le conseiller les voie. */
  var oosL = ORDER.filter(function(l){ return l.available===false && !l.checked && l.group==="req"; });
  if(oosL.length){
    var gl2 = L?"EN RUPTURE DE STOCK — À CONFIRMER AVEC UN CONSEILLER"
               :"OUT OF STOCK — TO CONFIRM WITH AN ADVISOR";
    rows+='<tr class="grp"><td colspan="5">'+esc(gl2)+"</td></tr>";
    txt.push("— "+gl2+" —");
    oosL.forEach(function(l){
      var m2=(l.price==null)?"—":money(l.price*l.qty,lang);
      rows+='<tr><td class="code">'+esc(l.sku||"—")+'</td><td>'+esc(l.name)+
            '</td><td class="r">'+l.qty+'</td><td class="r">'+esc((l.price==null)?tx("priceOnline"):money(l.price,lang))+
            '</td><td class="r">'+esc(m2)+"</td></tr>";
      txt.push(pad(l.sku||"—",13)+pad("x"+l.qty,5)+padL(m2,13)+"  "+l.name+(L?"  (en rupture)":"  (out of stock)"));
    });
    txt.push("");
  }
  $("docRows").innerHTML = rows;
  $("docTotal").textContent = money(t,lang)+(complete?"":" +");
  txt.push("");
  txt.push(tx("sumTotalTx")+" : "+money(t,lang)+(complete?"":" +"));

  var notes=[];
  if(!complete) notes.push(L?"Certains articles sont affichés au prix courant en ligne : le montant final peut varier légèrement."
                            :"Some items show the current online price: the final amount may vary slightly.");
  var off = E.offCart(ORDER);
  if(off.length) notes.push((L?"À commander avec un conseiller : ":"To order with an advisor: ")+
    off.map(function(o){ return o.sku||o.name; }).join(", ")+".");
  if(E.shelterOut(ORDER)) notes.push(L?"Abri en rupture de stock : commande à confirmer par courriel, un conseiller vous donne la date de disponibilité."
                                      :"Shelter out of stock: order to be confirmed by email; an advisor will give you the availability date.");
  if(oosL.length) notes.push((L?"En rupture de stock au moment de la configuration : "
                               :"Out of stock at the time of configuration: ")+
    oosL.map(function(o){ return o.sku||o.name; }).join(", ")+
    (L?". Ces pièces sont nécessaires : un conseiller confirme la date de retour en stock."
      :". These parts are required: an advisor will confirm the restock date."));
  if(A._accepted){
    var dt=A._accepted;
    try{ dt = new Date(A._accepted).toLocaleString(L?"fr-CA":"en-CA"); }catch(e){}
    notes.push((L?"Avis de responsabilité accepté par le client le ":"Liability notice accepted by the customer on ")+dt+
               (L?" — dimensions de véhicule approximatives, configuration suggérée d'après les informations fournies, vérification du règlement municipal à la charge du client."
                  :" — approximate vehicle dimensions, configuration suggested from the information provided, municipal by-law verification is the customer's responsibility."));
  }
  try{ notes.push((L?"Référence de configuration : ":"Configuration reference: ")+window.TEMPO_TRACK.sid+
                  (L?" — mentionnez-la à votre conseiller, il retrouve exactement cet écran."
                    :" — give this reference to your advisor and they'll pull up this exact screen.")); }catch(e){}
  notes.push(L?"Dimensions standard : ce bon reprend les formats que nous tenons en stock. Longueur irrégulière, hauteur particulière ou toile 4 saisons — c'est possible, mais ça passe par un vendeur ("+D.CFG.email+" · "+D.CFG.tel+")."
              :"Standard sizes: this sheet lists the formats we stock. Irregular length, special height or a 4-season cover is possible, but it goes through an advisor ("+D.CFG.email+" · "+D.CFG.tel+").");
  notes.push(L?"Prix en dollars canadiens, avant taxes et livraison. Recommandation indicative : mesurez votre espace et votre véhicule avant de commander, et vérifiez le règlement de votre municipalité."
              :"Prices in Canadian dollars, before taxes and delivery. Indicative recommendation: measure your space and vehicle before ordering, and check your municipality's by-laws.");
  $("docNote").innerHTML = notes.map(function(n){ return esc(n); }).join("<br>");

  $("docCo").textContent   = D.CFG.company;
  $("docAddr").textContent = D.CFG.address;
  $("docTel").textContent  = D.CFG.tel;
  $("docWeb").textContent  = D.CFG.web;

  if(A._accepted){
    txt.push("");
    txt.push((L?"Avis de responsabilité accepté le ":"Liability notice accepted on ")+A._accepted);
  }
  txt.push("");
  try{ txt.push((L?"Référence : ":"Reference: ")+window.TEMPO_TRACK.sid); }catch(e){}
  try{ txt.push((L?"Lien : ":"Link: ")+myLink()); }catch(e){}
  txt.push("");
  txt.push(D.CFG.company+" · "+D.CFG.address);
  txt.push(D.CFG.tel+" · "+D.CFG.web);
  $("summaryTx").textContent = txt.join("\n");
  window.TEMPO_SUMMARY = txt.join("\n");
}
$("btnPrint").onclick=function(){ TRK("impression"); window.print(); };
/* ---------- avis de responsabilité avant le panier ---------- */
var discOK=false;
function openDisc(){
  var e=$("discLogo"); if(e && window.TEMPO_LOGO) e.src=window.TEMPO_LOGO;
  $("d1").checked=$("d2").checked=$("d3").checked=false;
  $("discErr").textContent="";
  $("disc2Err").textContent="";
  var cb=$("disc2Cart"); cb.disabled=false;
  cb.querySelector("span").textContent = tx("disc2Cart");
  discStep(1);
  $("disc").hidden=false;
}
$("discNo").onclick=function(){ closeDisc(); };
$("disc").onclick=function(ev){ if(ev.target===this) closeDisc(); };
function closeDisc(){ $("disc").hidden=true; discStep(1); }
function discStep(n){
  $("discStep1").hidden = (n!==1);
  $("discF1").hidden    = (n!==1);
  $("discStep2").hidden = (n!==2);
  $("discF2").hidden    = (n!==2);
  $("discT").textContent = (n===1) ? tx("discTitle") : tx("disc2Title");
}
$("discYes").onclick=function(){
  if(!($("d1").checked && $("d2").checked && $("d3").checked)){
    $("discErr").textContent = lang==="fr"
      ? "Cochez les trois cases pour continuer — c'est ce qui nous permet de vous servir correctement."
      : "Check all three boxes to continue — that's what lets us serve you properly.";
    return;
  }
  var stamp = (function(){ try{ return new Date().toISOString(); }catch(e){ return ""; } })();
  A._accepted = stamp;
  buildSummary();
  $("discErr").textContent="";
  $("disc2Err").textContent="";
  discStep(2);
};
$("disc2Close").onclick=function(){ closeDisc(); };
$("disc2Print").onclick=function(){ TRK("impression"); window.print(); };
$("disc2Cart").onclick=function(){
  var L = lang==="fr";
  var pack = tracePack(A._accepted);
  var url  = E.cartUrl(ORDER);          /* lien-panier Shopify, valable depuis n'importe où */
  var btn  = this;
  TRK("panier");                        /* envoyé avant toute redirection */

  /* Hors boutique (aperçu local, autre domaine), l'appel AJAX est
     impossible. On ouvre alors directement le panier de la boutique,
     dans le geste du clic pour ne pas être bloqué par le navigateur. */
  if(typeof fetch !== "function" || location.protocol.indexOf("http") !== 0){
    if(url){
      window.open(url, "_blank", "noopener");
      $("disc2Err").textContent = L
        ? "Votre panier vient de s'ouvrir sur abristempo.com avec tous vos articles. Depuis cet aperçu, votre configuration ne peut pas être jointe automatiquement à la commande : imprimez-la ou envoyez-la-nous."
        : "Your cart just opened on abristempo.com with all your items. From this preview, your configuration cannot be attached to the order automatically: print it or send it to us.";
    } else {
      $("disc2Err").textContent = L
        ? "Cette configuration se commande avec un conseiller. Imprimez votre bon de commande ou envoyez-le-nous."
        : "This configuration is ordered through an advisor. Print your order form or send it to us.";
    }
    return;
  }

  btn.disabled = true;
  $("disc2Err").textContent = L ? "Un instant, on prépare votre panier…" : "One moment, preparing your cart…";
  E.checkout(ORDER, pack,
    function(){ location.href = "/cart"; },
    function(reason, detail){
      /* La boutique n'a pas répondu : on ne laisse pas le client sans
         panier. Le lien-panier prend le relais, et la configuration
         reste tracée dans la banque et sur le bon de commande. */
      if(url){ location.href = url; return; }
      btn.disabled = false;
      btn.querySelector("span").textContent = tx("disc2Cart");
      $("disc2Err").textContent = L
        ? "La boutique n'a pas répondu comme prévu. Imprimez votre bon de commande ou envoyez-le-nous : un conseiller finalise la commande avec vous."
        : "The store did not respond as expected. Print your order form or send it to us: an advisor will finalize the order with you.";
    });
};

/* Trois canaux de trace : propriétés de ligne, note de commande, attributs. */
function tracePack(stamp){
  var L=lang==="fr";
  var dt = stamp; try{ dt = new Date(stamp).toLocaleString(L?"fr-CA":"en-CA"); }catch(e){}
  var props = {};
  props[L?"Configuré en ligne":"Configured online"] = L?"Configurateur d'abri Tempo":"Tempo shelter configurator";
  props[L?"Dimensions":"Dimensions"] = ftIn(R.w)+" x "+R.len+"' x "+ftIn(R.h)+(L?" (hauteur libre)":" (clearance)");
  if(R.kind==="auto") props[L?"Véhicule déclaré":"Declared vehicle"] =
    (E.vehLabelN(A))+(A.toit&&A.toit!=="rien"?(L?" + accessoire de toit":" + roof accessory"):"");
  if(A.entreeW||A.entreeL) props[L?"Entrée déclarée":"Declared driveway"] =
    (A.entreeW?ftIn(A.entreeW):"?")+" x "+(A.entreeL?ftIn(A.entreeL):"?");
  if(A.sol) props[L?"Sol déclaré":"Declared ground"] = E.soilLabel(A.sol);
  if(A.pcote==="oui") props[L?"Porte de côté":"Side door"] =
    (A.pcoteSect==="bout" ? ((A.pcoteSide==="droite"?(L?"côté droit":"right side"):(L?"côté gauche":"left side"))+" · "+
                             (L?"1re ou dernière section — couture sur mesure":"first or last section — custom sewing"))
                          : E.doorPlace(R,A));
  if(A.raccord==="oui") props[L?"Raccord maison":"House connection"] =
    (A.raccordLen||4)+(L?" pi entre l'abri et le garage · ouverture ":" ft between shelter and garage · opening ")+(A.raccordOuv||9)+(L?" pi":" ft");
  props[L?"Avis de responsabilité accepté":"Liability notice accepted"] = dt;
  /* Le lien rouvre l'écran exact du client : un vendeur voit ce qu'il a vu. */
  try{ props["_"+(L?"Lien de la configuration":"Configuration link")] = myLink(); }catch(e){}
  try{ props["_"+(L?"Numéro de session":"Session ID")] = window.TEMPO_TRACK.sid; }catch(e){}
  props["_"+(L?"Configuration complète":"Full configuration")] = window.TEMPO_SUMMARY || "";

  var attrs = {};
  for(var k in props) if(k.charAt(0)!=="_") attrs[k] = props[k];
  attrs["_"+(L?"Lien de la configuration":"Configuration link")] = props["_"+(L?"Lien de la configuration":"Configuration link")] || "";
  attrs["_"+(L?"Numéro de session":"Session ID")] = props["_"+(L?"Numéro de session":"Session ID")] || "";
  attrs["_"+(L?"Configuration complète":"Full configuration")] = window.TEMPO_SUMMARY || "";

  var note = (L?"— CONFIGURATEUR D'ABRI TEMPO —\n":"— TEMPO SHELTER CONFIGURATOR —\n") + (window.TEMPO_SUMMARY||"");
  return { props:props, attrs:attrs, note:note };
}
function sectionNo(){
  var sec=E.doorSection(R);
  return sec ? sec.no : 1;
}

$("advPrint").onclick=function(){ TRK("impression"); window.print(); };
if($("oosPrint")) $("oosPrint").onclick=function(){ TRK("impression"); window.print(); };
if($("oosMail"))  $("oosMail").onclick=function(){
  var b=$("mailBox"); b.hidden=false;
  try{ b.scrollIntoView({behavior:"smooth",block:"center"}); $("mName2").focus(); }catch(e){}
};
$("advMail").onclick=function(){
  var b=$("mailBox"); b.hidden=false;
  try{ b.scrollIntoView({behavior:"smooth",block:"center"}); $("mName2").focus(); }catch(e){}
};
$("btnMailOpen").onclick=function(){
  var b=$("mailBox"); b.hidden=!b.hidden;
  if(!b.hidden) try{ $("mName2").focus(); }catch(e){}
};
/* ---------- coordonnées du client ---------- */
function leadFields(){
  return { nom:($("mName2").value||"").trim(), tel:($("mTel").value||"").trim(),
           courriel:($("mMail")?($("mMail").value||"").trim():""),
           ville:($("mCity").value||"").trim() };
}
function leadValid(f){ return f.nom.length>=2 && f.tel.replace(/\D/g,"").length>=10; }
function mailHref(f){
  var L=lang==="fr";
  var head = (L?"Bonjour,\n\nVoici ma configuration faite avec le configurateur d'abri Tempo.\n\nNom : "
                :"Hello,\n\nHere is my configuration from the Tempo shelter configurator.\n\nName: ")+f.nom+
             (L?"\nTéléphone : ":"\nPhone: ")+f.tel+
             (f.courriel?((L?"\nCourriel : ":"\nEmail: ")+f.courriel):"")+
             (f.ville?((L?"\nVille : ":"\nCity: ")+f.ville):"")+"\n\n";
  var link = "";
  try{ link = (L?"Lien de ma configuration : ":"My configuration link: ")+
              window.TEMPO_TRACK.shareUrl(A,R,ORDER)+"\n\n"; }catch(e){}
  return "mailto:"+D.CFG.email+"?subject="+encodeURIComponent(tx("mailSubject")+" — "+f.nom)+
         "&body="+encodeURIComponent(head+link+(window.TEMPO_SUMMARY||""));
}
$("btnMailSend").onclick=function(ev){
  var f=leadFields();
  if(!leadValid(f)){ ev.preventDefault(); $("mailErr").textContent = tx("leadErr"); return; }
  $("mailErr").textContent="";
  TRK("contact", f);
  this.href = mailHref(f);
};
if($("btnLeadSend")) $("btnLeadSend").onclick=function(){
  var f=leadFields();
  if(!leadValid(f)){ $("mailErr").textContent = tx("leadErr"); return; }
  $("mailErr").textContent="";
  TRK("contact", f);
  if(D.CFG.logUrl){
    $("leadOK").hidden=false;
    this.disabled=true;
    this.querySelector("span").textContent = lang==="fr" ? "Envoyé ✓" : "Sent ✓";
    try{ $("leadOK").scrollIntoView({behavior:"smooth",block:"center"}); }catch(e){}
  } else {
    location.href = mailHref(f);       /* sans banque configurée, on retombe sur le courriel */
  }
};

/* ---------- copier ---------- */
function copyTo(text, span, okKey, backKey){
  function done(){ span.textContent=tx(okKey); setTimeout(function(){ span.textContent=tx(backKey); },1900); }
  if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done,fb);
  else fb();
  function fb(){
    var ta=document.createElement("textarea"); ta.value=text;
    ta.style.position="fixed"; ta.style.opacity=0;
    document.body.appendChild(ta); ta.select();
    try{ document.execCommand("copy"); done(); }catch(e){}
    document.body.removeChild(ta);
  }
}
$("btnCopy").onclick=function(){ copyTo($("summaryTx").textContent, this.querySelector("span"), "copied", "copy"); };

/* ---------- partager sa configuration ---------- */
function myLink(){
  try{ return window.TEMPO_TRACK.shareUrl(A,R,ORDER); }catch(e){ return location.href; }
}
if($("btnShare")) $("btnShare").onclick=function(){
  copyTo(myLink(), this.querySelector("span"), "saveCopied", "saveCopy");
  TRK("partage");
};
if($("btnShareNative") && navigator.share){
  $("btnShareNative").hidden=false;
  $("btnShareNative").onclick=function(){
    TRK("partage");
    try{ navigator.share({ title:tx("heroTitle"), text:tx("saveTitle"), url:myLink() }); }catch(e){}
  };
}
if($("recapRedo")) $("recapRedo").onclick=function(){ reset(); };


/* ============================================================
   ALERTES DE DIMENSIONS — le client doit voir tout de suite
   si ça n'entre pas, ou si l'abri déborde de son entrée.
   ============================================================ */
function sizeAlerts(){
  var box=$("sizeAlerts"); if(!box || !R) return;
  var L=lang==="fr", out=[];
  var BAD='<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5h.01"/></svg>';
  var WRN='<svg viewBox="0 0 24 24"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/></svg>';
  var OK ='<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';
  function add2(kind, ic, txt, fix){
    out.push('<div class="talert '+kind+'">'+ic+'<div>'+txt+
             (fix?'<span class="fix">'+esc(fix)+'</span>':'')+'</div></div>');
  }

  /* --- les véhicules entrent-ils ? --- */
  var f = viz && viz.vehFit;
  if(f && f.n){
    var manqueL = f.need - f.have, manqueW = f.needW - f.haveW;
    if(manqueL > 0.01){
      add2("bad", BAD,
        "<b>"+(L?"Trop court pour vos véhicules.":"Too short for your vehicles.")+"</b> "+
        (L? ("Il faut "+ftIn(f.need)+" de longueur et l'abri en fait "+ftIn(f.have)+" : il manque <b>"+ftIn(manqueL)+"</b>.")
          : ("You need "+ftIn(f.need)+" of length and the shelter is "+ftIn(f.have)+" — you're <b>"+ftIn(manqueL)+"</b> short.")),
        L?"Allongez l'abri dans le panneau 3D, ou retirez un véhicule."
         :"Lengthen the shelter in the 3D panel, or remove a vehicle.");
    }
    if(manqueW > 0.01){
      add2("bad", BAD,
        "<b>"+(L?"Trop étroit pour vos véhicules.":"Too narrow for your vehicles.")+"</b> "+
        (L? ("Côte à côte, ils demandent "+ftIn(f.needW)+" et l'abri en fait "+ftIn(f.haveW)+".")
          : ("Side by side they need "+ftIn(f.needW)+" and the shelter is "+ftIn(f.haveW)+".")),
        L?"Passez à un modèle plus large, ou placez-les l'un derrière l'autre."
         :"Move up to a wider model, or park them one behind the other.");
    }
    if(manqueL<=0.01 && manqueW<=0.01){
      var margeL=f.have-f.need;
      if(margeL < 2.5){
        add2("warn", WRN,
          "<b>"+(L?"Ça entre, mais c'est juste.":"It fits, but only just.")+"</b> "+
          (L? ("Il ne reste que "+ftIn(margeL)+" de dégagement en longueur.")
            : ("That leaves only "+ftIn(margeL)+" of extra length.")),
          L?"Une taille de plus vous laisserait ouvrir le hayon à l'intérieur."
           :"One size up would let you open the tailgate inside.");
      } else
      add2("ok", OK,
        "<b>"+(L?"Vos véhicules entrent.":"Your vehicles fit.")+"</b> "+
        (L? (f.rows>1 ? ("Placés "+f.cols+" de front sur "+f.rows+" rangées, avec "+ftIn(margeL)+" de dégagement en longueur.")
                      : ("Il reste "+ftIn(margeL)+" de dégagement en longueur."))
          : (f.rows>1 ? (f.cols+" across in "+f.rows+" rows, with "+ftIn(margeL)+" of length to spare.")
                      : (ftIn(margeL)+" of length to spare."))));
    }
  }

  /* --- la hauteur libre suffit-elle, accessoire de toit compris ? --- */
  if(R.kind==="auto" && R.veh){
    var add=D.ROOF_ADD[A.toit||"rien"]||0;
    var hmax=0, HS={berline:4+7/12, vus:5+7/12, camion:6+5/12};
    if(VZ && VZ.veh){ for(var k in VZ.veh) if(VZ.veh[k]) hmax=Math.max(hmax, HS[k]||0); }
    if(!hmax) hmax=R.veh.h;
    var besoin=hmax+add+0.25;
    if(besoin > R.h+0.02){
      add2("bad", BAD,
        "<b>"+(L?"Pas assez haut.":"Not tall enough.")+"</b> "+
        (L? ("Il faut "+ftIn(besoin)+" sous la barre de porte"+(add?" (accessoire de toit compris)":"")+
             " et vous avez "+ftIn(R.h)+".")
          : ("You need "+ftIn(besoin)+" under the door bar"+(add?" (including your roof accessory)":"")+
             " and you have "+ftIn(R.h)+".")),
        L?"Montez d'un cran dans « Hauteur libre », sous la 3D."
         :"Move up one step under \"Clearance height\", below the 3D view.");
    }
  }

  /* --- l'abri entre-t-il sur l'entrée déclarée ? --- */
  if(VZ && VZ.drW && VZ.drL){
    var depW=R.w-VZ.drW, depL=R.len-VZ.drL;
    if(depW > 0.01){
      add2("bad", BAD,
        "<b>"+(L?"Plus large que votre entrée.":"Wider than your driveway.")+"</b> "+
        (L? ("L'abri fait "+ftIn(R.w)+" et vous avez déclaré "+ftIn(VZ.drW)+" : il dépasse de <b>"+ftIn(depW/2)+" de chaque côté</b>.")
          : ("The shelter is "+ftIn(R.w)+" and you declared "+ftIn(VZ.drW)+": it overhangs <b>"+ftIn(depW/2)+" on each side</b>.")),
        L?"Vérifiez que vous avez le droit d'empiéter sur le gazon ou chez le voisin."
         :"Make sure you're allowed to extend onto the lawn or your neighbour's property.");
    }
    if(depL > 0.01){
      add2("bad", BAD,
        "<b>"+(L?"Plus long que votre entrée.":"Longer than your driveway.")+"</b> "+
        (L? ("L'abri fait "+ftIn(R.len)+" pour "+ftIn(VZ.drL)+" déclarés : il déborde de <b>"+ftIn(depL)+"</b>.")
          : ("The shelter is "+ftIn(R.len)+" and you declared "+ftIn(VZ.drL)+" — it's <b>"+ftIn(depL)+"</b> too long.")),
        L?"Raccourcissez-le dans le panneau 3D, ou mesurez de nouveau."
         :"Shorten it in the 3D panel, or measure again.");
    }
    if(depW<=0.01 && depL<=0.01){
      var side=(VZ.drW-R.w)/2;
      if(side < 1.5){
        add2("warn", WRN,
          "<b>"+(L?"Très juste sur les côtés.":"Very tight on the sides.")+"</b> "+
          (L? ("Il reste "+ftIn(side)+" entre l'abri et le bord de votre entrée.")
            : (ftIn(side)+" remains between the shelter and the edge of your driveway.")),
          L?"Prévoyez 4 pi de chaque côté pour déneiger le toit sans marcher chez le voisin."
           :"Allow 4 ft on each side to clear snow off the roof without stepping onto your neighbour's property.");
      }
    }
  }
  box.innerHTML = out.join("");
}

/* ============================================================
   VISUALISEUR
   ============================================================ */
function initViz(){
  if(!viz){
    viz=new Viz($("viz"), $("vizStage"));
    viz.onInteract=function(){ if(!seen){ seen=true; $("vizHint").classList.add("gone"); } };
    viz.onView=function(){ $("vizTop").setAttribute("aria-pressed","false"); };
    $("vizVeh").onclick=function(){ viz.showVeh=!viz.showVeh; this.setAttribute("aria-pressed",viz.showVeh); viz.draw(); };
    $("vizTop").onclick=function(){ var on=this.getAttribute("aria-pressed")!=="true"; this.setAttribute("aria-pressed",on); viz.setTop(on); };
    $("vizReset").onclick=function(){ $("vizTop").setAttribute("aria-pressed","false"); viz.reset(); };
    window.addEventListener("resize", function(){ if(viz&&viz.scene){ viz.resize(); viz.draw(); } });
  }
  buildControls();
  syncViz(true);
}
/* ---------- état des commandes propres à la 3D ---------- */
var VZ = null;
function vzInit(){
  if(VZ) return VZ;
  VZ = { front:true, back:true, sideOpen:true, tarp:true, dims:false,
         soil:null, drW:null, drL:null, veh:null };
  return VZ;
}
var VMAP = { voiture:"berline", vus:"vus", camionnette:"camion",
             fourgonnette:"vus", fourgon_haut:"camion" };
var VMAP2 = { "2voitures":["berline","berline"], mixte:["berline","vus"],
              "2vus":["vus","vus"], "2gros":["camion","camion"] };
/* Pourquoi ce modèle-là n'accepte pas de porte de côté en libre-service. */
function sideNoWhy(m, len, L){
  if(m.id==="double_rond") return L
    ? "On ne recommande pas de porte de côté sur le double Rond : sa toile est soudée et l'arche s'enroule jusqu'au sol. Parlez-en à un conseiller si vous y tenez."
    : "We don't recommend a side door on the double Round: its cover is welded and the arch curves right down to the ground. Talk to an advisor if you really want one.";
  if(m.id==="utilitaire") return L
    ? "L'utilitaire 8' x 10' n'a pas de section du milieu : ses arches sont aux 5 pi, donc les deux sections sont des sections de bout. Pas de porte de côté sur ce modèle."
    : "The 8' x 10' utility shelter has no middle section: its arches are 5 ft apart, so both sections are end sections. No side door on this model.";
  return L
    ? "Sur cette longueur, l'abri n'a que deux sections — toutes deux des sections de bout. Une porte de côté devrait être cousue sur mesure à l'atelier de Laval : c'est faisable, mais ça passe par un conseiller et des frais de couture s'appliquent."
    : "At this length the shelter has only two sections — both end sections. A side door would have to be custom-sewn at our Laval workshop: it's possible, but it goes through an advisor and sewing charges apply.";
}
function vzDefaults(){
  vzInit();
  if(VZ.soil===null) VZ.soil = A.sol || "asphalte";
  if(VZ.drW===null)  VZ.drW  = A.entreeW || Math.max(Math.round(R.w)+6, 20);
  if(VZ.drL===null)  VZ.drL  = A.entreeL || Math.max(Math.round(R.len)+4, 24);
  if(VZ.veh===null){
    VZ.veh = {berline:0, vus:0, camion:0};
    if(R.kind==="auto"){
      var ks = A.nb==="1" ? [VMAP[A.veh]||"vus"] : (VMAP2[A.veh2]||["vus","vus"]).slice();
      if(A.nb==="3grid") ks.push(ks[ks.length-1]);
      ks.forEach(function(k){ VZ.veh[k]++; });
    }
  }
  return VZ;
}
function vzCount(){ return VZ.veh.berline+VZ.veh.vus+VZ.veh.camion; }
function vzList(){
  var out=[];
  ["berline","vus","camion"].forEach(function(k){ if(VZ.veh[k]) out.push({type:k, n:VZ.veh[k]}); });
  return out;
}

/* ---------- petits composants ---------- */
function chips(el, opts, active, pick){
  el.innerHTML="";
  opts.forEach(function(o){
    var b=document.createElement("button");
    b.type="button"; b.textContent=o[1];
    b.setAttribute("aria-pressed", active(o[0]));
    b.onclick=function(){ pick(o[0]); };
    el.appendChild(b);
  });
}
function stepIdx(el, i, lo, hi, set, lab){
  if(!el) return;
  el.innerHTML="";
  lab = lab || (lang==="fr" ? ["Plus court","Plus long"] : ["Shorter","Longer"]);
  function mk(txt, d){
    var b=document.createElement("button");
    b.type="button"; b.textContent=txt;
    b.setAttribute("aria-label", d<0?lab[0]:lab[1]);
    if((d<0 && i<=lo) || (d>0 && i>=hi)) b.disabled=true;
    b.onclick=function(){ set(Math.min(hi, Math.max(lo, i+d))); };
    return b;
  }
  el.appendChild(mk("−",-1));
  var bar=document.createElement("div"); bar.className="bar";
  var f=document.createElement("i");
  f.style.width=(hi>lo ? Math.round((i-lo)/(hi-lo)*100) : 100)+"%";
  bar.appendChild(f); el.appendChild(bar);
  el.appendChild(mk("+",1));
}
function stepper(el, val, min, max, stp, set){
  el.innerHTML="";
  function mk(txt, d){
    var b=document.createElement("button");
    b.type="button"; b.textContent=txt;
    b.setAttribute("aria-label", (d<0?"−":"+")+" "+Math.abs(d));
    if((d<0 && val<=min) || (d>0 && val>=max)) b.disabled=true;
    b.onclick=function(){ set(Math.min(max, Math.max(min, val+d))); };
    return b;
  }
  el.appendChild(mk("−",-stp));
  var bar=document.createElement("div"); bar.className="bar";
  var i=document.createElement("i");
  i.style.width=Math.round((val-min)/(max-min)*100)+"%";
  bar.appendChild(i); el.appendChild(bar);
  el.appendChild(mk("+", stp));
}

function buildControls(){
  var m=R.model, L=lang==="fr", sl=$("slLength");
  vzDefaults();

  /* --- dimensions : la longueur se change au bouton, pas au curseur --- */
  var Ls = m.L, li = Math.max(0, Ls.indexOf(R.len));
  stepIdx($("stepLen"), li, 0, Ls.length-1, function(k){
    R.len = Ls[k];
    var hs2=E.heightsFor(m,R.w,R.len);
    if(hs2.indexOf(R.h)<0) R.h=hs2[hs2.length-1];
    E.recompute(R); ORDER=E.buildOrder(R,A);
    buildControls(); syncViz(); renderDims(); hydrateAndRender();
  });
  $("valLength").textContent = R.len+"' · "+D.metric(R.len);

  var hs=E.heightsFor(m,R.w,R.len);
  chips($("chipsHeight"), hs.map(function(h){ return [h, ftIn(h)]; }),
    function(h){ return Math.abs(h-R.h)<0.01; },
    function(h){ R.h=h; E.recompute(R); ORDER=E.buildOrder(R,A);
      buildControls(); syncViz(); renderDims(); hydrateAndRender(); });
  $("valHeight").textContent=ftIn(R.h);

  var wr=$("widthRow");
  if(m.w.length<2) wr.style.display="none";
  else{
    wr.style.display="";
    chips($("chipsWidth"), m.w.map(function(w){ return [w, ftIn(w)]; }),
      function(w){ return Math.abs(w-R.w)<0.01; },
      function(w){ R.w=w; R.rise=D.riseOf(m,w); E.recompute(R); ORDER=E.buildOrder(R,A);
        buildControls(); syncViz(true); renderDims(); hydrateAndRender(); });
    $("valWidth").textContent=ftIn(R.w)+" · "+D.metric(R.w);
  }

  /* --- portes de bout : les deux bouts s'ouvrent --- */
  var OO=[[true, L?"Ouverte":"Open"],[false, L?"Fermée":"Closed"]];
  chips($("chipsFront"), OO, function(v){ return VZ.front===v; },
        function(v){ VZ.front=v; syncViz(); buildControls(); });
  chips($("chipsBack"),  OO, function(v){ return VZ.back===v; },
        function(v){ VZ.back=v; syncViz(); buildControls(); });
  /* Porte de côté : on peut l'ajouter ici même si le client
     avait répondu « non » au questionnaire. */
  var noSide = !D.canSideDoor(R.model, R.len);
  $("sideNo").hidden = !noSide;
  $("chipsSideAdd").hidden = noSide;
  if(noSide){
    $("sideNo").textContent = sideNoWhy(R.model, R.len, L);
    $("valSideAdd").textContent="";
    if(A.pcote==="oui"){ A.pcote="non"; delete A.pcoteSide; delete A.pcoteSect; }
  }
  var SDO=[["non", L?"Aucune":"None"],["gauche", L?"À gauche":"Left"],["droite", L?"À droite":"Right"]];
  chips($("chipsSideAdd"), SDO,
    function(v){ return v==="non" ? A.pcote!=="oui" : (A.pcote==="oui" && A.pcoteSide===v); },
    function(v){
      if(v==="non"){ A.pcote="non"; delete A.pcoteSide; delete A.pcoteSect; }
      else {
        A.pcote="oui"; A.pcoteSide=v;
        if(A.pcoteSect!=="bout") A.pcoteSect="milieu";
        R.doorSide = (v==="droite"?1:-1);
      }
      E.recompute(R); ORDER=E.buildOrder(R,A);
      buildControls(); syncViz(); renderResult(); hydrateAndRender();
    });
  $("valSideAdd").textContent = A.pcote==="oui"
    ? (A.pcoteSect==="bout" ? (L?"1re ou dernière section":"first or last section") : "")
    : "";
  buildDoorCtl();

  /* --- terrain --- */
  var SOILS=[["asphalte",L?"Asphalte":"Asphalt"],["beton",L?"Béton":"Concrete"],
             ["pave",L?"Pavé uni":"Pavers"],["gazon",L?"Gazon":"Grass"],
             ["gravier",L?"Gravier":"Gravel"],["terre",L?"Terre":"Soil"]];
  chips($("chipsSoil"), SOILS, function(v){ return VZ.soil===v; }, function(v){
    VZ.soil=v;
    /* le sol pilote les ancrages : on met aussi la réponse à jour */
    A.sol = (v==="terre") ? "gazon" : v;
    R.soil = A.sol;
    E.recompute(R); ORDER=E.buildOrder(R,A);
    buildControls(); syncViz(); renderResult(); hydrateAndRender();
  });

  stepper($("stepDrW"), VZ.drW, 8, 60, 1, function(v){
    VZ.drW=v; A.entreeW=v; ORDER=E.buildOrder(R,A);
    buildControls(); syncViz(); renderResult(); hydrateAndRender();
  });
  stepper($("stepDrL"), VZ.drL, 8, 70, 1, function(v){
    VZ.drL=v; A.entreeL=v; ORDER=E.buildOrder(R,A);
    buildControls(); syncViz(); renderResult(); hydrateAndRender();
  });
  $("valDrW").textContent=ftIn(VZ.drW);
  $("valDrL").textContent=ftIn(VZ.drL);
  coverage();

  /* --- véhicules --- */
  vehRows();

  /* --- affichage --- */
  chips($("chipsSkin"), [[true, L?"Toile":"Cover"],[false, L?"Structure":"Frame"]],
    function(v){ return VZ.tarp===v; },
    function(v){ VZ.tarp=v; syncViz(); buildControls(); });
  chips($("chipsDims"), [[false, L?"Masquées":"Hidden"],[true, L?"Affichées":"Shown"]],
    function(v){ return VZ.dims===v; },
    function(v){ VZ.dims=v; syncViz(); buildControls(); });

  fitCheck();
  var p = E.fallbackPrice(R.sku);
  var sh = ORDER[0];
  if(sh && sh.price!==null && sh.price!==undefined) p = sh.price;
  $("mPrice").textContent = p===null||p===undefined ? tx("priceOnline") : money(p,lang);
  $("mPriceNote").textContent = p===null||p===undefined ? "" : tx("priceNote");
  $("mSku").textContent = (lang==="fr"?"Code : ":"Item code: ")+R.sku;
}

/* Ce que l'abri couvre réellement de l'entrée déclarée. */
function coverage(){
  var L=lang==="fr", box=$("covBox");
  if(!box) return;
  var cw=Math.min(R.w, VZ.drW), cl=Math.min(R.len, VZ.drL);
  var area=Math.round(cw*cl), tot=Math.max(1, VZ.drW*VZ.drL);
  var pct=Math.round(area/tot*100);
  var side=(VZ.drW-R.w)/2;
  var extra = side < 1.5
    ? (L?" Il reste moins de 1 pi 6 po de chaque côté : prévoyez de quoi déneiger le toit."
        :" Less than 1 ft 6 in remains on each side: plan how you will clear the roof.")
    : "";
  box.innerHTML = L
    ? ("<b>"+area+" pi² couverts</b> sur les "+Math.round(tot)+" pi² de votre entrée, soit "+pct+" %."+esc(extra))
    : ("<b>"+area+" of the "+Math.round(tot)+" sq ft</b> of your driveway covered — "+pct+"%."+esc(extra));
}

function vehRows(){
  var L=lang==="fr", box=$("vehRows");
  if(!box) return;
  box.innerHTML="";
  var SPEC = (window.TEMPO_VIZ && window.TEMPO_VIZ.VEHS) || null;
  [["berline", L?"Berline":"Sedan", "15'1\" x 5'11\" x 4'7\""],
   ["vus",     L?"VUS":"SUV",       "15'1\" x 6'1\" x 5'7\""],
   ["camion",  L?"Camionnette":"Pickup", "19'6\" x 6'8\" x 6'5\""]].forEach(function(v){
    var row=document.createElement("div"); row.className="tveh";
    row.innerHTML='<div class="nm"><b>'+esc(v[1])+'</b><small>'+esc(v[2])+'</small></div>';
    var st=document.createElement("div"); st.className="tstep";
    function mk(txt,d){
      var b=document.createElement("button"); b.type="button"; b.textContent=txt;
      var n=VZ.veh[v[0]];
      if((d<0&&n<=0)||(d>0&&(n>=6||vzCount()>=6))) b.disabled=true;
      b.onclick=function(){ VZ.veh[v[0]]=Math.max(0,Math.min(6,VZ.veh[v[0]]+d));
        buildControls(); syncViz(); };
      return b;
    }
    st.appendChild(mk("−",-1));
    var c=document.createElement("span"); c.className="cnt"; c.textContent=VZ.veh[v[0]];
    st.appendChild(c);
    st.appendChild(mk("+",1));
    row.appendChild(st);
    box.appendChild(row);
  });
}

/* Choix du côté et de la section de la porte, directement sur la 3D. */
function buildDoorCtl(){
  var row=$("sdRow");
  if(A.pcote!=="oui" || A.pcoteSect!=="milieu" || !D.canSideDoor(R.model,R.len)){ row.hidden=true; R.doorBay=0; return; }
  var nArch=Math.max(2, Math.round(R.len/R.model.arc)+1), nBay=nArch-1;
  if(nBay<3){ row.hidden=true; return; }
  row.hidden=false;
  var L=lang==="fr";
  if(!R.doorBay) R.doorBay=Math.floor(nBay/2);
  R.doorBay=Math.min(nBay-2, Math.max(1, R.doorBay));
  if(!R.doorSide) R.doorSide=(A.pcoteSide==="droite"?1:-1);

  /* Flèches, pas un curseur : le client saute d'une section à l'autre.
     Le numéro est celui vu de l'avant — 2, 3, 4… jamais une section de bout. */
  var no = nBay - R.doorBay;
  stepIdx($("stepDoorBay"), no, 2, nBay-1, function(k){
    R.doorBay = nBay - k;
    /* la section se retrouve sur la ligne d'article et sur le bon
       de commande imprimé : on les rafraîchit ensemble. */
    ORDER=E.buildOrder(R,A);
    buildDoorCtl(); syncViz(); renderOrder(); buildSummary();
  }, lang==="fr" ? ["Section précédente","Section suivante"] : ["Previous section","Next section"]);
  var from=(no-1)*R.model.arc, to=from+R.model.arc;
  $("valDoor").textContent=(L?"section ":"section ")+no+" · "+from+"–"+to+(L?" pi de l'avant":" ft from front");

  chips($("chipsSideOpen"), [[true,L?"Ouverte":"Open"],[false,L?"Fermée":"Closed"]],
    function(v){ return VZ.sideOpen===v; },
    function(v){ VZ.sideOpen=v; syncViz(); buildDoorCtl(); });
}

/* Section de la porte de côté : jamais une section de bout. */
function midBay(){
  var sec=E.doorSection(R);
  return sec ? sec.bay : 0;
}
function syncViz(refit){
  if(!viz) return;
  vzDefaults();
  viz.build({
    model:R.model, w:R.w, len:R.len, h:R.h, rise:D.riseOf(R.model,R.w),
    soil:VZ.soil, veh:(R.kind==="auto"?R.veh:null),
    vehicles:vzList(),
    drive:{ w:VZ.drW, l:VZ.drL },
    door:(A.pcote==="oui" && A.pcoteSect==="milieu"),
    doorSide:(R.doorSide||(A.pcoteSide==="droite"?1:-1)), doorBay:midBay(),
    sideOpen:VZ.sideOpen, frontOpen:VZ.front, backOpen:VZ.back,
    showTarp:VZ.tarp, showDims:VZ.dims,
    windows:D.windowsFor(R.model),
    ori:{ front:tx("oriFront"), back:tx("oriBack"), left:tx("oriLeft"), right:tx("oriRight") },
    tarpColor:R.model.welded?[248,249,246]:[251,251,248],
    labels:{ w:ftIn(R.w), l:R.len+"'", h:ftIn(R.h) },
    lang:lang
  });
  viz.resize();
  if(refit) viz.dist=viz._fit();
  viz.draw();
  lenCheck();
  sizeAlerts();
}

/* Longueur requise par les véhicules placés en enfilade. */
function lenCheck(){
  var box=$("fitLen"); if(!box) return;
  var L=lang==="fr";
  var f = viz && viz.vehFit;
  if(!f){ box.style.display="none"; return; }
  box.style.display="";
  var ok='<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';
  var no='<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>';
  if(f.wide){
    box.className="tfit ok";
    box.innerHTML=ok+"<span>"+(L?"Placés côte à côte, ils entrent dans la largeur.":"Side by side, they fit the width.")+"</span>";
    return;
  }
  box.className = f.ok ? "tfit ok" : "tfit no";
  box.innerHTML = (f.ok?ok:no)+"<span>"+
    (L? ("Longueur requise "+ftIn(f.need)+" · abri "+ftIn(f.have)+".")
      : ("Length needed "+ftIn(f.need)+" · shelter "+ftIn(f.have)+"."))+
    (f.ok ? "" : (L?" Allongez l'abri ou retirez un véhicule.":" Lengthen the shelter or remove a vehicle."))+"</span>";
}

function fitCheck(){
  var box=$("fitBox");
  if(box) box.style.display="none";   /* remplacé par les alertes de dimensions */
}

/* ============================================================
   AMORÇAGE
   ============================================================ */
$("btnStart").onclick=function(){ A={lang:lang}; path=[]; VZ=null; step(); };
$("btnRestart").onclick=reset;
$("advBack").onclick=function(){
  /* « Trois de front » : on ramène le client sur la question plutôt que
     de tout lui faire recommencer — l'autre réponse se configure ici. */
  if(A.nb==="3large"){ delete A.nb; step(); return; }
  reset();
};
function reset(){
  A={lang:lang}; path=[]; R=null; ORDER=[]; cur=null; editing=false; VZ=null; progress(0);
  try{ if(history.replaceState && location.hash) history.replaceState(null,"",location.href.split("#")[0]); }catch(e){}
  show("scrIntro");
}

/* ============================================================
   REPRISE — le lien contient la configuration au complet
   ============================================================ */
function restore(st){
  if(!st || !st.a || !st.a.usage) return false;
  A = st.a; path = [];
  R = E.recommend(A);
  if(st.m && M[st.m]) R.model = M[st.m];
  if(st.w) R.w = st.w;
  if(st.l) R.len = st.l;
  if(st.h) R.h = st.h;
  R.rise = D.riseOf(R.model, R.w);
  E.recompute(R);
  if(st.db) R.doorBay = st.db;
  if(st.ds) R.doorSide = st.ds;
  ORDER = E.buildOrder(R, A);
  var byKey = {};
  ORDER.forEach(function(l){ byKey[l.key]=l; });
  (st.off||[]).forEach(function(k){ if(byKey[k] && !byKey[k].locked){ byKey[k].checked=false; E.applyDeps(ORDER,k,false); } });
  (st.on ||[]).forEach(function(k){ if(byKey[k] && !byKey[k].locked){ byKey[k].checked=true;  E.applyDeps(ORDER,k,true);  } });
  window.TEMPO_R=R; window.TEMPO_ORDER=ORDER;
  progress(100);
  renderResult();
  show("scrResult");
  setTimeout(initViz, 60);
  hydrateAndRender();
  return true;
}
$("langFR").onclick=function(){ if(lang!=="fr"){ lang="fr"; applyLang(); if(R&&viz) syncViz(); } };
$("langEN").onclick=function(){ if(lang!=="en"){ lang="en"; applyLang(); if(R&&viz) syncViz(); } };
if(!String.prototype.padEnd){
  String.prototype.padEnd=function(n,c){ var s=String(this); while(s.length<n) s+=c||" "; return s; };
}
if(!String.prototype.repeat){
  String.prototype.repeat=function(n){ var s=""; for(var i=0;i<n;i++) s+=String(this); return s; };
}
/* Onglets sous la 3D : un seul panneau à la fois, et la vue reste
   à l'écran pendant qu'on règle. Plus besoin de faire l'ascenseur. */
$$("#vizTabs button").forEach(function(b){
  b.onclick=function(){
    $$("#vizTabs button").forEach(function(o){
      o.setAttribute("aria-pressed", o===b ? "true" : "false");
      var pn=$(o.getAttribute("data-p"));
      if(pn) pn.hidden = (o!==b);
    });
    try{ if(viz){ viz.resize(); } }catch(e){}
    /* on amène le haut du panneau juste sous la 3D collée */
    try{
      var card=document.querySelector(".tviz-card");
      var pan =document.querySelector(".tviz-panel");
      if(card && pan){
        var cr=card.getBoundingClientRect(), pr=pan.getBoundingClientRect();
        if(pr.top < cr.bottom + 4){
          window.scrollTo({ top: window.pageYOffset + pr.top - cr.bottom - 10, behavior:"smooth" });
        }
      }
    }catch(e){}
  };
});

headerLogo(); logoLink();
window.TEMPO_REDRAW = function(){ if(viz && viz.scene) viz.draw(); };
applyLang();

/* Un lien partagé rouvre exactement l'écran que le client avait devant lui. */
try{
  var st0 = window.TEMPO_TRACK && window.TEMPO_TRACK.readUrlState();
  if(st0){
    if(st0.a && st0.a.lang){ lang = st0.a.lang==="en"?"en":"fr"; applyLang(); }
    if(!restore(st0)) reset();
    else TRK("reprise");
  }
}catch(e){ reset(); }

window.TEMPO_DBG = function(){ return E.cartUrl(ORDER); };
window.TEMPO_VIZ_INST = function(){ return viz; };
window.TEMPO_TEST = { get A(){return A;}, get R(){return R;}, get ORDER(){return ORDER;}, lang:function(l){ lang=l; applyLang(); } };
})();